
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4vCA9", function(module, exports) {

$parcel$export(module.exports, "SpanSkeleton", () => $a879f42abb981ca6$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $a879f42abb981ca6$export$8f31e4c4a37b8e9c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $a879f42abb981ca6$var$placeholderShimmer = null;
const $a879f42abb981ca6$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8590A2)"
    },
    gray: {
        animation: "var(--ds-skeleton, #091E420F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CCE0FF)"
    }
};
const $a879f42abb981ca6$var$spanSkeletonStyles = null;
const $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhk11bn",
    blue: "_bfhkavxe",
    darkGray: "_bfhk1v33"
};
const $a879f42abb981ca6$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $35pXk.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $a879f42abb981ca6$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$a879f42abb981ca6$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $35pXk.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $a879f42abb981ca6$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $a879f42abb981ca6$export$2e2bcd8739ae039 = $a879f42abb981ca6$export$8f31e4c4a37b8e9c;

});

parcelRegister("5Tie7", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $eeea3d3a1c12cf78$export$1ca0544321134ad6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $1KuCI = parcelRequire("1KuCI");

var $9snKo = parcelRequire("9snKo");
const $eeea3d3a1c12cf78$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1KuCI.CardLinkView), {
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9snKo.loadingPlaceholderClassName),
        placeholder: placeholder
    }, 'lazy-render-key');
};

});
parcelRegister("1KuCI", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $33c97c3cf1ea6f6c$export$ce508304ed2dd145);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ioVck = parcelRequire("ioVck");
class $33c97c3cf1ea6f6c$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ioVck.Frame), {
            withoutBackground: true,
            ...this.props,
            children: this.props.placeholder || this.props.link
        });
    }
}

});
parcelRegister("ioVck", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $0a9218124e4addff$export$b89a827e9254211a);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4gM1A = parcelRequire("4gM1A");

var $kMb0d = parcelRequire("kMb0d");
const $0a9218124e4addff$export$b89a827e9254211a = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
    const handleClick = (0, $gwFzn.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $gwFzn.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    const isAnchor = Boolean(link || onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = isAnchor ? (0, $kMb0d.WrapperAnchor) : (0, $kMb0d.WrapperSpan);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered,
        truncateInline: truncateInline,
        children: children
    });
});

});
parcelRegister("kMb0d", function(module, exports) {

$parcel$export(module.exports, "WrapperSpan", () => $f88a24196e637c23$export$8b5c95e985c4ec9a);
$parcel$export(module.exports, "WrapperAnchor", () => $f88a24196e637c23$export$6e4bde711df5c2ab);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $f88a24196e637c23$var$lineHeight = 22;
const $f88a24196e637c23$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ref: ref,
        ...props,
        className: (0, $35pXk.default)([
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz14q2 _1rkwglyw _4cvx15qp" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz14q2 _1rkwglyw _4cvx15qp",
            truncateInline && (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itzgxb _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6d15qp",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qs1s3c _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7zgxb _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv"
        ]),
        children: props.children
    });
});
const $f88a24196e637c23$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ truncateInline: truncateInline, withoutBackground: withoutBackground, isHovered: isHovered, isInteractive: isInteractive, isSelected: isSelected, href: href, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
        href: href,
        ref: ref,
        ...props,
        className: (0, $35pXk.default)([
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_1yt4x7n9 _2rkoiti9 _v56415x0 _1e0c1nu9 _16d9qvcn _syaz14q2 _1rkwglyw _4cvx15qp" : "_1yt4x7n9 _2rkoiti9 _v56415x0 _vwz4qslr _1e0c1nu9 _16d9qvcn _syaz14q2 _1rkwglyw _4cvx15qp",
            truncateInline && (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _1e0c1abx _1yyjkb7n _sudp1e54 _nr8z1o8l _1voyv77o _3kwxidpf _jqg5v77o _6vwiidpf",
            truncateInline && !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bto1l2s _1nmz9jpi _vwz4183y _1e0c1abx _1yyjkb7n _sudp1e54 _17bix7n9 _nr8z1o8l _102kqslr",
            withoutBackground ? "_19bvidpf _18u01i6y" : "_19itzgxb _bfhkhp5a _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _1nrm18uv _c2waglyw _1iohnqa1",
            isHovered && "_1h6d15qp",
            isHovered && !withoutBackground && "_4bfu18uv _1hmsglyw _ajmmnqa1",
            isSelected ? "_12ji1r31 _1qu2glyw _12y31o36 _80omtlke _16qs1s3c _uiztglyw _1a3b18uv _4fprglyw _5goinqa1 _9oik18uv _1bnxglyw _jf4cnqa1 _bfw7zgxb _1nrm18uv _c2waglyw _1iohnqa1" : "_uizt1kdv",
            isInteractive && "_nt751r31 _49pcglyw _1hvw1o36 _1372tlke _7ehi1s3c _1j5pglyw _1di6fg4m"
        ]),
        children: props.children
    });
});
const $f88a24196e637c23$var$baseWrapperStylesNew = null;
const $f88a24196e637c23$var$baseWrapperStylesOld = null; // if the parent instruct the wrapper to be interactive, and the wrapper is in focus, apply selectedStyles
const $f88a24196e637c23$var$interactiveStyles = null;
const $f88a24196e637c23$var$hoveredStyles = null;
const $f88a24196e637c23$var$hoveredWithBackgroundStyles = null;
const $f88a24196e637c23$var$withoutBackgroundStyles = null;
const $f88a24196e637c23$var$withBackgroundStyles = null;
const $f88a24196e637c23$var$truncateStylesNew = null;
const $f88a24196e637c23$var$truncateStylesOld = null;
const $f88a24196e637c23$var$notSelectedStyle = null;
const $f88a24196e637c23$var$selectedStyles = null;

});



parcelRegister("9snKo", function(module, exports) {

$parcel$export(module.exports, "loadingPlaceholderClassName", () => $20ef05bed4af1360$export$4b2b7d155f69aed4);
const $20ef05bed4af1360$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';

});


parcelRegister("hpUsb", function(module, exports) {

$parcel$export(module.exports, "Card", () => $b7b2971f0774cd45$export$60332b2344f7fe41);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");
var $hlhtG = parcelRequire("hlhtG");

var $ggbZE = parcelRequire("ggbZE");
var $1DWH0 = parcelRequire("1DWH0");

var $lgqac = parcelRequire("lgqac");

var $lODqX = parcelRequire("lODqX");
class $b7b2971f0774cd45$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).PureComponent {
    render() {
        const content = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lODqX.CardWithURLRenderer), {
            ...this.props
        });
        return this.props.intl ? content : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
            locale: "en",
            children: content
        });
    }
}
const $b7b2971f0774cd45$export$60332b2344f7fe41 = (0, $ggbZE.default)((0, $lgqac.context))((0, $1DWH0.default)()((0, $js7oX.default)($b7b2971f0774cd45$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("lODqX", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $494a9ab126f82b16$export$e00a7788e30dc998);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $RUXAI = parcelRequire("RUXAI");

var $9HkI0 = parcelRequire("9HkI0");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $bIll3 = parcelRequire("bIll3");

var $ivUmx = parcelRequire("ivUmx");

var $5MkWK = parcelRequire("5MkWK");

var $9E8aG = parcelRequire("9E8aG");

var $l6tPN = parcelRequire("l6tPN");

var $5Tie7 = parcelRequire("5Tie7");

const $494a9ab126f82b16$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(0, $ivUmx.importWithRetry)(()=>(parcelRequire("jxaPH"))));
function $494a9ab126f82b16$export$e00a7788e30dc998(props) {
    (0, $RUXAI.di)($494a9ab126f82b16$export$a7690c318cd6a95e);
    const [id] = (0, $gwFzn.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))());
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $l6tPN.clearMarks)(id);
            (0, $l6tPN.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt } = props;
    const isFlexibleUi = (0, $9E8aG.isFlexibleUiCard)(children, (0, $dh538.fg)('platform-linking-flexible-card-openness') ? ui : undefined);
    const analyticsContext = (0, $5MkWK.useSmartLinkAnalyticsContext)({
        display: isFlexibleUi ? 'flexible' : appearance,
        id: id,
        url: url ?? ''
    });
    const errorHandler = (0, $gwFzn.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') fireEvent('operational.smartLink.chunkLoadFailed', {
            ...analyticsContext?.attributes,
            display: appearance,
            error: error,
            errorInfo: errorInfo,
            definitionId: null
        });
        else if (error.name !== 'APIError') {
            (0, $bIll3.startUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $bIll3.failUfoExperience)('smart-link-rendered', id || 'NULL');
            (0, $bIll3.failUfoExperience)('smart-link-authenticated', id || 'NULL');
            fireEvent('ui.smartLink.renderFailed', {
                ...analyticsContext?.attributes,
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id ?? null,
                error: error,
                errorInfo: errorInfo
            });
        }
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analyticsContext?.attributes,
        appearance,
        fireEvent,
        id,
        isFlexibleUi,
        onError,
        url
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)(FallbackComponent, {});
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        placeholder: placeholder,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder,
        truncateInline: truncateInline,
        CompetitorPrompt: CompetitorPrompt
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5Tie7.LoadingCardLink), {
                ...cardWithUrlProps
            }),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($494a9ab126f82b16$export$a7690c318cd6a95e, {
                ...cardWithUrlProps,
                children: children
            })
        })
    });
}

});
parcelRegister("kKODE", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $5b5d947ab1fa491a$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::1f3587129789e7883af37adad3817cd2>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $1PKWZ = parcelRequire("1PKWZ");

var $cGziR = parcelRequire("cGziR");
const $5b5d947ab1fa491a$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $gwFzn.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $cGziR.default)(...params));
        event.fire((0, $1PKWZ.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("1PKWZ", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $6678419bc4dceb3a$export$3f072f06b90c3985);
const $6678419bc4dceb3a$export$3f072f06b90c3985 = 'media';

});

parcelRegister("cGziR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4575fec4bf8df71a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::eb8cd1263459fb798341024dc0c461ea>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $4575fec4bf8df71a$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $4575fec4bf8df71a$export$2e2bcd8739ae039 = $4575fec4bf8df71a$var$createEventPayload;

});


parcelRegister("bIll3", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $fe01df8db47f84d1$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $fe01df8db47f84d1$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $fe01df8db47f84d1$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $fe01df8db47f84d1$export$4084c0df4a03a6af);

var $9801n = parcelRequire("9801n");
var $iqaft = parcelRequire("iqaft");
const $fe01df8db47f84d1$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
};
const $fe01df8db47f84d1$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9801n.ConcurrentExperience)('smart-link-rendered', $fe01df8db47f84d1$var$renderExperience),
    'smart-link-authenticated': new (0, $9801n.ConcurrentExperience)('smart-link-authenticated', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9801n.ConcurrentExperience)('smart-link-action-invocation', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9801n.ConcurrentExperience)('smart-link-ai-summary', $fe01df8db47f84d1$var$aiExperience)
};
const $fe01df8db47f84d1$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $fe01df8db47f84d1$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("ivUmx", function(module, exports) {

$parcel$export(module.exports, "isSpecialEvent", () => $71dfdac77e49ff43$export$efca2c4705678489);
$parcel$export(module.exports, "isSpecialKey", () => $71dfdac77e49ff43$export$d8de0cd37d316fdf);
$parcel$export(module.exports, "isSpecialClick", () => $71dfdac77e49ff43$export$5b1771037ab7c451);
$parcel$export(module.exports, "getIconForFileType", () => $71dfdac77e49ff43$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $71dfdac77e49ff43$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $71dfdac77e49ff43$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $71dfdac77e49ff43$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $71dfdac77e49ff43$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $71dfdac77e49ff43$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $71dfdac77e49ff43$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $71dfdac77e49ff43$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $71dfdac77e49ff43$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $71dfdac77e49ff43$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $71dfdac77e49ff43$export$6a4545d6b336c401);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4wH3g = parcelRequire("4wH3g");

var $dh538 = parcelRequire("dh538");

var $j6S25 = parcelRequire("j6S25");

var $5TXU5 = parcelRequire("5TXU5");

var $f6wMd = parcelRequire("f6wMd");
const $71dfdac77e49ff43$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($71dfdac77e49ff43$export$e6c5ffa684aac4d7() || $71dfdac77e49ff43$export$d8de0cd37d316fdf(evt) || $71dfdac77e49ff43$export$5b1771037ab7c451(evt));
const $71dfdac77e49ff43$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $71dfdac77e49ff43$export$d8de0cd37d316fdf = (event)=>{
    return (0, $dh538.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $71dfdac77e49ff43$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $71dfdac77e49ff43$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $71dfdac77e49ff43$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "Zuvzb",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $71dfdac77e49ff43$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $71dfdac77e49ff43$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [label] = icon;
    return label;
};


























































































const $71dfdac77e49ff43$export$92d31eb5326761b6 = ()=>{
    return {
        [(0, $5TXU5.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9SMct")))
        },
        [(0, $5TXU5.IconType).Blog]: {
            default: ()=>Promise.resolve((parcelRequire("7r4Rz")))
        },
        [(0, $5TXU5.IconType).Audio]: {
            default: ()=>(parcelRequire("c7LVo"))
        },
        [(0, $5TXU5.IconType).Code]: {
            default: ()=>(parcelRequire("1QGGT"))
        },
        [(0, $5TXU5.IconType).File]: {
            default: ()=>(parcelRequire("1O2NA"))
        },
        [(0, $5TXU5.IconType).Folder]: {
            default: ()=>(parcelRequire("avEb3"))
        },
        [(0, $5TXU5.IconType).Generic]: {
            default: ()=>(parcelRequire("1O2NA"))
        },
        [(0, $5TXU5.IconType).Image]: {
            default: ()=>(parcelRequire("9aTCg"))
        },
        [(0, $5TXU5.IconType).Presentation]: {
            default: ()=>(parcelRequire("lU4hm"))
        },
        [(0, $5TXU5.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("gZITg"))
        },
        [(0, $5TXU5.IconType).Video]: {
            default: ()=>(parcelRequire("2h3ro"))
        },
        [(0, $5TXU5.IconType).Project]: {
            default: ()=>Promise.resolve((parcelRequire("fXYLR")))
        },
        [(0, $5TXU5.IconType).Template]: {
            default: ()=>Promise.resolve((parcelRequire("2YaGf")))
        },
        [(0, $5TXU5.IconType).Forbidden]: {
            default: ()=>(parcelRequire("ephUW"))
        },
        [(0, $5TXU5.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("8Q3VW")))
        },
        [(0, $5TXU5.IconType).Archive]: {
            default: ()=>(parcelRequire("icf9z")),
            large: ()=>(parcelRequire("a86hb"))
        },
        [(0, $5TXU5.IconType).Executable]: {
            default: ()=>(parcelRequire("kscP5")),
            large: ()=>(parcelRequire("hPBqs"))
        },
        [(0, $5TXU5.IconType).GIF]: {
            default: ()=>(parcelRequire("k5T7h")),
            large: ()=>(parcelRequire("hd3xq"))
        },
        [(0, $5TXU5.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("1qYnK")),
            large: ()=>(parcelRequire("3grNr"))
        },
        [(0, $5TXU5.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("f2prL")),
            large: ()=>(parcelRequire("kkK3B"))
        },
        [(0, $5TXU5.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("cfQQr")),
            large: ()=>(parcelRequire("ar2MQ"))
        },
        [(0, $5TXU5.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("25gta")),
            large: ()=>(parcelRequire("b4d77"))
        },
        [(0, $5TXU5.IconType).MSExcel]: {
            default: ()=>(parcelRequire("kEmyI")),
            large: ()=>(parcelRequire("gML09"))
        },
        [(0, $5TXU5.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("f8uMq")),
            large: ()=>(parcelRequire("3pfn4"))
        },
        [(0, $5TXU5.IconType).MSWord]: {
            default: ()=>(parcelRequire("dRwZ6")),
            large: ()=>(parcelRequire("ehMoK"))
        },
        [(0, $5TXU5.IconType).PDF]: {
            default: ()=>(parcelRequire("bb6Gy")),
            large: ()=>(parcelRequire("kc9hI"))
        },
        [(0, $5TXU5.IconType).Sketch]: {
            default: ()=>(parcelRequire("bYzU1")),
            large: ()=>(parcelRequire("9VPT7"))
        },
        // Bitbucket icons
        [(0, $5TXU5.IconType).Branch]: {
            default: ()=>Promise.resolve((parcelRequire("iNt9O"))),
            large: ()=>(parcelRequire("xuakz"))
        },
        [(0, $5TXU5.IconType).Commit]: {
            default: ()=>Promise.resolve((parcelRequire("g3kRp"))),
            large: ()=>(parcelRequire("3YSy7"))
        },
        [(0, $5TXU5.IconType).PullRequest]: {
            default: ()=>Promise.resolve((parcelRequire("48jO6"))),
            large: ()=>(parcelRequire("gSaEk"))
        },
        [(0, $5TXU5.IconType).Repo]: {
            default: ()=>Promise.resolve((parcelRequire("gP2jG"))),
            large: ()=>(parcelRequire("gRMiS"))
        },
        // Jira icons
        [(0, $5TXU5.IconType).Bug]: {
            default: ()=>Promise.resolve((parcelRequire("5pEhQ"))),
            large: ()=>(parcelRequire("8THg5"))
        },
        [(0, $5TXU5.IconType).Change]: {
            default: ()=>Promise.resolve((parcelRequire("gyMYQ"))),
            large: ()=>(parcelRequire("5yCxN"))
        },
        [(0, $5TXU5.IconType).Epic]: {
            default: ()=>Promise.resolve((parcelRequire("g30aC"))),
            large: ()=>(parcelRequire("hMeeW"))
        },
        [(0, $5TXU5.IconType).Incident]: {
            default: ()=>Promise.resolve((parcelRequire("ieNZ0"))),
            large: ()=>(parcelRequire("1hYpU"))
        },
        [(0, $5TXU5.IconType).Problem]: {
            default: ()=>Promise.resolve((parcelRequire("736YY"))),
            large: ()=>(parcelRequire("9g5ea"))
        },
        [(0, $5TXU5.IconType).ServiceRequest]: {
            default: ()=>Promise.resolve((parcelRequire("GLxTx"))),
            large: ()=>(parcelRequire("79LRY"))
        },
        [(0, $5TXU5.IconType).Story]: {
            default: ()=>Promise.resolve((parcelRequire("hrqJ0"))),
            large: ()=>(parcelRequire("gmJmy"))
        },
        [(0, $5TXU5.IconType).SubTask]: {
            default: ()=>Promise.resolve((parcelRequire("4V1hx"))),
            large: ()=>(parcelRequire("fJmRq"))
        },
        [(0, $5TXU5.IconType).Task]: {
            default: ()=>Promise.resolve((parcelRequire("9wTHj"))),
            large: ()=>(parcelRequire("48nZb"))
        },
        // Confluence icons
        [(0, $5TXU5.IconType).LiveDocument]: {
            default: ()=>Promise.resolve((parcelRequire("brDJd"))),
            large: ()=>Promise.resolve((parcelRequire("deok5")))
        },
        // Provider icons
        [(0, $5TXU5.IconType).Confluence]: {
            default: ()=>(parcelRequire("xyzgG")).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $5TXU5.IconType).Jira]: {
            default: ()=>(parcelRequire("7RecP")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Badge icons
        [(0, $5TXU5.IconType).Attachment]: {
            default: ()=>(parcelRequire("3Q8hh"))
        },
        [(0, $5TXU5.IconType).CheckItem]: {
            default: ()=>(parcelRequire("bUUUj"))
        },
        [(0, $5TXU5.IconType).Component]: {
            default: ()=>(parcelRequire("9f10t"))
        },
        [(0, $5TXU5.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("3gPdG")))
        },
        [(0, $5TXU5.IconType).View]: {
            default: ()=>(parcelRequire("bB7TU"))
        },
        [(0, $5TXU5.IconType).React]: {
            default: ()=>(parcelRequire("1krdI"))
        },
        [(0, $5TXU5.IconType).Vote]: {
            default: ()=>(parcelRequire("sJgoY"))
        },
        [(0, $5TXU5.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("gfVkp"))
        },
        [(0, $5TXU5.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("hgbfX"))
        },
        [(0, $5TXU5.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("d4dgh"))
        },
        [(0, $5TXU5.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("8gGKC"))
        },
        [(0, $5TXU5.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("eHEdz"))
        },
        [(0, $5TXU5.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("9B7dU"))
        },
        [(0, $5TXU5.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("dJ8xq"))
        },
        [(0, $5TXU5.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("8snbs"))
        },
        [(0, $5TXU5.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("h7AKi"))
        },
        [(0, $5TXU5.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("3FWbZ"))
        },
        [(0, $5TXU5.IconType).PriorityUndefined]: {
            default: ()=>(parcelRequire("8TPpZ"))
        },
        [(0, $5TXU5.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("e5ojs"))
        },
        [(0, $5TXU5.IconType).Subscriber]: {
            default: ()=>Promise.resolve((parcelRequire("7D93v")))
        },
        [(0, $5TXU5.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("aJUVI"))
        }
    };
};
const $71dfdac77e49ff43$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $f6wMd.default)(fileFormat);
    if (!iconDescriptor?.icon || !iconDescriptor.label) return null;
    const lazyIcons = $71dfdac77e49ff43$export$92d31eb5326761b6();
    return [
        iconDescriptor.label,
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $71dfdac77e49ff43$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $71dfdac77e49ff43$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $71dfdac77e49ff43$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $71dfdac77e49ff43$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $71dfdac77e49ff43$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $71dfdac77e49ff43$export$e772c8ff12451969(interval);
            return $71dfdac77e49ff43$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $71dfdac77e49ff43$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $71dfdac77e49ff43$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $71dfdac77e49ff43$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $j6S25.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $71dfdac77e49ff43$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $5TXU5.SmartLinkSize).Large,
        (0, $5TXU5.SmartLinkSize).XLarge
    ].includes(size);
const $71dfdac77e49ff43$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));

});
parcelRegister("5TXU5", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $d747218f543c7aaa$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $d747218f543c7aaa$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $d747218f543c7aaa$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $d747218f543c7aaa$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $d747218f543c7aaa$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $d747218f543c7aaa$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $d747218f543c7aaa$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $d747218f543c7aaa$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $d747218f543c7aaa$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $d747218f543c7aaa$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $d747218f543c7aaa$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $d747218f543c7aaa$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $d747218f543c7aaa$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $d747218f543c7aaa$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $d747218f543c7aaa$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $d747218f543c7aaa$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $d747218f543c7aaa$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $d747218f543c7aaa$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $d747218f543c7aaa$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $d747218f543c7aaa$export$6ca4ef8b3dc2c804);
const $d747218f543c7aaa$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $d747218f543c7aaa$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $d747218f543c7aaa$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $d747218f543c7aaa$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $d747218f543c7aaa$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $d747218f543c7aaa$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $d747218f543c7aaa$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $d747218f543c7aaa$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $d747218f543c7aaa$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $d747218f543c7aaa$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $d747218f543c7aaa$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $d747218f543c7aaa$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $d747218f543c7aaa$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $d747218f543c7aaa$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    return ElementName;
}({});
var $d747218f543c7aaa$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $d747218f543c7aaa$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $d747218f543c7aaa$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $d747218f543c7aaa$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $d747218f543c7aaa$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $d747218f543c7aaa$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("f6wMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8700f5e69c6738e7$export$2e2bcd8739ae039);

var $5TXU5 = parcelRequire("5TXU5");
const $8700f5e69c6738e7$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $5TXU5.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $5TXU5.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $5TXU5.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $5TXU5.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $5TXU5.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $5TXU5.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $5TXU5.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $5TXU5.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $5TXU5.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $5TXU5.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $5TXU5.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $5TXU5.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $5TXU5.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $5TXU5.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $5TXU5.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $5TXU5.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $5TXU5.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $5TXU5.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $5TXU5.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $5TXU5.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $5TXU5.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $5TXU5.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $8700f5e69c6738e7$export$2e2bcd8739ae039 = $8700f5e69c6738e7$var$extractFileFormatIcon;

});

parcelRegister("9SMct", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3c9171fc16956912$export$2e2bcd8739ae039);

var $5mB97 = parcelRequire("5mB97");

var $i9cac = parcelRequire("i9cac");

var $8jHAi = parcelRequire("8jHAi");

var $7CgcZ = parcelRequire("7CgcZ");
const $3c9171fc16956912$var$PageIconWithColor = (0, $7CgcZ.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), 'blueBold', (0, $7CgcZ.renderIconPerSize)((0, (/*@__PURE__*/$parcel$interopDefault($5mB97))), (0, (/*@__PURE__*/$parcel$interopDefault($i9cac)))));
$3c9171fc16956912$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $3c9171fc16956912$export$2e2bcd8739ae039 = $3c9171fc16956912$var$PageIconWithColor;

});
parcelRegister("7CgcZ", function(module, exports) {

$parcel$export(module.exports, "renderIconPerSize", () => $6846287c8ee6bf50$export$28dd5ad82647c000);
$parcel$export(module.exports, "renderIconTile", () => $6846287c8ee6bf50$export$87c3646d0e299cfe);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $5TXU5 = parcelRequire("5TXU5");

var $ivUmx = parcelRequire("ivUmx");
const $6846287c8ee6bf50$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return '24';
        default:
            return '16';
    }
};
const $6846287c8ee6bf50$export$28dd5ad82647c000 = (IconSmall, IconLarge)=>{
    return ({ size: size, ...props })=>{
        if ((0, $ivUmx.isIconSizeLarge)(size)) return /*#__PURE__*/ (0, $7UHDa.jsx)(IconLarge, {
            ...props
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)(IconSmall, {
            ...props
        });
    };
};
const $6846287c8ee6bf50$export$87c3646d0e299cfe = (Icon, appearance, LegacyIcon)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
            appearance: appearance,
            icon: Icon,
            size: $6846287c8ee6bf50$export$3acc3fb10995f020(size),
            ...props,
            LEGACY_fallbackComponent: LegacyIcon && /*#__PURE__*/ (0, $7UHDa.jsx)(LegacyIcon, {
                ...props,
                size: size
            })
        });
    };
};

});


parcelRegister("7r4Rz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a1b21c3b6fc75776$export$2e2bcd8739ae039);

var $hxQwS = parcelRequire("hxQwS");

var $bueVT = parcelRequire("bueVT");

var $7CgcZ = parcelRequire("7CgcZ");
const $a1b21c3b6fc75776$var$BlogIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $hxQwS.default), (0, $bueVT.default));
$a1b21c3b6fc75776$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $a1b21c3b6fc75776$export$2e2bcd8739ae039 = $a1b21c3b6fc75776$var$BlogIconWithColor;

});

parcelRegister("c7LVo", function(module, exports) {

let $8d3b5053fda0b8f9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8d3b5053fda0b8f9$var$load("8tqgK"),
    $8d3b5053fda0b8f9$var$load("fe4be"),
    $8d3b5053fda0b8f9$var$load("jDjSj"),
    $8d3b5053fda0b8f9$var$load("kO0mz")
]).then(()=>parcelRequire('kYM3c'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});



parcelRegister("1QGGT", function(module, exports) {

let $158bc343c58e339c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $158bc343c58e339c$var$load("ffEVr"),
    $158bc343c58e339c$var$load("kIjBt"),
    $158bc343c58e339c$var$load("3wmvj"),
    $158bc343c58e339c$var$load("gQLjx")
]).then(()=>parcelRequire('3OcEi'));

});

parcelRegister("1O2NA", function(module, exports) {

let $150ca1b9a934c53f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $150ca1b9a934c53f$var$load("fe4be"),
    $150ca1b9a934c53f$var$load("ffEVr"),
    $150ca1b9a934c53f$var$load("kDqHr")
]).then(()=>parcelRequire('9JsQ8'));

});

parcelRegister("avEb3", function(module, exports) {

let $7a6bf701f57ee729$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7a6bf701f57ee729$var$load("ffEVr"),
    $7a6bf701f57ee729$var$load("9LlD6"),
    $7a6bf701f57ee729$var$load("5i5pX")
]).then(()=>parcelRequire('ltRMD'));

});

parcelRegister("9aTCg", function(module, exports) {

let $6ae0307477264a9e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6ae0307477264a9e$var$load("fe4be"),
    $6ae0307477264a9e$var$load("ffEVr"),
    $6ae0307477264a9e$var$load("8059b"),
    $6ae0307477264a9e$var$load("eA5B3")
]).then(()=>parcelRequire('gcJKc'));

});

parcelRegister("lU4hm", function(module, exports) {

let $ff2225aaf542d98a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ff2225aaf542d98a$var$load("ffEVr"),
    $ff2225aaf542d98a$var$load("6ACCg"),
    $ff2225aaf542d98a$var$load("4HZlX")
]).then(()=>parcelRequire('1w5AW'));

});

parcelRegister("gZITg", function(module, exports) {

let $c5f52a2138e7a44b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c5f52a2138e7a44b$var$load("6ACCg"),
    $c5f52a2138e7a44b$var$load("ffEVr"),
    $c5f52a2138e7a44b$var$load("7jSfd")
]).then(()=>parcelRequire('h45kr'));

});

parcelRegister("2h3ro", function(module, exports) {

let $1a7fd693c6730615$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1a7fd693c6730615$var$load("fe4be"),
    $1a7fd693c6730615$var$load("hPalR"),
    $1a7fd693c6730615$var$load("ffEVr"),
    $1a7fd693c6730615$var$load("7AsyI")
]).then(()=>parcelRequire('480Js'));

});

parcelRegister("ephUW", function(module, exports) {

let $a7d14c86e1d9b34d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a7d14c86e1d9b34d$var$load("ffEVr"),
    $a7d14c86e1d9b34d$var$load("8LPnw")
]).then(()=>parcelRequire('bRfUA'));

});

parcelRegister("icf9z", function(module, exports) {

let $d3f51a1f2a77808c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d3f51a1f2a77808c$var$load("2fk6g").then(()=>parcelRequire('dlbUV'));

});

parcelRegister("a86hb", function(module, exports) {

let $75ff85078c2ed1ab$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $75ff85078c2ed1ab$var$load("dil5i").then(()=>parcelRequire('fX9Sa'));

});

parcelRegister("kscP5", function(module, exports) {

let $ee405e887cc23ac5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ee405e887cc23ac5$var$load("huUvS").then(()=>parcelRequire('2ixko'));

});

parcelRegister("hPBqs", function(module, exports) {

let $cfb43b137b722cb1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $cfb43b137b722cb1$var$load("P5iE2").then(()=>parcelRequire('4dLYc'));

});

parcelRegister("k5T7h", function(module, exports) {

let $ea0f074652d059fd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ea0f074652d059fd$var$load("1oiJ6").then(()=>parcelRequire('d5BUD'));

});

parcelRegister("hd3xq", function(module, exports) {

let $c876652aec92aae5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c876652aec92aae5$var$load("42vdC").then(()=>parcelRequire('b4DX7'));

});

parcelRegister("1qYnK", function(module, exports) {

let $10b70ec32af8c31d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $10b70ec32af8c31d$var$load("lxiFd").then(()=>parcelRequire('4rkAw'));

});

parcelRegister("3grNr", function(module, exports) {

let $26086d81f65006fd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $26086d81f65006fd$var$load("9Bu2S").then(()=>parcelRequire('5W6v1'));

});

parcelRegister("f2prL", function(module, exports) {

let $af2ac82573c25707$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $af2ac82573c25707$var$load("eDqo1").then(()=>parcelRequire('jDMpf'));

});

parcelRegister("kkK3B", function(module, exports) {

let $ecd966e3c0f21332$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ecd966e3c0f21332$var$load("8pE8S").then(()=>parcelRequire('av4P2'));

});

parcelRegister("cfQQr", function(module, exports) {

let $024d6ad95162d834$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $024d6ad95162d834$var$load("6HBYC").then(()=>parcelRequire('l59oX'));

});

parcelRegister("ar2MQ", function(module, exports) {

let $798e9664dc7355d0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $798e9664dc7355d0$var$load("ivQYH").then(()=>parcelRequire('giYeH'));

});

parcelRegister("25gta", function(module, exports) {

let $1848d2e79896f624$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $1848d2e79896f624$var$load("bYxCZ").then(()=>parcelRequire('jOGxt'));

});

parcelRegister("b4d77", function(module, exports) {

let $80ea3d90d6644a01$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $80ea3d90d6644a01$var$load("7a9CL").then(()=>parcelRequire('eWLPt'));

});

parcelRegister("kEmyI", function(module, exports) {

let $f0890ac8d853fa59$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f0890ac8d853fa59$var$load("eTBsW").then(()=>parcelRequire('d8Kpd'));

});

parcelRegister("gML09", function(module, exports) {

let $c3859685823f8ffc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c3859685823f8ffc$var$load("8mzoy").then(()=>parcelRequire('gH8Rx'));

});

parcelRegister("f8uMq", function(module, exports) {

let $b04f7aaa98b02b1b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b04f7aaa98b02b1b$var$load("020xd").then(()=>parcelRequire('hY1Uy'));

});

parcelRegister("3pfn4", function(module, exports) {

let $27afa140cf6d4ad7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $27afa140cf6d4ad7$var$load("bjzRn").then(()=>parcelRequire('dfQbH'));

});

parcelRegister("dRwZ6", function(module, exports) {

let $a179cfa5888e8e00$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a179cfa5888e8e00$var$load("ls0Um").then(()=>parcelRequire('90Icb'));

});

parcelRegister("ehMoK", function(module, exports) {

let $a6683214f49d09be$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a6683214f49d09be$var$load("fYi1a").then(()=>parcelRequire('lkBga'));

});

parcelRegister("bb6Gy", function(module, exports) {

let $8235e85ddce5d7b2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8235e85ddce5d7b2$var$load("eVYW1").then(()=>parcelRequire('11LZV'));

});

parcelRegister("kc9hI", function(module, exports) {

let $eb3c21678f401c25$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eb3c21678f401c25$var$load("fqrMn").then(()=>parcelRequire('lzyQK'));

});

parcelRegister("bYzU1", function(module, exports) {

let $8b8125d44d11cedd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $8b8125d44d11cedd$var$load("f35QR").then(()=>parcelRequire('9W0IA'));

});

parcelRegister("9VPT7", function(module, exports) {

let $73b1afc933b7f23e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $73b1afc933b7f23e$var$load("hzK1f").then(()=>parcelRequire('9AnKp'));

});

parcelRegister("xuakz", function(module, exports) {

let $064a7b7274c3d2b7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $064a7b7274c3d2b7$var$load("ffEVr"),
    $064a7b7274c3d2b7$var$load("4sSyn")
]).then(()=>parcelRequire('lU7yV'));

});

parcelRegister("3YSy7", function(module, exports) {

let $2e614a09d5ae46cf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2e614a09d5ae46cf$var$load("ffEVr"),
    $2e614a09d5ae46cf$var$load("dnrR3")
]).then(()=>parcelRequire('jB3l2'));

});

parcelRegister("gSaEk", function(module, exports) {

let $c489f33d6a792d48$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c489f33d6a792d48$var$load("ffEVr"),
    $c489f33d6a792d48$var$load("gxkp2")
]).then(()=>parcelRequire('8EuWv'));

});

parcelRegister("gRMiS", function(module, exports) {

let $c47710a4586457cc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c47710a4586457cc$var$load("ffEVr"),
    $c47710a4586457cc$var$load("hiqrg")
]).then(()=>parcelRequire('59qhj'));

});

parcelRegister("8THg5", function(module, exports) {

let $67a50402b31c2cbb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $67a50402b31c2cbb$var$load("ffEVr"),
    $67a50402b31c2cbb$var$load("490Jr")
]).then(()=>parcelRequire('go9q2'));

});

parcelRegister("5yCxN", function(module, exports) {

let $40be06cdc2e665fc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $40be06cdc2e665fc$var$load("ffEVr"),
    $40be06cdc2e665fc$var$load("ggkqU")
]).then(()=>parcelRequire('2hyOi'));

});

parcelRegister("hMeeW", function(module, exports) {

let $cf11f71d8071be05$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cf11f71d8071be05$var$load("ffEVr"),
    $cf11f71d8071be05$var$load("65smn")
]).then(()=>parcelRequire('7MtzJ'));

});

parcelRegister("1hYpU", function(module, exports) {

let $0f063e859a78f055$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0f063e859a78f055$var$load("ffEVr"),
    $0f063e859a78f055$var$load("1fh7t")
]).then(()=>parcelRequire('iyOJu'));

});

parcelRegister("9g5ea", function(module, exports) {

let $6bd9a9c1ed721510$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6bd9a9c1ed721510$var$load("ffEVr"),
    $6bd9a9c1ed721510$var$load("4mLGd")
]).then(()=>parcelRequire('75US5'));

});

parcelRegister("79LRY", function(module, exports) {

let $535e81955a488366$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $535e81955a488366$var$load("ffEVr"),
    $535e81955a488366$var$load("cMlHc")
]).then(()=>parcelRequire('2v58P'));

});

parcelRegister("gmJmy", function(module, exports) {

let $bea1e38148f8f13f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $bea1e38148f8f13f$var$load("ffEVr"),
    $bea1e38148f8f13f$var$load("lSzlP")
]).then(()=>parcelRequire('guaI6'));

});

parcelRegister("fJmRq", function(module, exports) {

let $b73cca9e8650c180$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b73cca9e8650c180$var$load("ffEVr"),
    $b73cca9e8650c180$var$load("5erPe")
]).then(()=>parcelRequire('ddr0p'));

});

parcelRegister("48nZb", function(module, exports) {

let $302a83df0652df90$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $302a83df0652df90$var$load("ffEVr"),
    $302a83df0652df90$var$load("cXodu")
]).then(()=>parcelRequire('aH2D0'));

});

parcelRegister("xyzgG", function(module, exports) {

let $064de5a28f67dee0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $064de5a28f67dee0$var$load("4j0Ap").then(()=>parcelRequire('4sZvs'));

});

parcelRegister("7RecP", function(module, exports) {

let $5b88809ec6ddda67$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5b88809ec6ddda67$var$load("87j6O").then(()=>parcelRequire('kAaAo'));

});

parcelRegister("3Q8hh", function(module, exports) {

let $2cbca62fb8c4827b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2cbca62fb8c4827b$var$load("8PsNg"),
    $2cbca62fb8c4827b$var$load("ffEVr"),
    $2cbca62fb8c4827b$var$load("3vYMs")
]).then(()=>parcelRequire('ekFKF'));

});

parcelRegister("bUUUj", function(module, exports) {

let $8ad11145acda6bad$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8ad11145acda6bad$var$load("d1W0Z"),
    $8ad11145acda6bad$var$load("ffEVr"),
    $8ad11145acda6bad$var$load("9UmxH")
]).then(()=>parcelRequire('jwRB3'));

});

parcelRegister("9f10t", function(module, exports) {

let $6ba64ba7b2761a01$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6ba64ba7b2761a01$var$load("jNyUd"),
    $6ba64ba7b2761a01$var$load("aQnhg"),
    $6ba64ba7b2761a01$var$load("hlgZa")
]).then(()=>parcelRequire('lAsab'));

});

parcelRegister("bB7TU", function(module, exports) {

let $8719475a5283a2c5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8719475a5283a2c5$var$load("8tqgK"),
    $8719475a5283a2c5$var$load("jaTPo"),
    $8719475a5283a2c5$var$load("jSJrn")
]).then(()=>parcelRequire('33aqb'));

});

parcelRegister("1krdI", function(module, exports) {

let $0f7cc60ecce622c5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0f7cc60ecce622c5$var$load("dkV2T"),
    $0f7cc60ecce622c5$var$load("ffEVr"),
    $0f7cc60ecce622c5$var$load("kgJcP")
]).then(()=>parcelRequire('4azDt'));

});

parcelRegister("sJgoY", function(module, exports) {

let $0565ba097f534163$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0565ba097f534163$var$load("ffEVr"),
    $0565ba097f534163$var$load("513ba")
]).then(()=>parcelRequire('5MyoV'));

});

parcelRegister("gfVkp", function(module, exports) {

let $bd5a8436c34d5e98$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $bd5a8436c34d5e98$var$load("kefuj").then(()=>parcelRequire('d92Sa'));

});

parcelRegister("hgbfX", function(module, exports) {

let $c90ca98fe3f4ead2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c90ca98fe3f4ead2$var$load("bWqqo").then(()=>parcelRequire('54WGm'));

});

parcelRegister("d4dgh", function(module, exports) {

let $9835ef9160e26f5d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9835ef9160e26f5d$var$load("9ZeC1").then(()=>parcelRequire('4Xn5l'));

});

parcelRegister("8gGKC", function(module, exports) {

let $6050fac73242c69b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6050fac73242c69b$var$load("9zpNb").then(()=>parcelRequire('3lNRx'));

});

parcelRegister("eHEdz", function(module, exports) {

let $ab444746a2840683$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ab444746a2840683$var$load("gOpe6").then(()=>parcelRequire('agboS'));

});

parcelRegister("9B7dU", function(module, exports) {

let $6fcd2c2c2361cf2c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6fcd2c2c2361cf2c$var$load("RAL03").then(()=>parcelRequire('6EZU4'));

});

parcelRegister("dJ8xq", function(module, exports) {

let $9fe619cc9522aab1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $9fe619cc9522aab1$var$load("5nQIT").then(()=>parcelRequire('6Ft10'));

});

parcelRegister("8snbs", function(module, exports) {

let $6282ec126a48e044$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $6282ec126a48e044$var$load("l9frT").then(()=>parcelRequire('ekSUX'));

});

parcelRegister("h7AKi", function(module, exports) {

let $c76f980be20ced01$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c76f980be20ced01$var$load("lACXG").then(()=>parcelRequire('k3QR4'));

});

parcelRegister("3FWbZ", function(module, exports) {

let $2ad2573b4aebc3d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2ad2573b4aebc3d3$var$load("ao5oO").then(()=>parcelRequire('dATVH'));

});

parcelRegister("8TPpZ", function(module, exports) {

let $67ab585a6a4351d4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $67ab585a6a4351d4$var$load("eWzXf"),
    $67ab585a6a4351d4$var$load("ffEVr"),
    $67ab585a6a4351d4$var$load("7owaE")
]).then(()=>parcelRequire('dTP2L'));

});

parcelRegister("e5ojs", function(module, exports) {

let $a41464557d2b808c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a41464557d2b808c$var$load("9DPul"),
    $a41464557d2b808c$var$load("ffEVr"),
    $a41464557d2b808c$var$load("9PQvE")
]).then(()=>parcelRequire('4rZmd'));

});

parcelRegister("aJUVI", function(module, exports) {

let $7d1a446f165d3b77$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7d1a446f165d3b77$var$load("hl2oi"),
    $7d1a446f165d3b77$var$load("ffEVr"),
    $7d1a446f165d3b77$var$load("9dfxa")
]).then(()=>parcelRequire('cOAGo'));

});


parcelRegister("5MkWK", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $9dd53b67e285af98$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $9dd53b67e285af98$export$eaff10f7ec59c455);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $bYRk6 = parcelRequire("bYRk6");

var $1xKpK = parcelRequire("1xKpK");

var $eIleF = parcelRequire("eIleF");

var $6q0AE = parcelRequire("6q0AE");

var $dh538 = parcelRequire("dh538");

var $lz9QA = parcelRequire("lz9QA");

var $lgqac = parcelRequire("lgqac");
const $9dd53b67e285af98$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $1xKpK.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $9dd53b67e285af98$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $lgqac.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $9dd53b67e285af98$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const state = store ? (0, $6q0AE.getUrl)(store, url) : undefined;
    return (0, $gwFzn.useMemo)(()=>{
        return $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $9dd53b67e285af98$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $lz9QA.useSmartCardState)(url);
    const data = $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bYRk6.default), {
        data: data,
        children: children
    });
};

});
parcelRegister("lz9QA", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $206782ec364200b6$export$b0444d00ba7313c6);

var $bxoVL = parcelRequire("bxoVL");

var $eIleF = parcelRequire("eIleF");
const $206782ec364200b6$var$PENDING_STATE = {
    status: 'pending'
};
function $206782ec364200b6$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const cardState = (0, $bxoVL.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $206782ec364200b6$var$PENDING_STATE;
}

});


parcelRegister("9E8aG", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $c224b37846f1c464$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $c224b37846f1c464$export$df0092b19156b140);
$parcel$export(module.exports, "isStyleCacheProvider", () => $c224b37846f1c464$export$14ff825bfe645006);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $c224b37846f1c464$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $c224b37846f1c464$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $c224b37846f1c464$export$c0547b4405cae584);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $hkQwp = parcelRequire("hkQwp");
var $5znEc = parcelRequire("5znEc");
var $Y5kOr = parcelRequire("Y5kOr");
var $8NpDA = parcelRequire("8NpDA");

var $2gWqY = parcelRequire("2gWqY");
const $c224b37846f1c464$export$3c94e0f4719f5c2a = (children, ui)=>{
    if ((0, $dh538.fg)('platform-linking-flexible-card-openness')) {
        if (ui?.removeBlockRestriction) return children && (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children)?.length > 0 ? true : false;
    }
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children).some((child)=>$c224b37846f1c464$export$df0092b19156b140(child))) return true;
    return false;
};
const $c224b37846f1c464$export$14ff825bfe645006 = (node)=>{
    if (typeof node.type !== 'string' && node.type?.name === 'StyleCacheProvider' && node.props.children) return true;
    else if (typeof node.type !== 'string' && node.type?.name === 'CC' && node.props.children) return true;
    return false;
};
const $c224b37846f1c464$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return false;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($hkQwp).some((type)=>type === node.type)) return true;
    return false;
};
const $c224b37846f1c464$export$d7fc505bb0bd5756 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return false;
    if (Object.values($2gWqY).some((type)=>type === node.type)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$d7fc505bb0bd5756(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$df0092b19156b140 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return false;
    if (node.type === (0, $5znEc.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$df0092b19156b140(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return false;
    if (node.type === (0, $Y5kOr.default)) return true;
    if ($c224b37846f1c464$export$14ff825bfe645006(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $c224b37846f1c464$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};
const $c224b37846f1c464$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node) && node.type === (0, $8NpDA.default);

});
parcelRegister("hkQwp", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("8NpDA")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("1lLfV")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("Y5kOr")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("8zS2j")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("5znEc")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("2R1C4")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("jsdg1")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("eqpYq")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("MlN47")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("f0wtW")).default);

var $8NpDA = parcelRequire("8NpDA");

var $1lLfV = parcelRequire("1lLfV");

var $Y5kOr = parcelRequire("Y5kOr");

var $8zS2j = parcelRequire("8zS2j");

var $5znEc = parcelRequire("5znEc");

var $2R1C4 = parcelRequire("2R1C4");

var $jsdg1 = parcelRequire("jsdg1");

var $eqpYq = parcelRequire("eqpYq");

var $MlN47 = parcelRequire("MlN47");

var $f0wtW = parcelRequire("f0wtW");

});
parcelRegister("8NpDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $64d13bf310395f75$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $jsdg1 = parcelRequire("jsdg1");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $64d13bf310395f75$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    const cardContext = (0, $dh538.fg)('platform-linking-flexible-card-context') ? (0, $fUfR2.useFlexibleCardContext)() : undefined;
    if ((0, $dh538.fg)('platform-linking-flexible-card-context')) {
        if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !alwaysShow) return null;
    } else {
        if (status !== (0, $5TXU5.SmartLinkStatus).Resolved && !alwaysShow) return null;
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jsdg1.default), {
        ...props,
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? {
            size: props.size ?? cardContext?.ui?.size
        } : undefined,
        testId: testId
    });
};
var $64d13bf310395f75$export$2e2bcd8739ae039 = $64d13bf310395f75$var$FooterBlock;

});
parcelRegister("fUfR2", function(module, exports) {

$parcel$export(module.exports, "FlexibleCardContext", () => $6e7308c6380408ec$export$13dde4423ab71d62);
$parcel$export(module.exports, "useFlexibleCardContext", () => $6e7308c6380408ec$export$a8c4167e4e9f26ab);
$parcel$export(module.exports, "FlexibleUiContext", () => $6e7308c6380408ec$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $6e7308c6380408ec$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $6e7308c6380408ec$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $6e7308c6380408ec$export$e6b5ad18b56e8f51);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");
const $6e7308c6380408ec$export$13dde4423ab71d62 = (0, $gwFzn.createContext)(undefined);
const $6e7308c6380408ec$export$a8c4167e4e9f26ab = ()=>(0, $gwFzn.useContext)($6e7308c6380408ec$export$13dde4423ab71d62);
const $6e7308c6380408ec$export$ca70b164b615de47 = (0, $gwFzn.createContext)(undefined);
const $6e7308c6380408ec$export$61d7957a243df7aa = ()=>(0, $dh538.fg)('platform-linking-flexible-card-context') ? $6e7308c6380408ec$export$a8c4167e4e9f26ab()?.data : (0, $gwFzn.useContext)($6e7308c6380408ec$export$ca70b164b615de47);
const $6e7308c6380408ec$export$f7433dbd6c50e26a = (0, $gwFzn.createContext)(undefined);
const $6e7308c6380408ec$export$e6b5ad18b56e8f51 = ()=>(0, $dh538.fg)('platform-linking-flexible-card-context') ? $6e7308c6380408ec$export$a8c4167e4e9f26ab()?.ui : (0, $gwFzn.useContext)($6e7308c6380408ec$export$f7433dbd6c50e26a);

});

parcelRegister("jsdg1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a88c936354623c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4P6U3 = parcelRequire("4P6U3");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $2ZgNz = parcelRequire("2ZgNz");

var $7d67T = parcelRequire("7d67T");

var $2R1C4 = parcelRequire("2R1C4");

var $1RvsP = parcelRequire("1RvsP");

var $l7DP7 = parcelRequire("l7DP7");
const $a5a88c936354623c$var$actionGroupStylesOld = null;
const $a5a88c936354623c$var$actionGroupStyles = null;
const $a5a88c936354623c$var$safariStyles = null;
const $a5a88c936354623c$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $5TXU5.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const hasActions = (0, $gwFzn.useMemo)(()=>(0, $l7DP7.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const { safari: safari = false } = (0, $dh538.fg)('platform-linking-visual-refresh-v2') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gwFzn.useMemo)(()=>(0, $4P6U3.browser)(), []) : {};
    const onDropdownOpenChange = (0, $gwFzn.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            !hideProvider && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ZgNz.default), {
                ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actions && hasActions ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                testId: "smart-element-group-actions",
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                width: (0, $5TXU5.SmartLinkWidth).Flexible,
                className: (0, $35pXk.default)([
                    size === (0, $5TXU5.SmartLinkSize).XLarge && (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_c71lxy5q",
                    size === (0, $5TXU5.SmartLinkSize).XLarge && !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_c71lviql",
                    safari && "_4t3i1osq"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7d67T.default), {
                    onDropdownOpenChange: onDropdownOpenChange,
                    items: actions,
                    appearance: "default",
                    size: size
                })
            }) : null
        ]
    });
};
var $a5a88c936354623c$export$2e2bcd8739ae039 = $a5a88c936354623c$var$FooterBlockResolvedView;

});
parcelRegister("2ZgNz", function(module, exports) {

$parcel$export(module.exports, "default", () => $33250de89c37863a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $33250de89c37863a$var$ProviderElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.provider ?? null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Provider
    }) : null;
};
var $33250de89c37863a$export$2e2bcd8739ae039 = $33250de89c37863a$var$ProviderElement;

});
parcelRegister("9AUBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $951dc084d4c33fc9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toBadgeProps", () => $951dc084d4c33fc9$export$a2fb457791942ba4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $aK0ya = parcelRequire("aK0ya");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $iFRRf = parcelRequire("iFRRf");

var $kUxzQ = parcelRequire("kUxzQ");

var $1iDg7 = parcelRequire("1iDg7");

var $hJgLA = parcelRequire("hJgLA");
const $951dc084d4c33fc9$var$styles = {
    container: "_zulp1b66 _1e0c116y _4cvr1h6o _1ul91ns9",
    icon: "_1e0c116y _v4pn116y _1b94116y _1ii7116y _4t3i7vkz _bna77vkz _1xjx7vkz _17527vkz _ca0qze3t _14bqze3t _1oh2ze3t _i2i3ze3t _u5f3ze3t _3tceze3t _99ztze3t _uhasze3t _n3tdze3t _1ym6ze3t _1m2uze3t _5jw9ze3t _19bvze3t _1xr1ze3t _9n9oze3t _7wy9ze3t _1bsb7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _s7n4nkob _rtqbnkob _e4kmnkob _z239nkob",
    text: "_11c81o8v"
};
const $951dc084d4c33fc9$var$colorMap = {
    subtle: "_syaz131l",
    default: "_syaz1gjq"
};
const $951dc084d4c33fc9$var$badgeStyles = null;
const $951dc084d4c33fc9$var$iconStyles = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $951dc084d4c33fc9$var$labelStylesOld = null;
const $951dc084d4c33fc9$var$messageMapper = {
    [(0, $5TXU5.IconType).PriorityBlocker]: (0, $afp1H.messages).priority_blocker,
    [(0, $5TXU5.IconType).PriorityCritical]: (0, $afp1H.messages).priority_critical,
    [(0, $5TXU5.IconType).PriorityHigh]: (0, $afp1H.messages).priority_high,
    [(0, $5TXU5.IconType).PriorityHighest]: (0, $afp1H.messages).priority_highest,
    [(0, $5TXU5.IconType).PriorityLow]: (0, $afp1H.messages).priority_low,
    [(0, $5TXU5.IconType).PriorityLowest]: (0, $afp1H.messages).priority_lowest,
    [(0, $5TXU5.IconType).PriorityMajor]: (0, $afp1H.messages).priority_major,
    [(0, $5TXU5.IconType).PriorityMedium]: (0, $afp1H.messages).priority_medium,
    [(0, $5TXU5.IconType).PriorityMinor]: (0, $afp1H.messages).priority_minor,
    [(0, $5TXU5.IconType).PriorityTrivial]: (0, $afp1H.messages).priority_trivial,
    [(0, $5TXU5.IconType).PriorityUndefined]: (0, $afp1H.messages).priority_undefined
};
const $951dc084d4c33fc9$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $951dc084d4c33fc9$var$messageMapper[icon];
        if (descriptor) return (0, $hJgLA.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $951dc084d4c33fc9$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iFRRf.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $951dc084d4c33fc9$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUxzQ.default), {
        testId: testId,
        url: url
    });
};
const $951dc084d4c33fc9$var$BaseBadgeRefreshNew = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ appearance: appearance = 'default', hideIcon: hideIcon = false, icon: icon, label: label, name: name, testId: testId = 'smart-element-badge', url: url, color: color }, ref)=>{
    const formattedMessageOrLabel = $951dc084d4c33fc9$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $951dc084d4c33fc9$var$renderAtlaskitIcon(icon, testId) || $951dc084d4c33fc9$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        ref: ref,
        style: {
            color: color && (0, $dh538.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        className: (0, $35pXk.default)([
            $951dc084d4c33fc9$var$styles.container,
            $951dc084d4c33fc9$var$colorMap[appearance]
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                as: "span",
                xcss: $951dc084d4c33fc9$var$styles.icon,
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                as: "span",
                testId: `${testId}-label`,
                xcss: $951dc084d4c33fc9$var$styles.text,
                children: formattedMessageOrLabel
            })
        ]
    });
}); // On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(BaseBadgeElement);
const $951dc084d4c33fc9$var$BaseBadgeElementRefreshNewWithOverrideCss = (0, $1iDg7.withOverrideCss)($951dc084d4c33fc9$var$BaseBadgeRefreshNew); /**
                                                                                         * A base element that displays some text with an associated icon.
                                                                                         * @internal
                                                                                         * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
                                                                                         * @see CommentCount
                                                                                         * @see ViewCount
                                                                                         * @see ReactCount
                                                                                         * @see VoteCount
                                                                                         * @see SubscriberCount
                                                                                         * @see Priority
                                                                                         * @see ProgrammingLanguage
                                                                                         * @see Provider
                                                                                         */ 
const $951dc084d4c33fc9$var$BaseBadgeElementCompiledNew = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, className: className, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $951dc084d4c33fc9$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $951dc084d4c33fc9$var$renderAtlaskitIcon(icon, testId) || $951dc084d4c33fc9$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                className: (0, $35pXk.default)([
                    "_16jlidpf _1o9zidpf _i0dl1wug _syaz1oju _vwz4idpf _s7n4nkob _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v _1jtnidpf _13t3idpf _rm9uidpf _rtqbnkob _e4kmnkob _z239nkob"
                ]),
                children: badgeIcon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                "data-testid": `${testId}-label`,
                className: (0, $35pXk.default)([
                    "_11c8dcr7 _syaz131l _19bvv77o _s7n4nkob"
                ]),
                children: formattedMessageOrLabel
            })
        ]
    });
};
var $951dc084d4c33fc9$export$2e2bcd8739ae039 = (0, $aK0ya.withFeatureFlaggedComponent)($951dc084d4c33fc9$var$BaseBadgeElementCompiledNew, $951dc084d4c33fc9$var$BaseBadgeElementRefreshNewWithOverrideCss, ()=>(0, $dh538.fg)('platform-linking-visual-refresh-v1'));
const $951dc084d4c33fc9$export$a2fb457791942ba4 = (label)=>{
    // Don't render the element if its 0
    return label !== '0' && label ? {
        label: label
    } : undefined;
};

});
parcelRegister("aK0ya", function(module, exports) {

$parcel$export(module.exports, "withFeatureFlaggedComponent", () => $d4453426be730a87$export$55dba0d8ccf3da86);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $d4453426be730a87$export$55dba0d8ccf3da86 = (ComponentOld, ComponentNext, featureFlagFn)=>{
    return (props)=>{
        // copied from packages/editor/editor-common/src/utils/withFeatureFlaggedComponent.tsx
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return featureFlagFn() ? /*#__PURE__*/ (0, $7UHDa.jsx)(ComponentNext, {
            ...props
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)(ComponentOld, {
            ...props
        });
    };
};

});

parcelRegister("iFRRf", function(module, exports) {

$parcel$export(module.exports, "default", () => $536366acab81aece$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4wH3g = parcelRequire("4wH3g");

var $lAFHW = parcelRequire("lAFHW");

var $7r4Rz = parcelRequire("7r4Rz");

var $GFtWS = parcelRequire("GFtWS");

var $9SMct = parcelRequire("9SMct");

var $5TXU5 = parcelRequire("5TXU5");

var $ivUmx = parcelRequire("ivUmx");
const $536366acab81aece$var$getIconImportFn = (icon, size)=>{
    const item = (0, $ivUmx.getLazyIcons)()[icon];
    if ((0, $ivUmx.isIconSizeLarge)(size) && item?.large) return item.large;
    return item?.default;
};
const $536366acab81aece$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "rynap",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $536366acab81aece$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId, size: size = (0, $5TXU5.SmartLinkSize).Medium })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $5TXU5.IconType).Document:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9SMct.default), {
                label: label ?? 'document',
                testId: testId,
                size: size
            });
        case (0, $5TXU5.IconType).Blog:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7r4Rz.default), {
                label: label ?? 'blog',
                testId: testId,
                size: size
            });
        case (0, $5TXU5.IconType).LiveDocument:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $GFtWS.default), {
                label: label ?? 'live-doc',
                testId: testId,
                size: size
            });
    }
    const importFn = $536366acab81aece$var$getIconImportFn(icon, size);
    if (!importFn) return null;
    const ImportedIcon = $536366acab81aece$var$importIcon(importFn);
    switch(icon){
        case (0, $5TXU5.IconType).Confluence:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lAFHW.ConfluenceIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5TXU5.IconType).Jira:
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                testId: testId,
                size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'small' : 'xxsmall'
            });
        case (0, $5TXU5.IconType).Error:
        case (0, $5TXU5.IconType).Forbidden:
            return /*#__PURE__*/ (0, $7UHDa.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'medium' : 'small',
                color: "var(--ds-icon-danger, #C9372C)"
            });
        default:
            return /*#__PURE__*/ (0, $7UHDa.jsx)(ImportedIcon, {
                label: label,
                testId: testId,
                LEGACY_size: size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'medium' : 'small',
                size: size
            });
    }
};
var $536366acab81aece$export$2e2bcd8739ae039 = $536366acab81aece$var$AtlaskitIcon;

});
parcelRegister("GFtWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc75dd15b55d0661$export$2e2bcd8739ae039);

var $brDJd = parcelRequire("brDJd");

var $deok5 = parcelRequire("deok5");

var $7CgcZ = parcelRequire("7CgcZ");
const $fc75dd15b55d0661$var$LiveDocumentIconWithColor = (0, $7CgcZ.renderIconPerSize)((0, $brDJd.default), (0, $deok5.default));
$fc75dd15b55d0661$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $fc75dd15b55d0661$export$2e2bcd8739ae039 = $fc75dd15b55d0661$var$LiveDocumentIconWithColor;

});


parcelRegister("kUxzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4091fe284214d9a3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fp8VN = parcelRequire("fp8VN");

var $dh538 = parcelRequire("dh538");

var $hT8Jj = parcelRequire("hT8Jj");
const $4091fe284214d9a3$var$styles = {
    roundImg: "_2rko14q2"
};
const $4091fe284214d9a3$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $gwFzn.useState)(false); // If url changes, reset state
    (0, $gwFzn.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton && (0, $dh538.fg)('platform_fix_block_card_img_icon_vc')) return /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: "",
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $35pXk.default)([
            appearance === 'round' && (0, $dh538.fg)('platform-linking-visual-refresh-v2') && $4091fe284214d9a3$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fp8VN))), {
        src: url,
        loading: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hT8Jj.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: "",
            style: {
                width: width,
                height: height
            },
            className: (0, $35pXk.default)([
                appearance === 'round' && (0, $dh538.fg)('platform-linking-visual-refresh-v2') && $4091fe284214d9a3$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $4091fe284214d9a3$export$2e2bcd8739ae039 = $4091fe284214d9a3$var$ImageIcon;

});
parcelRegister("hT8Jj", function(module, exports) {

$parcel$export(module.exports, "LoadingSkeleton", () => $0ee6375a3337d738$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $0ee6375a3337d738$var$animationNameStyles = null;
const $0ee6375a3337d738$var$loadingSkeletonStyle = null;
const $0ee6375a3337d738$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $35pXk.default)([
            "_2rkoyh40 _uiztglyw _bfhkh3tw _1itk1qw5 _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("1iDg7", function(module, exports) {

$parcel$export(module.exports, "withOverrideCss", () => $8ddce3b50e63e6e3$export$e0bdcacb944f1da6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
function $8ddce3b50e63e6e3$export$e0bdcacb944f1da6(Component) {
    return (props)=>{
        const ref = (0, $gwFzn.useRef)(null);
        (0, $gwFzn.useEffect)(()=>{
            if (props?.className && ref.current) ref.current.className = `${ref.current.className} ${props.className}`;
        }, [
            props?.className
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
            ...props,
            ref: ref
        });
    };
}

});

parcelRegister("hJgLA", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $ecdac2a9be051ad6$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $ecdac2a9be051ad6$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $ecdac2a9be051ad6$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconWidth", () => $ecdac2a9be051ad6$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $ecdac2a9be051ad6$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getMaxLines", () => $ecdac2a9be051ad6$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $ecdac2a9be051ad6$export$475c391af8171fec);
$parcel$export(module.exports, "hasWhiteSpace", () => $ecdac2a9be051ad6$export$619e376a425cb759);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $4wH3g = parcelRequire("4wH3g");

var $5TXU5 = parcelRequire("5TXU5");
const $ecdac2a9be051ad6$export$9d642f65a919fb93 = {
    [(0, $5TXU5.SmartLinkSize).Small]: 'none',
    [(0, $5TXU5.SmartLinkSize).Medium]: 'compact',
    [(0, $5TXU5.SmartLinkSize).Large]: 'compact',
    [(0, $5TXU5.SmartLinkSize).XLarge]: 'default'
};
const $ecdac2a9be051ad6$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...descriptor,
            values: values
        });
    }
};
const $ecdac2a9be051ad6$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $ecdac2a9be051ad6$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-200, 16px)";
    }
};
const $ecdac2a9be051ad6$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "tmnOu",
        name: "importIcon",
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $ecdac2a9be051ad6$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1.75;
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $ecdac2a9be051ad6$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $ecdac2a9be051ad6$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $5TXU5.SmartLinkSize).Large:
            return 'space.200';
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $ecdac2a9be051ad6$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};

});



parcelRegister("7d67T", function(module, exports) {

$parcel$export(module.exports, "default", () => $56632f4bfc993cb1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");

var $RUXAI = parcelRequire("RUXAI");

var $hArLp = parcelRequire("hArLp");

var $eEA8O = parcelRequire("eEA8O");

var $52EPl = parcelRequire("52EPl");

var $8JHjV = parcelRequire("8JHjV");

var $dh538 = parcelRequire("dh538");

var $3gadb = parcelRequire("3gadb");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $hJgLA = parcelRequire("hJgLA");

var $l7DP7 = parcelRequire("l7DP7");

var $9CAD2 = parcelRequire("9CAD2");
const $56632f4bfc993cb1$var$stylesOld = null;
const $56632f4bfc993cb1$var$styles = null;
const $56632f4bfc993cb1$var$renderActionItems = (items = [], size = (0, $5TXU5.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $9CAD2.default), {
            item: item,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }, idx)); /**
                                                                                                                                                                                                                                                                                                                                                                                                            * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                                                                                                                                                                                                                                                                                                                                                                                                            * preferences.
                                                                                                                                                                                                                                                                                                                                                                                                            * @internal
                                                                                                                                                                                                                                                                                                                                                                                                            * @param {ActionGroupProps} ActionGroupProps
                                                                                                                                                                                                                                                                                                                                                                                                            * @see Action
                                                                                                                                                                                                                                                                                                                                                                                                            */ 
const $56632f4bfc993cb1$var$ActionGroup = ({ items: items = [], size: size = (0, $5TXU5.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $RUXAI.di)((0, $52EPl.default));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const renderableActionItems = (0, $gwFzn.useMemo)(()=>(0, $l7DP7.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $gwFzn.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $gwFzn.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $gwFzn.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $gwFzn.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $hJgLA.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8JHjV))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $afp1H.messages).more_actions
            });
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $52EPl.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })
                    }),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex,
                children: $56632f4bfc993cb1$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick)
            });
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41j6v _dzc21h6o _1ilq1i6y",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _dzc21h6o _1ilq1i6y",
            "actions-button-group"
        ]),
        "data-action-open": isOpen,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $hArLp.default), {
            children: [
                actionButtons,
                moreActionDropdown
            ]
        })
    }) : null;
};
var $56632f4bfc993cb1$export$2e2bcd8739ae039 = $56632f4bfc993cb1$var$ActionGroup;

});
parcelRegister("l7DP7", function(module, exports) {

$parcel$export(module.exports, "filterActionItems", () => $304e11160ef9ec7e$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $304e11160ef9ec7e$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $304e11160ef9ec7e$export$9678d3ca18bd7526);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $9E8aG = parcelRequire("9E8aG");

var $2gWqY = parcelRequire("2gWqY");

var $7d67T = parcelRequire("7d67T");

var $1RvsP = parcelRequire("1RvsP");
const $304e11160ef9ec7e$export$f942619ce67b1a41 = {
    [(0, $5TXU5.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).AppliedToComponentsCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Location]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Preview]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).Priority]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Provider]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Snippet]: [
        'block'
    ],
    [(0, $5TXU5.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).State]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).Title]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $5TXU5.ElementName).VoteCount]: [
        'inline'
    ]
};
const $304e11160ef9ec7e$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $5TXU5.SmartLinkSize).Large:
            return 1;
        case (0, $5TXU5.SmartLinkSize).Medium:
            return 0.5;
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $304e11160ef9ec7e$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node) && node.type === (0, $7d67T.default);
const $304e11160ef9ec7e$var$isElementDisplayValid = (name, display)=>{
    return $304e11160ef9ec7e$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $304e11160ef9ec7e$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $304e11160ef9ec7e$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node) && ((0, $9E8aG.isFlexibleUiElement)(node) || node.type === (0, $1RvsP.default));
const $304e11160ef9ec7e$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $5TXU5.ActionName).DeleteAction:
            case (0, $5TXU5.ActionName).EditAction:
            case (0, $5TXU5.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $5TXU5.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $304e11160ef9ec7e$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child)=>{
        if ($304e11160ef9ec7e$var$isElementOrElementGroup(child) || $304e11160ef9ec7e$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $304e11160ef9ec7e$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $2gWqY[name];
        const typedProps = props;
        if (Element && $304e11160ef9ec7e$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, $7UHDa.jsx)(Element, {
                ...typedProps
            }, idx);
            if (!$304e11160ef9ec7e$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("2gWqY", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => (parcelRequire("6cbph")).default);
$parcel$export(module.exports, "AssignedToGroup", () => (parcelRequire("4wLtQ")).default);
$parcel$export(module.exports, "AttachmentCount", () => (parcelRequire("iNImz")).default);
$parcel$export(module.exports, "AuthorGroup", () => (parcelRequire("LrBxG")).default);
$parcel$export(module.exports, "ChecklistProgress", () => (parcelRequire("bWsCB")).default);
$parcel$export(module.exports, "CollaboratorGroup", () => (parcelRequire("azCqP")).default);
$parcel$export(module.exports, "CommentCount", () => (parcelRequire("kexiH")).default);
$parcel$export(module.exports, "CreatedOn", () => (parcelRequire("e8W8a")).default);
$parcel$export(module.exports, "CreatedBy", () => (parcelRequire("3nul2")).default);
$parcel$export(module.exports, "DueOn", () => (parcelRequire("jKoRo")).default);
$parcel$export(module.exports, "LatestCommit", () => (parcelRequire("bmx11")).default);
$parcel$export(module.exports, "LinkIcon", () => (parcelRequire("jI5eg")).default);
$parcel$export(module.exports, "Location", () => (parcelRequire("8iOdP")).default);
$parcel$export(module.exports, "ModifiedBy", () => (parcelRequire("jW9GW")).default);
$parcel$export(module.exports, "ModifiedOn", () => (parcelRequire("1WqHG")).default);
$parcel$export(module.exports, "OwnedBy", () => (parcelRequire("ful5o")).default);
$parcel$export(module.exports, "OwnedByGroup", () => (parcelRequire("41AV3")).default);
$parcel$export(module.exports, "Preview", () => (parcelRequire("ikM9T")).default);
$parcel$export(module.exports, "Priority", () => (parcelRequire("8YJtM")).default);
$parcel$export(module.exports, "ProgrammingLanguage", () => (parcelRequire("6Ed8U")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("2ZgNz")).default);
$parcel$export(module.exports, "ReactCount", () => (parcelRequire("iuEuh")).default);
$parcel$export(module.exports, "ReadTime", () => (parcelRequire("2GDee")).default);
$parcel$export(module.exports, "SentOn", () => (parcelRequire("h2WFd")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("49WiA")).default);
$parcel$export(module.exports, "SourceBranch", () => (parcelRequire("aGsNO")).default);
$parcel$export(module.exports, "State", () => (parcelRequire("emfmd")).default);
$parcel$export(module.exports, "SubscriberCount", () => (parcelRequire("a0Yyn")).default);
$parcel$export(module.exports, "SubTasksProgress", () => (parcelRequire("b8mrt")).default);
$parcel$export(module.exports, "StoryPoints", () => (parcelRequire("jpKes")).default);
$parcel$export(module.exports, "TargetBranch", () => (parcelRequire("hIbqn")).default);
$parcel$export(module.exports, "Title", () => (parcelRequire("gHW9t")).default);
$parcel$export(module.exports, "ViewCount", () => (parcelRequire("zH0mb")).default);
$parcel$export(module.exports, "VoteCount", () => (parcelRequire("6LJqp")).default);
$parcel$export(module.exports, "AppliedToComponentsCount", () => (parcelRequire("e4NSt")).default);

var $6cbph = parcelRequire("6cbph");

var $4wLtQ = parcelRequire("4wLtQ");

var $iNImz = parcelRequire("iNImz");

var $LrBxG = parcelRequire("LrBxG");

var $bWsCB = parcelRequire("bWsCB");

var $azCqP = parcelRequire("azCqP");

var $kexiH = parcelRequire("kexiH");

var $e8W8a = parcelRequire("e8W8a");

var $3nul2 = parcelRequire("3nul2");

var $jKoRo = parcelRequire("jKoRo");

var $bmx11 = parcelRequire("bmx11");

var $jI5eg = parcelRequire("jI5eg");

var $8iOdP = parcelRequire("8iOdP");

var $jW9GW = parcelRequire("jW9GW");

var $1WqHG = parcelRequire("1WqHG");

var $ful5o = parcelRequire("ful5o");

var $41AV3 = parcelRequire("41AV3");

var $ikM9T = parcelRequire("ikM9T");

var $8YJtM = parcelRequire("8YJtM");

var $6Ed8U = parcelRequire("6Ed8U");

var $2ZgNz = parcelRequire("2ZgNz");

var $iuEuh = parcelRequire("iuEuh");

var $2GDee = parcelRequire("2GDee");

var $h2WFd = parcelRequire("h2WFd");

var $49WiA = parcelRequire("49WiA");

var $aGsNO = parcelRequire("aGsNO");

var $emfmd = parcelRequire("emfmd");

var $a0Yyn = parcelRequire("a0Yyn");

var $b8mrt = parcelRequire("b8mrt");

var $jpKes = parcelRequire("jpKes");

var $hIbqn = parcelRequire("hIbqn");

var $gHW9t = parcelRequire("gHW9t");

var $zH0mb = parcelRequire("zH0mb");

var $6LJqp = parcelRequire("6LJqp");

var $e4NSt = parcelRequire("e4NSt");

});
parcelRegister("6cbph", function(module, exports) {

$parcel$export(module.exports, "default", () => $05796b2533bfe14f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $aIzVM = parcelRequire("aIzVM");
const $05796b2533bfe14f$var$AssignedToElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).assigned_to, context.assignedTo) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AssignedTo
    }) : null;
};
var $05796b2533bfe14f$export$2e2bcd8739ae039 = $05796b2533bfe14f$var$AssignedToElement;

});
parcelRegister("aIzVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ecffae6e6a717dc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toFormattedTextProps", () => $1ecffae6e6a717dc$export$b9738bf28fb14829);
$parcel$export(module.exports, "toTextProps", () => $1ecffae6e6a717dc$export$f12aecc78be3c7bb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $dh538 = parcelRequire("dh538");

var $hJgLA = parcelRequire("hJgLA");
const $1ecffae6e6a717dc$var$baseStyleOld = null;
const $1ecffae6e6a717dc$var$baseStyle = null;
const $1ecffae6e6a717dc$export$79422073c7118b5b = ({ content: content, maxLines: maxLines = 1, message: message, name: name, className: className, testId: testId = 'smart-element-text', hideFormat: hideFormat = false, color: color })=>{
    if (!message && !content) return null;
    const dynamicCss = null;
    const newContent = hideFormat && content ? content : (0, $hJgLA.getFormattedMessage)(message) || content;
    const oldContent = (0, $hJgLA.getFormattedMessage)(message) || content;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _o5724jg8 _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _sudp1e54",
            "_1yyjr31u _102k1dud",
            className
        ]),
        style: {
            color: color && (0, $dh538.fg)('platform-linking-additional-flexible-element-props') ? color : undefined,
            "--_1erfju8": (0, $iAWao.default)(maxLines)
        },
        children: (0, $dh538.fg)('platform-linking-additional-flexible-element-props') ? newContent : oldContent
    });
};
var $1ecffae6e6a717dc$export$2e2bcd8739ae039 = $1ecffae6e6a717dc$export$79422073c7118b5b;
const $1ecffae6e6a717dc$export$b9738bf28fb14829 = (descriptor, context)=>{
    if ((0, $dh538.fg)('platform-linking-additional-flexible-element-props')) return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        },
        content: context
    } : undefined;
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $1ecffae6e6a717dc$export$f12aecc78be3c7bb = (content)=>{
    return content ? {
        content: content
    } : undefined;
};

});


parcelRegister("4wLtQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e65535d36ac745c6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9mMJ0 = parcelRequire("9mMJ0");
const $e65535d36ac745c6$var$AssignedToGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.assignedToGroup, true) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AssignedToGroup
    }) : null;
};
var $e65535d36ac745c6$export$2e2bcd8739ae039 = $e65535d36ac745c6$var$AssignedToGroupElement;

});
parcelRegister("9mMJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a89fd087e8e9b91$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAvatarGroupProps", () => $9a89fd087e8e9b91$export$91ba8651475968bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $2Pg7f = parcelRequire("2Pg7f");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $hJgLA = parcelRequire("hJgLA");
const $9a89fd087e8e9b91$var$styles = null;
const $9a89fd087e8e9b91$var$stylesMap = {
    xlarge: "_1e0c116y _1kvxu2gc _102oidpf",
    large: "_1e0c116y _1kvxu2gc _102oidpf",
    medium: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92",
    small: "_1e0c116y _1kvxu2gc _102oidpf _6fu61k92 _1rrq1k92 _udwj1k92 _10pr1k92"
};
const $9a89fd087e8e9b91$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $5TXU5.ElementName).AssignedToGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).assigned_to, personName);
        case (0, $5TXU5.ElementName).OwnedByGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).owned_by, personName);
        case (0, $5TXU5.ElementName).AuthorGroup:
            return (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).created_by, personName);
        default:
            return personName;
    }
};
const $9a89fd087e8e9b91$var$BaseAvatarGroup = ({ items: items = [], maxCount: maxCount = 4, name: name, className: className, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $dBxQj.default)();
    const data = (0, $gwFzn.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $5TXU5.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $hJgLA.getFormattedMessageAsString)(intl, (0, $afp1H.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
         //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $9a89fd087e8e9b91$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    , {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $9a89fd087e8e9b91$var$stylesMap[size],
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Pg7f.default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        })
    });
};
var $9a89fd087e8e9b91$export$2e2bcd8739ae039 = $9a89fd087e8e9b91$var$BaseAvatarGroup;
const $9a89fd087e8e9b91$export$91ba8651475968bd = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};

});


parcelRegister("iNImz", function(module, exports) {

$parcel$export(module.exports, "default", () => $68f91cb1c2b70cc7$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $68f91cb1c2b70cc7$var$AttachmentCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.attachmentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Attachment,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AttachmentCount
    }) : null;
};
var $68f91cb1c2b70cc7$export$2e2bcd8739ae039 = $68f91cb1c2b70cc7$var$AttachmentCountElement;

});

parcelRegister("LrBxG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5665fdfe0a3a6612$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9mMJ0 = parcelRequire("9mMJ0");
const $5665fdfe0a3a6612$var$AuthorGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.authorGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).AuthorGroup
    }) : null;
};
var $5665fdfe0a3a6612$export$2e2bcd8739ae039 = $5665fdfe0a3a6612$var$AuthorGroupElement;

});

parcelRegister("bWsCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9683283e28315c04$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $9683283e28315c04$var$ChecklistProgressElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.checklistProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).CheckItem,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ChecklistProgress
    }) : null;
};
var $9683283e28315c04$export$2e2bcd8739ae039 = $9683283e28315c04$var$ChecklistProgressElement;

});

parcelRegister("azCqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $853fada055614992$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9mMJ0 = parcelRequire("9mMJ0");
const $853fada055614992$var$CollaboratorGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.collaboratorGroup, false) : undefined;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CollaboratorGroup
    }) : null;
};
var $853fada055614992$export$2e2bcd8739ae039 = $853fada055614992$var$CollaboratorGroupElement;

});

parcelRegister("kexiH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c173ce05ce57544$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $0c173ce05ce57544$var$CommentCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.commentCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Comment,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CommentCount
    }) : null;
};
var $0c173ce05ce57544$export$2e2bcd8739ae039 = $0c173ce05ce57544$var$CommentCountElement;

});

parcelRegister("e8W8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $047203c23d0cd021$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $6wR2f = parcelRequire("6wR2f");
const $047203c23d0cd021$var$CreatedOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('created', context.createdOn) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6wR2f.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CreatedOn
    }) : null;
};
var $047203c23d0cd021$export$2e2bcd8739ae039 = $047203c23d0cd021$var$CreatedOnElement;

});
parcelRegister("6wR2f", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbe6fa3f8ea6e4e4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateTimeProps", () => $bbe6fa3f8ea6e4e4$export$2d4384e6b150cbe3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $67MrH = parcelRequire("67MrH");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $afp1H = parcelRequire("afp1H");
const $bbe6fa3f8ea6e4e4$var$stylesOld = null;
const $bbe6fa3f8ea6e4e4$var$styles = null;
const $bbe6fa3f8ea6e4e4$var$typeToDescriptorMap = {
    created: {
        relative: (0, $afp1H.messages).created_on_relative,
        absolute: (0, $afp1H.messages).created_on_absolute
    },
    modified: {
        relative: (0, $afp1H.messages).modified_on_relative,
        absolute: (0, $afp1H.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $afp1H.messages).sent_on_relative,
        absolute: (0, $afp1H.messages).sent_on_absolute
    }
};
const $bbe6fa3f8ea6e4e4$var$BaseDateTimeElement = ({ date: date, name: name, className: className, type: type, testId: testId = 'smart-element-date-time', text: text, hideDatePrefix: hideDatePrefix = false, color: color })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $dBxQj.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $67MrH.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    let content;
    if (hideDatePrefix && (0, $dh538.fg)('platform-linking-additional-flexible-element-props')) content = context;
    else if (text) content = `${text} ${context}`;
    else content = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...$bbe6fa3f8ea6e4e4$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        style: {
            color: color && (0, $dh538.fg)('platform-linking-additional-flexible-element-props') ? color : undefined
        },
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k1j6v",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _1reo15vq _18m915vq _syaz1gjq _1e0ccj1k _1ul9idpf _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _102k7vkz",
            className
        ]),
        children: content
    });
};
var $bbe6fa3f8ea6e4e4$export$2e2bcd8739ae039 = $bbe6fa3f8ea6e4e4$var$BaseDateTimeElement;
const $bbe6fa3f8ea6e4e4$export$2d4384e6b150cbe3 = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};

});
parcelRegister("67MrH", function(module, exports) {

$parcel$export(module.exports, "selectUnit", () => $4758f9d23d9a881e$export$b8f7189986dd5395);
var $4758f9d23d9a881e$var$__assign = undefined && undefined.__assign || function() {
    $4758f9d23d9a881e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4758f9d23d9a881e$var$__assign.apply(this, arguments);
};
var $4758f9d23d9a881e$var$MS_PER_SECOND = 1e3;
var $4758f9d23d9a881e$var$SECS_PER_MIN = 60;
var $4758f9d23d9a881e$var$SECS_PER_HOUR = $4758f9d23d9a881e$var$SECS_PER_MIN * 60;
var $4758f9d23d9a881e$var$SECS_PER_DAY = $4758f9d23d9a881e$var$SECS_PER_HOUR * 24;
var $4758f9d23d9a881e$var$SECS_PER_WEEK = $4758f9d23d9a881e$var$SECS_PER_DAY * 7;
function $4758f9d23d9a881e$export$b8f7189986dd5395(from, to, thresholds) {
    if (to === void 0) to = Date.now();
    if (thresholds === void 0) thresholds = {};
    var resolvedThresholds = $4758f9d23d9a881e$var$__assign($4758f9d23d9a881e$var$__assign({}, $4758f9d23d9a881e$export$f4fd60e41371f80d), thresholds || {});
    var secs = (+from - +to) / $4758f9d23d9a881e$var$MS_PER_SECOND;
    if (Math.abs(secs) < resolvedThresholds.second) return {
        value: Math.round(secs),
        unit: 'second'
    };
    var mins = secs / $4758f9d23d9a881e$var$SECS_PER_MIN;
    if (Math.abs(mins) < resolvedThresholds.minute) return {
        value: Math.round(mins),
        unit: 'minute'
    };
    var hours = secs / $4758f9d23d9a881e$var$SECS_PER_HOUR;
    if (Math.abs(hours) < resolvedThresholds.hour) return {
        value: Math.round(hours),
        unit: 'hour'
    };
    var days = secs / $4758f9d23d9a881e$var$SECS_PER_DAY;
    if (Math.abs(days) < resolvedThresholds.day) return {
        value: Math.round(days),
        unit: 'day'
    };
    var fromDate = new Date(from);
    var toDate = new Date(to);
    var years = fromDate.getFullYear() - toDate.getFullYear();
    if (Math.round(Math.abs(years)) > 0) return {
        value: Math.round(years),
        unit: 'year'
    };
    var months = years * 12 + fromDate.getMonth() - toDate.getMonth();
    if (Math.round(Math.abs(months)) > 0) return {
        value: Math.round(months),
        unit: 'month'
    };
    var weeks = secs / $4758f9d23d9a881e$var$SECS_PER_WEEK;
    return {
        value: Math.round(weeks),
        unit: 'week'
    };
}
var $4758f9d23d9a881e$export$f4fd60e41371f80d = {
    second: 45,
    minute: 45,
    hour: 22,
    day: 5
};

});



parcelRegister("3nul2", function(module, exports) {

$parcel$export(module.exports, "default", () => $916e74797092cad1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $aIzVM = parcelRequire("aIzVM");
const $916e74797092cad1$var$CreatedByElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).created_by, context.createdBy) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).CreatedBy
    }) : null;
};
var $916e74797092cad1$export$2e2bcd8739ae039 = $916e74797092cad1$var$CreatedByElement;

});

parcelRegister("jKoRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5c24538631868a6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $7f92O = parcelRequire("7f92O");
const $d5c24538631868a6$var$DueOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $7f92O.toDateLozengeProps)(context.dueOn) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7f92O.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).DueOn
    }) : null;
};
var $d5c24538631868a6$export$2e2bcd8739ae039 = $d5c24538631868a6$var$DueOnElement;

});
parcelRegister("7f92O", function(module, exports) {

$parcel$export(module.exports, "default", () => $7edf4af2ffda473e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toDateLozengeProps", () => $7edf4af2ffda473e$export$8f9f58f7bac50fbe);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");

var $5nBzc = parcelRequire("5nBzc");

var $dh538 = parcelRequire("dh538");

var $fUfR2 = parcelRequire("fUfR2");

var $cS65x = parcelRequire("cS65x");
const $7edf4af2ffda473e$var$stylesOld = null;
const $7edf4af2ffda473e$var$styles = null;
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {BaseLozengeElementProps} BaseLozengeElementProps - The props necessary for the Lozenge element.
 * @see State
 */ const $7edf4af2ffda473e$var$BaseLozengeElement = ({ action: action, appearance: appearance = 'default', name: name, className: className, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cS65x.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
        appearance: appearance,
        ...(0, $dh538.fg)('platform-component-visual-refresh') ? {
            isBold: true
        } : undefined,
        style: style,
        testId: `${testId}-lozenge`,
        children: text
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _vwz41kw7",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1e0c116y _1ul91ns9",
            className
        ]),
        children: lozenge
    });
};
var $7edf4af2ffda473e$export$2e2bcd8739ae039 = $7edf4af2ffda473e$var$BaseLozengeElement;
const $7edf4af2ffda473e$export$8f9f58f7bac50fbe = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2nPZH.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};

});
parcelRegister("cS65x", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fab12f071167d36$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $52EPl = parcelRequire("52EPl");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $eJ92v = parcelRequire("eJ92v");

var $g98dH = parcelRequire("g98dH");

var $8i8ID = parcelRequire("8i8ID");

var $7DSoa = parcelRequire("7DSoa");

var $cOlaT = parcelRequire("cOlaT");

var $lgqac = parcelRequire("lgqac");

var $b7GIg = parcelRequire("b7GIg");

var $667Mo = parcelRequire("667Mo");

var $7uUCV = parcelRequire("7uUCV");

var $bTJCs = parcelRequire("bTJCs");

var $58trk = parcelRequire("58trk");

var $dXPIV = parcelRequire("dXPIV");
const $7fab12f071167d36$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $7fab12f071167d36$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $gwFzn.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $gwFzn.useState)(false);
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [items, setItems] = (0, $gwFzn.useState)();
    const [errorMessage, setErrorMessage] = (0, $gwFzn.useState)();
    const reload = (0, $7DSoa.default)();
    const invoke = (0, $g98dH.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, invokePreviewAction: invokePreviewAction } = action?.update?.details || {};
    const handleOpenChange = (0, $gwFzn.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            fireEvent('ui.button.clicked.smartLinkStatusLozenge', {});
            fireEvent('track.smartLinkQuickAction.started', {
                smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $eJ92v.default));
                const validItems = typeof text === 'string' ? $7fab12f071167d36$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $bTJCs.LozengeActionErrorMessages).noDataIssueTermRefresh : (0, $bTJCs.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $bTJCs.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        invoke,
        isLoaded,
        text,
        fireEvent
    ]);
    const trigger = (0, $gwFzn.useCallback)((props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $dXPIV.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $gwFzn.useCallback)(async (id, text, appearance)=>{
        try {
            fireEvent('ui.button.clicked.smartLinkStatusListItem', {});
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $cOlaT.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: (0, $lgqac.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $8i8ID.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $bTJCs.LozengeActionErrorMessages).updateFailed);
                fireEvent('track.smartLinkQuickAction.failed', (0, $667Mo.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        invoke,
        linkId,
        reload,
        url,
        fireEvent
    ]);
    const dropdownItemGroup = (0, $gwFzn.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7uUCV.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            invokePreviewAction: invokePreviewAction
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $58trk.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        invokePreviewAction,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $52EPl.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex,
        children: dropdownItemGroup
    });
};
var $7fab12f071167d36$export$2e2bcd8739ae039 = (0, $b7GIg.default)($7fab12f071167d36$var$LozengeAction);

});
parcelRegister("eJ92v", function(module, exports) {

$parcel$export(module.exports, "default", () => $de46c47a4ecd1eb4$export$2e2bcd8739ae039);
const $de46c47a4ecd1eb4$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $de46c47a4ecd1eb4$export$2e2bcd8739ae039 = $de46c47a4ecd1eb4$var$extractLozengeActionItems;

});

parcelRegister("g98dH", function(module, exports) {

$parcel$export(module.exports, "default", () => $b01bbbcb1713fd75$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $htjmD = parcelRequire("htjmD");

var $eIleF = parcelRequire("eIleF");
const $b01bbbcb1713fd75$var$useInvoke = ()=>{
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const clientExt = (0, $htjmD.useSmartLinkClientExtension)(connections.client);
    return (0, $gwFzn.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $b01bbbcb1713fd75$export$2e2bcd8739ae039 = $b01bbbcb1713fd75$var$useInvoke;

});
parcelRegister("htjmD", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $6bb10922c4ae303f$export$303ede4eed148855);

var $gwFzn = parcelRequire("gwFzn");

var $gmi3X = parcelRequire("gmi3X");

var $4X6f2 = parcelRequire("4X6f2");

var $1Okf1 = parcelRequire("1Okf1");
const $6bb10922c4ae303f$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $1Okf1.useResolverUrl)(cardClient);
    const invoke = (0, $gwFzn.useCallback)(async (data)=>{
        try {
            return await (0, $gmi3X.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $4X6f2.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    return (0, $gwFzn.useMemo)(()=>({
            invoke: invoke
        }), [
        invoke
    ]);
};

});
parcelRegister("4X6f2", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $c5c90dd6b941df7e$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $c5c90dd6b941df7e$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $c5c90dd6b941df7e$export$6324b7946ad663e9 = /*#__PURE__*/ function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    return SmartLinkActionType;
}({});
class $c5c90dd6b941df7e$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = void 0;
        this.errorCode = errorCode;
    }
}

});



parcelRegister("8i8ID", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $e9aefac4b34acc2c$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $e9aefac4b34acc2c$export$1694272377fa07d8);

var $lgqac = parcelRequire("lgqac");
const $e9aefac4b34acc2c$export$65b3f792dff0bd60 = (err)=>{
    if (!$e9aefac4b34acc2c$export$1694272377fa07d8(err)) return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $lgqac.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $lgqac.TrackQuickActionFailureReason).UnknownError;
    }
};
const $e9aefac4b34acc2c$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("7DSoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe2ac6ef7785039$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $lyclm = parcelRequire("lyclm");

var $eIleF = parcelRequire("eIleF");

var $5TXU5 = parcelRequire("5TXU5");

var $bIll3 = parcelRequire("bIll3");

var $4IQbU = parcelRequire("4IQbU");
const $8fe2ac6ef7785039$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $4IQbU.default)();
    return (0, $gwFzn.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $lyclm.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $bIll3.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $8fe2ac6ef7785039$export$2e2bcd8739ae039 = $8fe2ac6ef7785039$var$useResolve;

});
parcelRegister("4IQbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $afe444b12e732e06$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $eIleF = parcelRequire("eIleF");

var $9gPkz = parcelRequire("9gPkz");
var $jHnts = parcelRequire("jHnts");
var $btw9C = parcelRequire("btw9C");

var $5TXU5 = parcelRequire("5TXU5");

var $4ibS1 = parcelRequire("4ibS1");

var $bKqKH = parcelRequire("bKqKH");
const $afe444b12e732e06$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $gwFzn.useCallback)((url, metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $gwFzn.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: url
        }, (0, $4ibS1.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $gwFzn.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $gwFzn.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $btw9C.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fallback', hostname, (0, $bKqKH.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fatal', hostname, (0, $bKqKH.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('error', hostname, (0, $bKqKH.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $4FhhO.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $gwFzn.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $afe444b12e732e06$export$2e2bcd8739ae039 = $afe444b12e732e06$var$useResponse;

});
parcelRegister("4ibS1", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $edbc823e59ec01a7$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $edbc823e59ec01a7$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $edbc823e59ec01a7$export$e32193033a594efb);
const $edbc823e59ec01a7$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $edbc823e59ec01a7$export$2796a804c6e44f63 = ()=>$edbc823e59ec01a7$var$emptyData;
const $edbc823e59ec01a7$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
const $edbc823e59ec01a7$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });

});

parcelRegister("bKqKH", function(module, exports) {

$parcel$export(module.exports, "ERROR_MESSAGE_OAUTH", () => $96d7cda9026a4858$export$3e81ce851ffda0ad);
$parcel$export(module.exports, "ERROR_MESSAGE_FATAL", () => $96d7cda9026a4858$export$45e7dda0d43d7f55);
$parcel$export(module.exports, "ERROR_MESSAGE_METADATA", () => $96d7cda9026a4858$export$338f7d9ccca1975d);
const $96d7cda9026a4858$export$297c39c8b9bfca0 = 'resolving';
const $96d7cda9026a4858$export$b64a888338c24e0e = 'errored';
const $96d7cda9026a4858$export$677b6edfa0002c70 = 'fallback';
const $96d7cda9026a4858$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $96d7cda9026a4858$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $96d7cda9026a4858$export$338f7d9ccca1975d = 'Error resolving metadata.';

});



parcelRegister("cOlaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa24a5eb3eb20317$export$2e2bcd8739ae039);
const $fa24a5eb3eb20317$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $fa24a5eb3eb20317$export$2e2bcd8739ae039 = $fa24a5eb3eb20317$var$createStatusUpdateRequest;

});

parcelRegister("b7GIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9e0a5eb52a0a8a6$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $5nBzc = parcelRequire("5nBzc");

var $dh538 = parcelRequire("dh538");
const $d9e0a5eb52a0a8a6$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $gwFzn.useMemo)(()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
                appearance: props?.appearance,
                ...(0, $dh538.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`,
                children: props?.text
            }), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
            fallback: fallback,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
                ...props
            })
        });
    };
var $d9e0a5eb52a0a8a6$export$2e2bcd8739ae039 = $d9e0a5eb52a0a8a6$var$withErrorBoundary;

});

parcelRegister("667Mo", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $e47eb447ef32ebf8$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $e47eb447ef32ebf8$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $e47eb447ef32ebf8$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $e47eb447ef32ebf8$export$618660b8f2aa87e2);
const $e47eb447ef32ebf8$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $e47eb447ef32ebf8$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $e47eb447ef32ebf8$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $e47eb447ef32ebf8$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("7uUCV", function(module, exports) {

$parcel$export(module.exports, "default", () => $86481dd22f22993b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $4jR19 = parcelRequire("4jR19");

var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $5L38b = parcelRequire("5L38b");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $afp1H = parcelRequire("afp1H");

var $9oOnT = parcelRequire("9oOnT");

var $hJgLA = parcelRequire("hJgLA");
const $86481dd22f22993b$var$MAX_LINE_NUMBER = 8;
const $86481dd22f22993b$var$contentStyles = null;
const $86481dd22f22993b$var$linkStyles = null;
const $86481dd22f22993b$var$textStylesBase = null;
const $86481dd22f22993b$var$dropdownItemGroupStyles = null;
const $86481dd22f22993b$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $86481dd22f22993b$var$MAX_LINE_NUMBER, invokePreviewAction: invokePreviewAction })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const invoke = (0, $9oOnT.default)({});
    const isPreviewAvailable = invokePreviewAction !== undefined;
    const handlePreviewOpen = (0, $gwFzn.useCallback)(()=>{
        if (isPreviewAvailable) {
            fireEvent('ui.button.clicked.smartLinkStatusOpenPreview', {});
            if (invokePreviewAction) invoke(invokePreviewAction);
        }
    }, [
        isPreviewAvailable,
        invoke,
        invokePreviewAction,
        fireEvent
    ]);
    const dynamicCss = null;
    const content = (0, $gwFzn.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gwFzn.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                    className: (0, $35pXk.default)([
                        "_zulpu2gc _11c81ixg _1reo15vq _18m915vq _1e0c1txw _1ul9idpf _2lx2vrvc _19pkv77o _4cvr1y6m _pqme2smr _102e2smr _ngc01fxt _1t4p1fxt"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5L38b))), {
                            testId: `${testId}-icon`,
                            LEGACY_size: "medium",
                            color: "var(--ds-icon-danger, #C9372C)",
                            LEGACY_secondaryColor: "var(--ds-background-danger, #FFECEB)",
                            label: 'error',
                            spacing: "spacious"
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            "data-testid": `${testId}-error-message`,
                            className: (0, $35pXk.default)([
                                "_11c81ixg _1reo15vq _18m915vq _o5724jg8 _1e0ccj1k _1bto1l2s _1nmz1hna _sudp1e54",
                                "_1yyj1n6p _102k16q4"
                            ]),
                            style: {
                                "--_t4prqe": (0, $iAWao.default)(maxLineNumber)
                            },
                            children: typeof errorMessage === 'string' ? errorMessage : (0, $hJgLA.getFormattedMessage)(errorMessage)
                        })
                    ]
                }),
                isPreviewAvailable ? /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    className: (0, $35pXk.default)([
                        "_zulpu2gc _1reo15vq _18m915vq _11c82smr _1e0c1txw _1ul9idpf _2lx2vrvc _4cvr1h6o _80omtlke _19pku2gc _18u0xy5q _otyrv77o"
                    ]),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
                        target: "_blank",
                        "data-testid": `${testId}-open-embed`,
                        onClick: handlePreviewOpen,
                        children: (0, $dh538.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $afp1H.messages).open_issue_in_jiraIssueTermRefresh
                        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                            ...(0, $afp1H.messages).open_issue_in_jira
                        })
                    })
                }) : null
            ]
        });
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        testId,
        dynamicCss
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": `${testId}-error-item-group`,
        className: (0, $35pXk.default)([
            "_14hp1wdt _6pup1kw7 _1eo073ad"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ahaN7.default), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dAYOx.default), {
                testId: `${testId}-error`,
                children: content
            })
        })
    });
};
var $86481dd22f22993b$export$2e2bcd8739ae039 = $86481dd22f22993b$var$LozengeActionError;

});
parcelRegister("9oOnT", function(module, exports) {

$parcel$export(module.exports, "default", () => $458a31c3ca98bc55$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $9HkI0 = parcelRequire("9HkI0");

var $kKODE = parcelRequire("kKODE");

var $l6tPN = parcelRequire("l6tPN");

var $bIll3 = parcelRequire("bIll3");
const $458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $458a31c3ca98bc55$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $gwFzn.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $l6tPN.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $bIll3.startUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $l6tPN.mark(markName, 'resolved');
            (0, $bIll3.succeedUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $l6tPN.mark(markName, 'errored');
            (0, $bIll3.failUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $458a31c3ca98bc55$export$2e2bcd8739ae039 = $458a31c3ca98bc55$var$useInvokeClientAction;

});
parcelRegister("l6tPN", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $f72103dc56ec53a8$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $f72103dc56ec53a8$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $f72103dc56ec53a8$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $f72103dc56ec53a8$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $f72103dc56ec53a8$export$185802fd694ee1f5);
const $f72103dc56ec53a8$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $f72103dc56ec53a8$var$hasPerformanceAPIAvailable = $f72103dc56ec53a8$var$isPerformanceAPIAvailable();
const $f72103dc56ec53a8$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $f72103dc56ec53a8$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $f72103dc56ec53a8$export$1a717feb4df1a945 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $f72103dc56ec53a8$export$de42547d395c8271 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $f72103dc56ec53a8$var$getMark = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $f72103dc56ec53a8$export$185802fd694ee1f5 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measure = $f72103dc56ec53a8$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $f72103dc56ec53a8$var$getMark(id, 'pending');
            const endMark = $f72103dc56ec53a8$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});



parcelRegister("bTJCs", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $3b4344c10bfc2ba3$export$4f2e371a667ad688);

var $afp1H = parcelRequire("afp1H");
const $3b4344c10bfc2ba3$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $afp1H.messages)['status_change_permission_error']
    },
    noDataIssueTermRefresh: {
        descriptor: (0, $afp1H.messages)['status_change_permission_errorIssueTermRefresh']
    },
    unknown: {
        descriptor: (0, $afp1H.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $afp1H.messages)['status_change_update_error']
    }
};

});

parcelRegister("58trk", function(module, exports) {

$parcel$export(module.exports, "default", () => $7734c527fca28b11$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ahaN7 = parcelRequire("ahaN7");

var $k5ktp = parcelRequire("k5ktp");
const $7734c527fca28b11$var$dropdownItemGroupStyles = null;
const $7734c527fca28b11$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": `${testId}-item-group`,
        className: (0, $35pXk.default)([
            "_c71l1mjv _18m91wug _1pv01r31 _1m1b1r31 _qh55glyw _lt2aglyw _ph3k1o36 _1twe1o36 _1ll7166n _qprf166n _n6y8usvi _109gusvi _z29hu4to _wlxpu4to _1gfl12x7 _yhjmutpp _1gqn12x7 _11lvutpp _d4lf1f4h _14hp1wdt _6pup1kw7"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ahaN7.default), {
            children: items.map((item, idx)=>/*#__PURE__*/ (0, $gwFzn.createElement)((0, $k5ktp.default), {
                    ...item,
                    key: idx,
                    onClick: onClick,
                    testId: `${testId}-item-${idx}`
                }))
        })
    });
var $7734c527fca28b11$export$2e2bcd8739ae039 = $7734c527fca28b11$var$LozengeActionItemsGroup;

});
parcelRegister("k5ktp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9439470310c10a2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dAYOx = parcelRequire("dAYOx");

var $5nBzc = parcelRequire("5nBzc");

var $dh538 = parcelRequire("dh538");
const $c9439470310c10a2$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $gwFzn.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $gwFzn.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        onMouseEnter: handleMouseEnter,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dAYOx.default), {
            onClick: handleClick,
            testId: testId,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
                appearance: appearance,
                ...(0, $dh538.fg)('platform-component-visual-refresh') ? {
                    isBold: true
                } : undefined,
                children: text
            })
        })
    }));
};
var $c9439470310c10a2$export$2e2bcd8739ae039 = $c9439470310c10a2$var$LozengeActionItem;

});


parcelRegister("dXPIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3c19665a3fd574$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ddbVR = parcelRequire("ddbVR");

var $7kzZ3 = parcelRequire("7kzZ3");

var $aK0ya = parcelRequire("aK0ya");

var $5nBzc = parcelRequire("5nBzc");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
const $7e3c19665a3fd574$var$styles = {
    chevronDown: "_18u012x7 _1e0c1txw",
    lozengeContainer: "_kkk2n7od _2rkoiti9 _1dqonqa1 _189ee4h9 _1h6d3acm _bfhk18uv _1e0c1txw _4cvr1h6o _4t3i7vkz",
    lozengeContainerSelected: "_1reo15vq _18m915vq _1h6d1p6i"
};
const $7e3c19665a3fd574$var$triggerLozengeStyles = null;
const $7e3c19665a3fd574$var$triggerButtonStyles = null;
const $7e3c19665a3fd574$var$LozengeActionTriggerOld = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $gwFzn.useState)(false);
    const onMouseEnter = (0, $gwFzn.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $gwFzn.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $gwFzn.useMemo)(()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
            appearance: appearance,
            isBold: (0, $dh538.fg)('platform-component-visual-refresh') ? true : isBold,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
                className: (0, $35pXk.default)([
                    "_4cvr1h6o _1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                        children: text
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        as: "span",
                        xcss: $7e3c19665a3fd574$var$styles.chevronDown,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                            color: "currentColor",
                            label: "options",
                            LEGACY_size: "medium",
                            LEGACY_margin: "-4px -8px -4px -7px",
                            size: "small"
                        })
                    })
                ]
            })
        }), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef,
        className: (0, $35pXk.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
const $7e3c19665a3fd574$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isHovering, setIsHovering] = (0, $gwFzn.useState)(false);
    const [isPressing, setIsPressing] = (0, $gwFzn.useState)(false);
    const [lozengeBackgroundColor, setLozengeBackgroundColor] = (0, $gwFzn.useState)(undefined);
    const [lozengeForegroundColor, setLozengeForegroundColor] = (0, $gwFzn.useState)(undefined);
    const onMouseEnter = (0, $gwFzn.useCallback)(()=>setIsHovering(true), []);
    const onMouseLeave = (0, $gwFzn.useCallback)(()=>setIsHovering(false), []);
    const onMouseOrKeyDown = (0, $gwFzn.useCallback)(()=>setIsPressing(true), []);
    const onMouseOrKeyUp = (0, $gwFzn.useCallback)(()=>setIsPressing(false), []);
    (0, $gwFzn.useEffect)(()=>{
        if (isPressing) {
            setLozengeBackgroundColor("var(--ds-background-selected-pressed, #85B8FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else if (isOpen) {
            if (isHovering) setLozengeBackgroundColor("var(--ds-background-selected-hovered, #CCE0FF)");
            else setLozengeBackgroundColor("var(--ds-background-selected, #E9F2FF)");
            setLozengeForegroundColor("var(--ds-text-selected, #0C66E4)");
        } else {
            setLozengeBackgroundColor(undefined);
            setLozengeForegroundColor(undefined);
        }
    }, [
        isPressing,
        isOpen,
        isHovering
    ]);
    const lozenge = (0, $gwFzn.useMemo)(()=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            xcss: (0, $ddbVR.cx)($7e3c19665a3fd574$var$styles.lozengeContainer, (isOpen || isPressing) && $7e3c19665a3fd574$var$styles.lozengeContainerSelected),
            as: "span",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5nBzc.default), {
                appearance: appearance,
                isBold: (0, $dh538.fg)('platform-component-visual-refresh') ? true : isHovering,
                style: {
                    backgroundColor: lozengeBackgroundColor,
                    color: lozengeForegroundColor
                },
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)("span", {
                    className: (0, $35pXk.default)([
                        "_4cvr1h6o _1e0c1txw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            children: text
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            as: "span",
                            xcss: $7e3c19665a3fd574$var$styles.chevronDown,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                                color: "currentColor",
                                label: "options",
                                LEGACY_size: "medium",
                                LEGACY_margin: "-4px -8px -4px -7px",
                                size: "small"
                            })
                        })
                    ]
                })
            })
        });
    }, [
        appearance,
        isHovering,
        isPressing,
        text,
        isOpen,
        lozengeBackgroundColor,
        lozengeForegroundColor
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("button", {
        type: "button",
        ...props,
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseOrKeyDown,
        onMouseUp: onMouseOrKeyUp,
        onKeyDown: onMouseOrKeyDown,
        onKeyUp: onMouseOrKeyUp,
        ref: triggerRef,
        className: (0, $35pXk.default)([
            "_kkk2n7od _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _15vhn7od _1dqonqa1 _189eyh40 _1h6d3acm _bfhk18uv _syazn7od _80omtlke _ect4n7od _1wybn7od _zg8ln7od _k48pn7od _vwz4idpf _1p1dn7od _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _mizu1r31 _1guj1r31 _p8tl1r31 _ra3xglyw _pbhaglyw _1q2vglyw _128m1o36 _11ow1o36 _j8b81o36 _1bas14y2 _19h614y2 _1d3914y2 _1ejj1vm4 _1u6l1vm4 _6ssh1vm4"
        ]),
        children: lozenge
    });
};
var $7e3c19665a3fd574$export$2e2bcd8739ae039 = (0, $aK0ya.withFeatureFlaggedComponent)($7e3c19665a3fd574$var$LozengeActionTriggerOld, $7e3c19665a3fd574$var$LozengeActionTrigger, ()=>(0, $dh538.fg)('platform-linking-visual-refresh-v2'));

});




parcelRegister("bmx11", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95f1e4b0b62823d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $c95f1e4b0b62823d$var$LatestCommitElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.latestCommit?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Commit,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).LatestCommit
    }) : null;
};
var $c95f1e4b0b62823d$export$2e2bcd8739ae039 = $c95f1e4b0b62823d$var$LatestCommitElement;

});

parcelRegister("jI5eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b061eed85b2a3300$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $4NlKF = parcelRequire("4NlKF");
const $b061eed85b2a3300$var$LinkIconElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (!context) return null;
    if ((0, $dh538.fg)('platform-linking-visual-refresh-v2')) {
        const data = (0, $4NlKF.toLinkIconProps)(context?.linkIcon, context.type);
        return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4NlKF.default), {
            ...data,
            ...props,
            name: (0, $5TXU5.ElementName).LinkIcon
        }) : null;
    }
    const data = typeof context?.linkIcon === 'object' ? context?.linkIcon : undefined;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4NlKF.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).LinkIcon
    }) : null;
};
var $b061eed85b2a3300$export$2e2bcd8739ae039 = $b061eed85b2a3300$var$LinkIconElement;

});
parcelRegister("4NlKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f41eba93c8538ef$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkIconProps", () => $5f41eba93c8538ef$export$6d33abd591a3f700);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $8Q3VW = parcelRequire("8Q3VW");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $5TXU5 = parcelRequire("5TXU5");

var $ivUmx = parcelRequire("ivUmx");

var $iFRRf = parcelRequire("iFRRf");

var $kUxzQ = parcelRequire("kUxzQ");

var $hJgLA = parcelRequire("hJgLA");
const $5f41eba93c8538ef$var$styles = {
    container: "_1ul91ns9",
    iconWrapperStyle: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $5f41eba93c8538ef$var$positionStyleMap = {
    center: "_1wpz1h6o",
    top: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wpz1y6m"
};
const $5f41eba93c8538ef$var$customRenderStyleMap = {
    xlarge: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    large: "_1reo15vq _18m915vq _11c8nf1z _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kz42d",
    medium: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym",
    small: "_1reo15vq _18m915vq _11c8nbxd _1e0ccj1k _1nmz1hna _1yyjkb7n _y3gn1h6o _1btozryt _sudpn7od _1ipkidpf _1kdcidpf _3glyidpf _1w2uidpf _1oh2idpf _99ztidpf _1m2uidpf _9n9oidpf _e4km18uv _1xjx1osq _e2oo1osq _102kptym"
};
const $5f41eba93c8538ef$var$renderAtlaskitIcon = (icon, testId, size = (0, $5TXU5.SmartLinkSize).Medium)=>{
    if (icon) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iFRRf.default), {
        icon: icon,
        testId: `${testId}-icon`,
        "aria-hidden": "true",
        label: "" // Since we already set aria-hidden="true", the label should be given an empty string
        ,
        size: size
    });
};
const $5f41eba93c8538ef$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Q3VW))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $5f41eba93c8538ef$var$renderImageIcon = (defaultIcon, url, testId, size = (0, $5TXU5.SmartLinkSize).Medium, appearance, hideLoadingSkeleton)=>{
    const width = size === (0, $5TXU5.SmartLinkSize).Large ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
    if (url) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUxzQ.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url,
        width: width,
        height: width,
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v2') && {
            appearance: appearance
        },
        hideLoadingSkeleton: hideLoadingSkeleton
    });
}; /**
    * A base element that displays an Icon or favicon.
    * @internal
    * @param props - The props necessary for the Icon element.
    * @see LinkIcon
    */ 
const $5f41eba93c8538ef$var$IconElement = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $5TXU5.SmartLinkPosition).Top, className: className, render: render, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const element = (0, $gwFzn.useMemo)(()=>{
        const defaultIcon = $5f41eba93c8538ef$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $5f41eba93c8538ef$var$renderImageIcon(defaultIcon, url, testId, size, (0, $dh538.fg)('platform-linking-visual-refresh-v2') ? appearance : undefined, hideLoadingSkeleton) || $5f41eba93c8538ef$var$renderAtlaskitIcon(icon, testId, size) || defaultIcon;
    }, [
        label,
        testId,
        overrideIcon,
        render,
        url,
        size,
        appearance,
        hideLoadingSkeleton,
        icon
    ]);
    const width = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $5f41eba93c8538ef$var$styles.container,
            $5f41eba93c8538ef$var$positionStyleMap[position],
            render && $5f41eba93c8538ef$var$customRenderStyleMap[size],
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            xcss: $5f41eba93c8538ef$var$styles.iconWrapperStyle,
            style: {
                width: width,
                height: width
            },
            children: element
        })
    });
};
var $5f41eba93c8538ef$export$2e2bcd8739ae039 = $5f41eba93c8538ef$var$IconElement;
const $5f41eba93c8538ef$export$6d33abd591a3f700 = (data, type)=>{
    const isDataLinkIcon = (_data)=>{
        return typeof _data === 'object' && _data !== null && ('icon' in _data || 'url' in _data);
    };
    if (!isDataLinkIcon(data)) return typeof data === 'object' ? data : undefined;
    const isImageRound = (0, $ivUmx.isProfileType)(type);
    return {
        ...data,
        appearance: isImageRound ? 'round' : 'square'
    };
};

});


parcelRegister("8iOdP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7078b0bbce341226$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $8bb8e = parcelRequire("8bb8e");
const $7078b0bbce341226$var$LocationElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.location ?? null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8bb8e.default), {
        theme: (0, $5TXU5.SmartLinkInternalTheme).Grey,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Location
    }) : null;
};
var $7078b0bbce341226$export$2e2bcd8739ae039 = $7078b0bbce341226$var$LocationElement;

});
parcelRegister("8bb8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb4f16a03665d341$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toLinkProps", () => $eb4f16a03665d341$export$d58e465a9e5297f4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @compiled/shorthand-property-sorting */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $5TXU5 = parcelRequire("5TXU5");

var $4gM1A = parcelRequire("4gM1A");

var $hJgLA = parcelRequire("hJgLA");
const $eb4f16a03665d341$var$DEFAULT_MAX_LINES = 2;
const $eb4f16a03665d341$var$MAXIMUM_MAX_LINES = 2;
const $eb4f16a03665d341$var$MINIMUM_MAX_LINES = 1;
const $eb4f16a03665d341$var$containerStyles = null;
const $eb4f16a03665d341$var$getMaxLines = (maxLines)=>{
    if (maxLines > $eb4f16a03665d341$var$MAXIMUM_MAX_LINES) return $eb4f16a03665d341$var$DEFAULT_MAX_LINES;
    if (maxLines < $eb4f16a03665d341$var$MINIMUM_MAX_LINES) return $eb4f16a03665d341$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $eb4f16a03665d341$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span",
        children: trigger
    });
const $eb4f16a03665d341$var$linkStyleSizeMap = {
    xlarge: "_11c8lodh _k48pi7a9 _vwz41k8s",
    large: "_11c82smr _k48pi7a9 _vwz41j6v",
    medium: "_11c82smr _k48pi7a9 _vwz41j6v",
    small: "_11c8dcr7 _k48pi7a9 _vwz41j6v"
};
const $eb4f16a03665d341$var$baseAnchorStyle = null;
const $eb4f16a03665d341$var$workBreakStyleMap = {
    true: "_1nmz1hna",
    false: "_1nmz9jpi"
};
const $eb4f16a03665d341$var$anchorConstantsStyles = null;
const $eb4f16a03665d341$var$anchorLineClampMap = {
    1: "_1yyjkb7n",
    2: "_1yyjcs5v"
};
const $eb4f16a03665d341$var$anchorLinkLineHeight1Map = {
    xlarge: "_102k1k8s",
    large: "_102k1j6v",
    medium: "_102k1j6v",
    small: "_102k1j6v"
};
const $eb4f16a03665d341$var$anchorLinkLineHeight2Map = {
    xlarge: "_102k1wto",
    large: "_102kviql",
    medium: "_102kviql",
    small: "_102kviql"
};
const $eb4f16a03665d341$var$themeStyleMap = {
    grey: "_fjv618uv _93u918uv _g2lk18uv _pnzf18uv _hlwq8stv _1e2m8stv _1l4b8stv _ue8d8stv _yni7nqa1 _1bianqa1 _93jhnqa1 _64n6nqa1 _1ray131l _dlb7131l _rnxt131l _1h4d131l _10uedcr7 _ye10131l",
    black: "_syaz1gjq _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
    link: "_syaz14q2 _9oik18uv _1bnx8stv _jf4cnqa1 _30l314q2 _9h8h16c2"
};
const $eb4f16a03665d341$var$BaseLinkElement = ({ hideTooltip: hideTooltip, maxLines: maxLines = $eb4f16a03665d341$var$DEFAULT_MAX_LINES, name: name, className: className, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $5TXU5.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank', anchorRef: anchorRef })=>{
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const hasSpace = (0, $gwFzn.useMemo)(()=>text ? (0, $hJgLA.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug",
            $eb4f16a03665d341$var$linkStyleSizeMap[size],
            $eb4f16a03665d341$var$anchorLineClampMap[$eb4f16a03665d341$var$getMaxLines(maxLines)],
            "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _sudp1e54",
            $eb4f16a03665d341$var$workBreakStyleMap[hasSpace ? 'true' : 'false'],
            $eb4f16a03665d341$var$getMaxLines(maxLines) === 1 && $eb4f16a03665d341$var$anchorLinkLineHeight1Map[size],
            $eb4f16a03665d341$var$getMaxLines(maxLines) === 2 && $eb4f16a03665d341$var$anchorLinkLineHeight2Map[size],
            $eb4f16a03665d341$var$themeStyleMap[theme],
            className
        ]),
        ...target !== '_self' && {
            target: target
        },
        ref: anchorRef,
        children: text
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug"
        ]),
        children: hideTooltip || text === undefined ? anchor : $eb4f16a03665d341$var$withTooltip(anchor, text, testId)
    });
};
var $eb4f16a03665d341$export$2e2bcd8739ae039 = $eb4f16a03665d341$var$BaseLinkElement;
const $eb4f16a03665d341$export$d58e465a9e5297f4 = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};

});


parcelRegister("jW9GW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7578031676e72aae$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $aIzVM = parcelRequire("aIzVM");
const $7578031676e72aae$var$ModifiedByElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).modified_by, context.modifiedBy) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ModifiedBy
    }) : null;
};
var $7578031676e72aae$export$2e2bcd8739ae039 = $7578031676e72aae$var$ModifiedByElement;

});

parcelRegister("1WqHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $eaad8a74af19aa38$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $6wR2f = parcelRequire("6wR2f");
const $eaad8a74af19aa38$var$ModifiedOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('modified', context.modifiedOn) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6wR2f.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ModifiedOn
    }) : null;
};
var $eaad8a74af19aa38$export$2e2bcd8739ae039 = $eaad8a74af19aa38$var$ModifiedOnElement;

});

parcelRegister("ful5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $42f47b467fa462a3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $aIzVM = parcelRequire("aIzVM");
const $42f47b467fa462a3$var$OwnedByElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).owned_by, context.ownedBy) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).OwnedBy
    }) : null;
};
var $42f47b467fa462a3$export$2e2bcd8739ae039 = $42f47b467fa462a3$var$OwnedByElement;

});

parcelRegister("41AV3", function(module, exports) {

$parcel$export(module.exports, "default", () => $085ad7f5d3b72529$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9mMJ0 = parcelRequire("9mMJ0");
const $085ad7f5d3b72529$var$OwnedByGroupElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9mMJ0.toAvatarGroupProps)(context.ownedByGroup, false) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9mMJ0.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).OwnedByGroup
    }) : null;
};
var $085ad7f5d3b72529$export$2e2bcd8739ae039 = $085ad7f5d3b72529$var$OwnedByGroupElement;

});

parcelRegister("ikM9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98281f2c459b443$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $2yyMz = parcelRequire("2yyMz");
const $a98281f2c459b443$var$PreviewElement = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $5TXU5.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2yyMz.default), {
        ...rest,
        ...data
    });
};
var $a98281f2c459b443$export$2e2bcd8739ae039 = $a98281f2c459b443$var$PreviewElement;

});
parcelRegister("2yyMz", function(module, exports) {

$parcel$export(module.exports, "default", () => $531c533c77a52797$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $kUxzQ = parcelRequire("kUxzQ");
const $531c533c77a52797$var$styles = null;
const $531c533c77a52797$var$MediaElement = ({ name: name, className: className, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_1h1tcq2i _1e0c1txw _1bsb1osq _4t3i1ns9 _jqez1osq _1lg71osq _6slq1osq _x1m21osq _1chb1osq _1usb1osq _5c331osq _l9z01osq _6o691dfr _vr2g1dfr _173baqso _1niwaqso _t0h9stnw _1ulbstnw _byj21ooe _3hvr1ooe _1c0s1ssb _15j31ssb _1npy1ssb _19he1ssb _n3vc1wug _1qj91wug _4fdy1wug _18cv1wug _1aoq15vq _1iqz15vq _6fioj63w _l0jmidpf _12zuh2mm",
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kUxzQ.default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        })
    });
};
var $531c533c77a52797$export$2e2bcd8739ae039 = $531c533c77a52797$var$MediaElement;

});


parcelRegister("8YJtM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecf289c1a2ef6a7c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $ecf289c1a2ef6a7c$var$PriorityElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.priority ?? null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Priority
    }) : null;
};
var $ecf289c1a2ef6a7c$export$2e2bcd8739ae039 = $ecf289c1a2ef6a7c$var$PriorityElement;

});

parcelRegister("6Ed8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c7f8fc790c1b094$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $3c7f8fc790c1b094$var$ProgrammingLanguageElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.programmingLanguage) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).ProgrammingLanguage,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ProgrammingLanguage
    }) : null;
};
var $3c7f8fc790c1b094$export$2e2bcd8739ae039 = $3c7f8fc790c1b094$var$ProgrammingLanguageElement;

});

parcelRegister("iuEuh", function(module, exports) {

$parcel$export(module.exports, "default", () => $5efcddd7e05f410f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $5efcddd7e05f410f$var$ReactCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.reactCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).React,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ReactCount
    }) : null;
};
var $5efcddd7e05f410f$export$2e2bcd8739ae039 = $5efcddd7e05f410f$var$ReactCountElement;

});

parcelRegister("2GDee", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b374eebbbeae9d3$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $aIzVM = parcelRequire("aIzVM");
const $2b374eebbbeae9d3$var$ReadTimeElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toFormattedTextProps)((0, $afp1H.messages).read_time, context.readTime) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ReadTime
    }) : null;
};
var $2b374eebbbeae9d3$export$2e2bcd8739ae039 = $2b374eebbbeae9d3$var$ReadTimeElement;

});

parcelRegister("h2WFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4843e0ca575cd89$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $6wR2f = parcelRequire("6wR2f");
const $b4843e0ca575cd89$var$SentOnElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $6wR2f.toDateTimeProps)('sent', context.sentOn) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6wR2f.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SentOn
    }) : null;
};
var $b4843e0ca575cd89$export$2e2bcd8739ae039 = $b4843e0ca575cd89$var$SentOnElement;

});

parcelRegister("49WiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a2a6a0afaba68de$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $fUfR2 = parcelRequire("fUfR2");

var $aIzVM = parcelRequire("aIzVM");
const $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES = 3; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $4a2a6a0afaba68de$var$snippetBaseStyleOld = null;
const $4a2a6a0afaba68de$var$snippetBaseStyle = null;
const $4a2a6a0afaba68de$var$SnippetElement = (props)=>{
    const { content: overrideContent, maxLines: maxLines = $4a2a6a0afaba68de$var$SNIPPET_DEFAULT_MAX_LINES, className: className, ...restOfProps } = props ?? {};
    const context = (0, $fUfR2.useFlexibleUiContext)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIzVM.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_syaz1fxt _1ul9idpf _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        ...restOfProps
    });
};
var $4a2a6a0afaba68de$export$2e2bcd8739ae039 = $4a2a6a0afaba68de$var$SnippetElement;

});

parcelRegister("aGsNO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b9dc14522cad497$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $aIzVM = parcelRequire("aIzVM");
const $2b9dc14522cad497$var$SourceBranchElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toTextProps)(context.sourceBranch) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SourceBranch
    }) : null;
};
var $2b9dc14522cad497$export$2e2bcd8739ae039 = $2b9dc14522cad497$var$SourceBranchElement;

});

parcelRegister("emfmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba597065b544e1bf$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $7f92O = parcelRequire("7f92O");
const $ba597065b544e1bf$var$StateElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.state ?? null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7f92O.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).State
    }) : null;
};
var $ba597065b544e1bf$export$2e2bcd8739ae039 = $ba597065b544e1bf$var$StateElement;

});

parcelRegister("a0Yyn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a2e44abfd20874f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $9a2e44abfd20874f$var$SubscriberCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.subscriberCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Subscriber,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SubscriberCount
    }) : null;
};
var $9a2e44abfd20874f$export$2e2bcd8739ae039 = $9a2e44abfd20874f$var$SubscriberCountElement;

});

parcelRegister("b8mrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a84eddedac7cbcb2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $a84eddedac7cbcb2$var$SubTasksProgressElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.subTasksProgress?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).SubTasksProgress,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).SubTasksProgress
    }) : null;
};
var $a84eddedac7cbcb2$export$2e2bcd8739ae039 = $a84eddedac7cbcb2$var$SubTasksProgressElement;

});

parcelRegister("jpKes", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f590de7cb9f9cd$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9FRqB = parcelRequire("9FRqB");
const $92f590de7cb9f9cd$var$StoryPointsElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9FRqB.toAtlaskitBadgeProps)(context.storyPoints) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9FRqB.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).StoryPoints
    }) : null;
};
var $92f590de7cb9f9cd$export$2e2bcd8739ae039 = $92f590de7cb9f9cd$var$StoryPointsElement;

});
parcelRegister("9FRqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $26451f799052e0a3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toAtlaskitBadgeProps", () => $26451f799052e0a3$export$731812b93bd90554);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $c4sKh = parcelRequire("c4sKh");

var $dh538 = parcelRequire("dh538");
const $26451f799052e0a3$var$badgeStylesOld = null;
const $26451f799052e0a3$var$badgeStyles = null; /**
                           * A base element that displays a visual indicator for a numeric value
                           * @internal
                           * @see StoryPoints
                           * */ 
const $26451f799052e0a3$var$BaseAtlaskitElementBadge = ({ value: value, name: name, className: className, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {} : {
            ['data-fit-to-content']: true
        },
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y _1ul91ns9",
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c4sKh.default), {
            children: value
        })
    });
};
var $26451f799052e0a3$export$2e2bcd8739ae039 = $26451f799052e0a3$var$BaseAtlaskitElementBadge;
const $26451f799052e0a3$export$731812b93bd90554 = (value)=>{
    return value ? {
        value: value
    } : undefined;
};

});


parcelRegister("hIbqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a81c9be82c9d19d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $aIzVM = parcelRequire("aIzVM");
const $9a81c9be82c9d19d$var$TargetBranchElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $aIzVM.toTextProps)(context.targetBranch) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIzVM.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).TargetBranch
    }) : null;
};
var $9a81c9be82c9d19d$export$2e2bcd8739ae039 = $9a81c9be82c9d19d$var$TargetBranchElement;

});

parcelRegister("gHW9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6969367f8b7bc15$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $8bb8e = parcelRequire("8bb8e");
const $b6969367f8b7bc15$var$TitleElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $dh538.fg)('platform-linking-flexible-card-context') ? context?.linkTitle : (0, $8bb8e.toLinkProps)(context.title, context.url) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8bb8e.default), {
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).Title
    }) : null;
};
var $b6969367f8b7bc15$export$2e2bcd8739ae039 = $b6969367f8b7bc15$var$TitleElement;

});

parcelRegister("zH0mb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c7b8fd91da848f0$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $5c7b8fd91da848f0$var$ViewCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.viewCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).View,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).ViewCount
    }) : null;
};
var $5c7b8fd91da848f0$export$2e2bcd8739ae039 = $5c7b8fd91da848f0$var$ViewCountElement;

});

parcelRegister("6LJqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a9391f1b33e2cfa$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $1a9391f1b33e2cfa$var$VoteCountElement = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context ? (0, $9AUBM.toBadgeProps)(context.voteCount?.toString()) : null;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Vote,
        ...data,
        ...props,
        name: (0, $5TXU5.ElementName).VoteCount
    }) : null;
};
var $1a9391f1b33e2cfa$export$2e2bcd8739ae039 = $1a9391f1b33e2cfa$var$VoteCountElement;

});

parcelRegister("e4NSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e7d5657b08cc85$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $9AUBM = parcelRequire("9AUBM");
const $97e7d5657b08cc85$var$AppliedToComponentsCountElement = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    if (// Check for null and undefined, render if it's 0.
    context?.appliedToComponentsCount === null || context?.appliedToComponentsCount === undefined) return null;
    const label = formatMessage((0, $afp1H.messages).compass_applied_components_count, {
        numberOfComponents: context.appliedToComponentsCount
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9AUBM.default), {
        icon: (0, $5TXU5.IconType).Component,
        label: label,
        ...props
    });
};
var $97e7d5657b08cc85$export$2e2bcd8739ae039 = $97e7d5657b08cc85$var$AppliedToComponentsCountElement;

});


parcelRegister("1RvsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $16630f477b2fdaf3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $l7DP7 = parcelRequire("l7DP7");
const $16630f477b2fdaf3$var$alignmentStyleMap = {
    right: "_1dthh9n0 _r291h9n0 _1bahesu3 _y3gnusic",
    left: "_1dthv2br _r291v2br _1bah1y6m _y3gn1e5h"
}; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $16630f477b2fdaf3$var$baseStyleBySizeOld = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _vwz41j6v"
};
const $16630f477b2fdaf3$var$baseStyleBySize = {
    xlarge: "_zulpv47k _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    large: "_zulppxbi _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    medium: "_zulpu2gc _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf",
    small: "_zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf"
};
const $16630f477b2fdaf3$var$baseStyleByDirection = {
    horizontal: "_2lx2vrvc _4cvr1h6o",
    vertical: "_2lx21bp4 _4cvr1y6m"
};
const $16630f477b2fdaf3$var$baseStyleOld = null;
const $16630f477b2fdaf3$var$baseStyles = null;
const $16630f477b2fdaf3$var$widthStyle = {
    flexible: "_16jlkb7n _1o9z11wp _i0dlf1ug",
    'fit-to-content': ""
};
const $16630f477b2fdaf3$var$positionStyle = {
    top: "_1wpz1y6m",
    center: ""
};
const $16630f477b2fdaf3$var$horizontalStyleBase = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $16630f477b2fdaf3$var$horizontalStyleByHeightOld = {
    xlarge: "_1e0ccj1k _102k1m1q",
    large: "_1e0ccj1k _102k1m1q",
    medium: "_1e0ccj1k _102k1k8s",
    small: "_1e0ccj1k _102k1k8s"
};
const $16630f477b2fdaf3$var$horizontalStyleByHeight = {
    xlarge: "_1e0ccj1k _102k125z",
    large: "_1e0ccj1k _102k125z",
    medium: "_1e0ccj1k _102kz42d",
    small: "_1e0ccj1k _102kz42d"
};
const $16630f477b2fdaf3$var$gapStylesLeft = {
    xlarge: "_7yhbv47k _m6ukidpf",
    large: "_7yhbpxbi _m6ukidpf",
    medium: "_7yhbu2gc _m6ukidpf",
    small: "_7yhb1b66 _m6ukidpf"
};
const $16630f477b2fdaf3$var$gapStylesRight = {
    xlarge: "_24rcv47k _3dveidpf",
    large: "_24rcpxbi _3dveidpf",
    medium: "_24rcu2gc _3dveidpf",
    small: "_24rc1b66 _3dveidpf"
};
const $16630f477b2fdaf3$var$minWidthStyle = null; /**
                             * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
                             * preferences.
                             * @internal
                             * @param {ActionGroupProps} ActionGroupProps
                             * @see Action
                             */ 
const $16630f477b2fdaf3$var$ElementGroup = ({ align: align = (0, $5TXU5.SmartLinkAlignment).Left, children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $5TXU5.SmartLinkWidth).FitToContent, position: position = (0, $5TXU5.SmartLinkPosition).Center, className: className })=>{
    const isHorizontal = direction === (0, $5TXU5.SmartLinkDirection).Horizontal;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-smart-element-group": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $16630f477b2fdaf3$var$baseStyleBySizeOld[size],
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $16630f477b2fdaf3$var$baseStyleBySize[size],
            $16630f477b2fdaf3$var$baseStyleByDirection[direction],
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw _1ouwidpf _f6ju1ns9",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_fiawglyw",
            $16630f477b2fdaf3$var$alignmentStyleMap[align],
            "_1ul99by0",
            $16630f477b2fdaf3$var$widthStyle[width],
            isHorizontal && "_1reo15vq _18m915vq _1e0c1ule _s7n4nkob _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54 _1aaynkob _15tynkob _1iu61nu9 _166k1nu9 _1div1nu9 _bmfb1nu9",
            isHorizontal && !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $16630f477b2fdaf3$var$horizontalStyleByHeightOld[size],
            isHorizontal && (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $16630f477b2fdaf3$var$horizontalStyleByHeight[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Left && $16630f477b2fdaf3$var$gapStylesLeft[size],
            isHorizontal && align === (0, $5TXU5.SmartLinkAlignment).Right && $16630f477b2fdaf3$var$gapStylesRight[size],
            $16630f477b2fdaf3$var$positionStyle[position],
            className
        ]),
        children: (0, $l7DP7.renderChildren)(children, size)
    });
};
var $16630f477b2fdaf3$export$2e2bcd8739ae039 = $16630f477b2fdaf3$var$ElementGroup;

});


parcelRegister("9CAD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $98cfef5f1319cffc$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $jlQ9A = parcelRequire("jlQ9A");
const $98cfef5f1319cffc$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $gwFzn.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $98cfef5f1319cffc$export$2e2bcd8739ae039 = $98cfef5f1319cffc$var$ActionGroupItem;

});
parcelRegister("jlQ9A", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("6FZ6a")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("jLXEH")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("dVBHR")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("cLh5D")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("9l03X")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("2vLbR")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("apOlf")).default);
$parcel$export(module.exports, "UnresolvedAction", () => (parcelRequire("lVA2Y")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("fl0WE")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("loGLq")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("9Gqdx")).default);

var $6FZ6a = parcelRequire("6FZ6a");

var $jLXEH = parcelRequire("jLXEH");

var $dVBHR = parcelRequire("dVBHR");

var $cLh5D = parcelRequire("cLh5D");

var $9l03X = parcelRequire("9l03X");

var $2vLbR = parcelRequire("2vLbR");

var $apOlf = parcelRequire("apOlf");

var $lVA2Y = parcelRequire("lVA2Y");

var $fl0WE = parcelRequire("fl0WE");

var $loGLq = parcelRequire("loGLq");

var $9Gqdx = parcelRequire("9Gqdx");

});
parcelRegister("6FZ6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f726fde681f8fde$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $aQC9h = parcelRequire("aQC9h");

var $ax5FR = parcelRequire("ax5FR");

var $03f7c = parcelRequire("03f7c");

var $20gwM = parcelRequire("20gwM");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $1f726fde681f8fde$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, style: style, asDropDownItem: asDropDownItem, className: className, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $03f7c.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    }) : undefined;
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $20gwM.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ax5FR.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aQC9h.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $7UHDa.jsx)(Wrapper, {
        children: button
    }) : button;
};
var $1f726fde681f8fde$export$2e2bcd8739ae039 = $1f726fde681f8fde$var$Action;

});
parcelRegister("aQC9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0e9865fe28e398$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $9YwaJ = parcelRequire("9YwaJ");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");
var $7p4As = parcelRequire("7p4As");
var $dE1p6 = parcelRequire("dE1p6");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $3gadb = parcelRequire("3gadb");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $1iDg7 = parcelRequire("1iDg7");

var $hJgLA = parcelRequire("hJgLA");
const $0c0e9865fe28e398$var$IconOnlyLarge = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0c0e9865fe28e398$var$SizeSmall = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0c0e9865fe28e398$var$SizeSmallIconOnly = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0c0e9865fe28e398$var$SizeSmallNotIconOnly = null;
const $0c0e9865fe28e398$var$IconButtonAppearanceMap = {
    default: 'default',
    danger: undefined,
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: undefined
};
const $0c0e9865fe28e398$var$ButtonAppearanceMap = {
    default: 'default',
    danger: 'danger',
    link: 'default',
    primary: 'primary',
    subtle: 'subtle',
    'subtle-link': 'subtle',
    warning: 'warning'
};
const $0c0e9865fe28e398$var$tooltipOptions = {
    hideTooltipOnClick: true
};
const $0c0e9865fe28e398$var$ActionButtonRefreshNew = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel }, ref)=>{
    const iconOnly = !content;
    const onButtonClick = (0, $gwFzn.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    const button = (0, $gwFzn.useMemo)(()=>{
        const isLinkButton = !!href;
        const spacing = size === (0, $5TXU5.SmartLinkSize).Large || size === (0, $5TXU5.SmartLinkSize).XLarge ? 'default' : 'compact';
        if (iconOnly) {
            const icon = iconBefore || iconAfter;
            const iconFn = ()=>icon || null;
            if (isLinkButton) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dE1p6.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                href: href,
                isDisabled: isDisabled,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                appearance: $0c0e9865fe28e398$var$IconButtonAppearanceMap[appearance],
                icon: iconFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isTooltipDisabled: false,
                label: tooltipMessage,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                tooltip: $0c0e9865fe28e398$var$tooltipOptions
            });
        }
        const iconBeforeFn = ()=>iconBefore || null;
        const iconAfterFn = ()=>iconAfter || null;
        if (isLinkButton) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
                appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                href: href,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                appearance: $0c0e9865fe28e398$var$ButtonAppearanceMap[appearance],
                "aria-label": ariaLabel,
                iconAfter: iconAfterFn,
                iconBefore: iconBeforeFn,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: spacing,
                testId: testId,
                children: content
            })
        });
    }, [
        appearance,
        ariaLabel,
        content,
        href,
        iconAfter,
        iconBefore,
        iconOnly,
        isDisabled,
        isLoading,
        onButtonClick,
        onClick,
        size,
        testId,
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        testId: `${testId}-button-wrapper`,
        ref: ref,
        children: button
    });
});
// On cleanup of platform-linking-visual-refresh-v1, this should become
// export default withOverrideCss(ActionButton);
const $0c0e9865fe28e398$var$ActionButtonRefreshNewWithOverrideCss = (0, $1iDg7.withOverrideCss)($0c0e9865fe28e398$var$ActionButtonRefreshNew); // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $0c0e9865fe28e398$var$ActionButtonNew = ({ appearance: appearance = 'default', content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, className: className })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $gwFzn.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $35pXk.default)([
            size === (0, $5TXU5.SmartLinkSize).Large && iconOnly && "_1gflidpf _or3fidpf _1ddvidpf _1hhaidpf _yhjmidpf _1trnidpf _1fstidpf _1xceidpf _1gqnidpf _1qdmidpf _df2ridpf _j1twidpf _11lvidpf _192bidpf _vbn7idpf _wfu3idpf _1i3bidpf _13gwidpf _4wlcidpf _rehaidpf _mp2fidpf _ro8midpf _1l0qidpf _1bnaidpf _3kh9idpf _i2vxidpf _8pvjidpf _1e1oidpf _1vtwidpf _ijvwidpf _tpwpidpf _1ad8idpf",
            size === (0, $5TXU5.SmartLinkSize).Small && "_11c8dcr7 _k48p1wq8",
            size === (0, $5TXU5.SmartLinkSize).Small && iconOnly && "_1gflv77o _or3fv77o _1ddvv77o _1hhav77o _yhjmv77o _1trnv77o _1fstv77o _1xcev77o _1gqnv77o _1qdmv77o _df2rv77o _j1twv77o _11lvv77o _192bv77o _vbn7v77o _wfu3v77o",
            size === (0, $5TXU5.SmartLinkSize).Small && !iconOnly && "_11lv1b66 _192b1b66 _vbn71b66 _wfu31b66 _yhjm1b66 _1trn1b66 _1fst1b66 _1xce1b66",
            className
        ]),
        "data-testid": `${testId}-button-wrapper`,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9YwaJ.default), {
                appearance: appearance,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                isLoading: isLoading,
                onClick: onButtonClick(onClick),
                spacing: (0, $hJgLA.sizeToButtonSpacing)[size],
                testId: testId,
                href: href,
                "aria-label": ariaLabel,
                children: content
            })
        })
    });
};
const $0c0e9865fe28e398$var$ActionButtonHideLegacyButton = (props)=>{
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    if (ui?.hideLegacyButton || ui?.removeBlockRestriction && (0, $dh538.fg)('platform-linking-flexible-card-openness')) return /*#__PURE__*/ (0, $7UHDa.jsx)($0c0e9865fe28e398$var$ActionButtonRefreshNewWithOverrideCss, {
        ...props
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0c0e9865fe28e398$var$ActionButtonNew, {
        ...props
    });
};
const $0c0e9865fe28e398$var$ActionButton = (props)=>{
    return (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $7UHDa.jsx)($0c0e9865fe28e398$var$ActionButtonHideLegacyButton, {
        ...props
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)($0c0e9865fe28e398$var$ActionButtonNew, {
        ...props
    });
};
var $0c0e9865fe28e398$export$2e2bcd8739ae039 = $0c0e9865fe28e398$var$ActionButton;

});

parcelRegister("ax5FR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e516599d84c6e93$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dAYOx = parcelRequire("dAYOx");

var $ivUmx = parcelRequire("ivUmx");
const $4e516599d84c6e93$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $dAYOx.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $ivUmx.handleOnClick)(onClick),
        testId: testId,
        children: content
    });
var $4e516599d84c6e93$export$2e2bcd8739ae039 = $4e516599d84c6e93$var$ActionDropdownItem;

});

parcelRegister("03f7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc9e773a3279151b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");
const $cc9e773a3279151b$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
        case (0, $5TXU5.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $5TXU5.SmartLinkSize).Medium:
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
// TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $cc9e773a3279151b$var$iconSizeStyleMap = {
    '1.5rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1k8s _1tke1k8s _c71l1k8s _1bsb1k8s _1ul91k8s _p12f1k8s _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71k8s _1xjx1k8s _17521k8s _qci81k8s _15iz1k8s _erub1k8s _19l31k8s _1pr21k8s _1u5t1k8s _mezj1k8s _e2oo1k8s _w8l51k8s _1rg21k8s _q7cv1k8s _xwbj1k8s _rtys1k8s _b8nk1k8s _4x201k8s",
    '1rem': "_16jlidpf _1o9zidpf _i0dl1wug _4t3i1j6v _1tke1j6v _c71l1j6v _1bsb1j6v _1ul91j6v _p12f1j6v _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna71j6v _1xjx1j6v _17521j6v _qci81j6v _15iz1j6v _erub1j6v _19l31j6v _1pr21j6v _1u5t1j6v _mezj1j6v _e2oo1j6v _w8l51j6v _1rg21j6v _q7cv1j6v _xwbj1j6v _rtys1j6v _b8nk1j6v _4x201j6v",
    '20px': "_16jlidpf _1o9zidpf _i0dl1wug _4t3igktf _1tkegktf _c71lgktf _1bsbgktf _1ul9gktf _p12fgktf _i2i3idpf _uhasidpf _5jw9idpf _7wy9idpf _bna7gktf _1xjxgktf _1752gktf _qci8gktf _15izgktf _erubgktf _19l3gktf _1pr2gktf _1u5tgktf _mezjgktf _e2oogktf _w8l5gktf _1rg2gktf _q7cvgktf _xwbjgktf _rtysgktf _b8nkgktf _4x20gktf"
}; // TODO: Remove on fg cleanup: platform-visual-refresh-icons
const $cc9e773a3279151b$var$stackItemIconStylesOld = null;
const $cc9e773a3279151b$var$stackItemIconStylesCompiled = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $cc9e773a3279151b$var$iconStyleMap = {
    true: "_syaz1lh4",
    false: "_syazwdcn"
};
const $cc9e773a3279151b$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>{
    if (!(0, $dh538.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cc9e773a3279151b$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            asStackItemIcon && "_1e0c1o8l _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            asStackItemIcon && $cc9e773a3279151b$var$iconSizeStyleMap['20px'],
            !asStackItemIcon && $cc9e773a3279151b$var$iconSizeStyleMap[$cc9e773a3279151b$var$getIconWidth(size)]
        ]),
        children: icon
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": `${testId}-icon`,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cc9e773a3279151b$var$iconStyleMap[isDisabled ? 'true' : 'false'],
            "_1e0c1o8l"
        ]),
        children: icon
    });
};
var $cc9e773a3279151b$export$2e2bcd8739ae039 = $cc9e773a3279151b$var$ActionIcon;

});

parcelRegister("20gwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e828a55eaf50791b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $j1jJO = parcelRequire("j1jJO");
const $e828a55eaf50791b$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $j1jJO.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $j1jJO.default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            })
    });
var $e828a55eaf50791b$export$2e2bcd8739ae039 = $e828a55eaf50791b$var$ActionStackItem;

});
parcelRegister("j1jJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb337baea8f1bcdf$export$2e2bcd8739ae039);
/* action-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1Whri = parcelRequire("1Whri");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $fVUfS = parcelRequire("fVUfS");

var $9hlns = parcelRequire("9hlns");

var $hJgLA = parcelRequire("hJgLA");

var $03f7c = parcelRequire("03f7c");
const $cb337baea8f1bcdf$var$stylesOld = {
    button: "_kkk2n7od _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _irr3166n _1di61dty",
    content: "_11c8dcr7 _syaz1fxt"
};
const $cb337baea8f1bcdf$var$styles = {
    button: "_bfhk1w7a _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1bsb1osq _1ah31i6y _irr3166n _1di61dty",
    content: "_11c81o8v _syaz1fxt"
};
const $cb337baea8f1bcdf$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, style: style })=>{
    const space = spaceOption ?? (0, $hJgLA.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $03f7c.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $9hlns.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)(!(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cb337baea8f1bcdf$var$stylesOld.button, (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cb337baea8f1bcdf$var$styles.button),
        ...tooltipProps,
        onClick: onClick,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            grow: "fill",
            space: space,
            children: [
                icon,
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)(!(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cb337baea8f1bcdf$var$stylesOld.content, (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $cb337baea8f1bcdf$var$styles.content),
                    children: content
                })
            ]
        })
    });
};
var $cb337baea8f1bcdf$export$2e2bcd8739ae039 = $cb337baea8f1bcdf$var$ActionButton;

});



parcelRegister("jLXEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f415990ae4e7261e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $1jfCH = parcelRequire("1jfCH");

var $afp1H = parcelRequire("afp1H");

var $6FZ6a = parcelRequire("6FZ6a");
const $f415990ae4e7261e$var$DeleteAction = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).delete
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jfCH))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).delete
        }),
        ...props
    });
var $f415990ae4e7261e$export$2e2bcd8739ae039 = $f415990ae4e7261e$var$DeleteAction;

});

parcelRegister("dVBHR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a74c68e5cf0852d5$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $3QhJU = parcelRequire("3QhJU");

var $afp1H = parcelRequire("afp1H");

var $6FZ6a = parcelRequire("6FZ6a");
const $a74c68e5cf0852d5$var$EditAction = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).edit
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QhJU))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).edit
        }),
        ...props
    });
var $a74c68e5cf0852d5$export$2e2bcd8739ae039 = $a74c68e5cf0852d5$var$EditAction;

});

parcelRegister("cLh5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $47aa84bed0904f6b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $7rrdI = parcelRequire("7rrdI");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $9oOnT = parcelRequire("9oOnT");

var $6FZ6a = parcelRequire("6FZ6a");
const $47aa84bed0904f6b$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).DownloadAction];
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $afp1H.messages).download_file : (0, $afp1H.messages).download;
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).download_description : (0, $afp1H.messages).download;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...label
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7rrdI))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props
    }) : null;
};
var $47aa84bed0904f6b$export$2e2bcd8739ae039 = $47aa84bed0904f6b$var$DownloadAction;

});

parcelRegister("9l03X", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd35d1180b7d8d14$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $hJgLA = parcelRequire("hJgLA");

var $fdQmL = parcelRequire("fdQmL");

var $itUVP = parcelRequire("itUVP");


const $fd35d1180b7d8d14$var$importIconMapper = {
    goal: ()=>(parcelRequire("jfL7I")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("iA4FT")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $fd35d1180b7d8d14$var$getIcon = (stackIconType)=>{
    const importFn = $fd35d1180b7d8d14$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $hJgLA.importIcon)(importFn);
};
const $fd35d1180b7d8d14$var$FollowAction = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $afp1H.messages).follow : (0, $afp1H.messages).unfollow;
    const projectMessage = value ? (0, $afp1H.messages).follow_project : (0, $afp1H.messages).unfollow_project;
    const goalMessage = value ? (0, $afp1H.messages).follow_goal : (0, $afp1H.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $afp1H.messages).follow_project_description : (0, $afp1H.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $afp1H.messages).follow_goal_description : (0, $afp1H.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $fd35d1180b7d8d14$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, $7UHDa.jsx)(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $itUVP.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...errorMessage
            }),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fdQmL.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...label
        }),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        ...data,
        ...props,
        onError: handleError
    });
};
var $fd35d1180b7d8d14$export$2e2bcd8739ae039 = $fd35d1180b7d8d14$var$FollowAction;

});
parcelRegister("fdQmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a36d75dc0f2bdcbc$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kKODE = parcelRequire("kKODE");

var $g98dH = parcelRequire("g98dH");

var $8i8ID = parcelRequire("8i8ID");

var $7DSoa = parcelRequire("7DSoa");

var $1w3oA = parcelRequire("1w3oA");

var $6FZ6a = parcelRequire("6FZ6a");
const $a36d75dc0f2bdcbc$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const invoke = (0, $g98dH.default)();
    const reload = (0, $7DSoa.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleClick = (0, $gwFzn.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                if (smartLinkActionType === 'FollowEntityAction' || smartLinkActionType === 'UnfollowEntityAction') fireEvent('ui.button.clicked.smartLinkFollowButton', {});
                else fireEvent(`ui.button.clicked.${smartLinkActionType}`, {});
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $1w3oA.default)(action);
                await invoke(request);
                fireEvent('track.smartLinkQuickAction.success', {
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                fireEvent('track.smartLinkQuickAction.failed', {
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $8i8ID.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        invoke,
        onClick,
        onErrorCallback,
        reload,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $a36d75dc0f2bdcbc$export$2e2bcd8739ae039 = $a36d75dc0f2bdcbc$var$ServerAction;

});
parcelRegister("1w3oA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8421257f1cf5034c$export$2e2bcd8739ae039);
const $8421257f1cf5034c$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $8421257f1cf5034c$export$2e2bcd8739ae039 = $8421257f1cf5034c$var$createInvokeRequest;

});


parcelRegister("itUVP", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $3c347798ab285251$export$49248678d3914625);

var $afp1H = parcelRequire("afp1H");
const $3c347798ab285251$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $afp1H.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $afp1H.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $afp1H.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $afp1H.messages).unfollow_goal_error;
    return (0, $afp1H.messages).generic_error_message;
};

});

parcelRegister("jfL7I", function(module, exports) {

let $e043f8cb9d7c285c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e043f8cb9d7c285c$var$load("8tqgK"),
    $e043f8cb9d7c285c$var$load("3wY4G")
]).then(()=>parcelRequire('7EiCp'));

});

parcelRegister("iA4FT", function(module, exports) {

let $d86f3712ccf6f69f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d86f3712ccf6f69f$var$load("8tqgK"),
    $d86f3712ccf6f69f$var$load("88r9N")
]).then(()=>parcelRequire('lwRK9'));

});


parcelRegister("2vLbR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8c6ed50ac412c77$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $bgJk4 = parcelRequire("bgJk4");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $9oOnT = parcelRequire("9oOnT");

var $6FZ6a = parcelRequire("6FZ6a");
const $b8c6ed50ac412c77$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).PreviewAction];
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke(data.invokeAction);
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $afp1H.messages).preview_description : (0, $afp1H.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).preview_improved
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bgJk4))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $b8c6ed50ac412c77$export$2e2bcd8739ae039 = $b8c6ed50ac412c77$var$PreviewAction;

});

parcelRegister("apOlf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a91d440270dbacf8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $8Q3VW = parcelRequire("8Q3VW");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $9oOnT = parcelRequire("9oOnT");

var $6FZ6a = parcelRequire("6FZ6a");
const $a91d440270dbacf8$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const invoke = (0, $9oOnT.default)({});
    const data = context?.actions?.[(0, $5TXU5.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $gwFzn.useState)((0, $afp1H.messages).copy_url_to_clipboard);
    const onClick = (0, $gwFzn.useCallback)(()=>{
        if (data?.invokeAction) {
            invoke({
                ...data.invokeAction,
                actionFn: async ()=>{
                    await data.invokeAction?.actionFn();
                    setTooltipMessage((0, $afp1H.messages).copied_url_to_clipboard);
                }
            });
            onClickCallback?.();
        }
    }, [
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).copy_url_to_clipboard
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Q3VW))), {
            color: "currentColor",
            label: "copy url",
            LEGACY_size: "medium",
            spacing: "spacious"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $a91d440270dbacf8$export$2e2bcd8739ae039 = $a91d440270dbacf8$var$CopyLinkAction;

});

parcelRegister("lVA2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1261186af9b2859$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $gdv5Z = parcelRequire("gdv5Z");
var $fVUfS = parcelRequire("fVUfS");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");
const $a1261186af9b2859$var$styles = {
    button: "_1e0c1bgi",
    message: "_1rjcze3t _18zrze3t"
};
const $a1261186af9b2859$var$UnresolvedAction = ({ testId: testId = 'unresolved-action' })=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const data = context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction];
    if (!data) return null;
    const { descriptor: descriptor, onClick: onClick, values: values } = data;
    const hasAction = onClick !== undefined;
    const message = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        testId: `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : undefined,
        xcss: $a1261186af9b2859$var$styles.message,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...descriptor,
            values: values
        })
    });
    return hasAction ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        onClick: data.onClick,
        style: {
            color: `inherit`,
            font: `inherit`,
            textAlign: `inherit`
        },
        xcss: $a1261186af9b2859$var$styles.button,
        children: message
    }) : message;
};
var $a1261186af9b2859$export$2e2bcd8739ae039 = $a1261186af9b2859$var$UnresolvedAction;

});

parcelRegister("fl0WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $773427e96b58aed9$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $g1LJt = parcelRequire("g1LJt");
const $773427e96b58aed9$var$AISummaryAction = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $g1LJt.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $773427e96b58aed9$export$2e2bcd8739ae039 = $773427e96b58aed9$var$AISummaryAction;

});
parcelRegister("g1LJt", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $b80129153fa85400$export$8eed96bc6d982595);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $6KV13 = parcelRequire("6KV13");

var $f0eEY = parcelRequire("f0eEY");

var $blblm = parcelRequire("blblm");
const $b80129153fa85400$export$8eed96bc6d982595 = (props)=>{
    (0, $RUXAI.di)((0, $6KV13.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $6KV13.default)(url);
    (0, $gwFzn.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $blblm.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f0eEY.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("6KV13", function(module, exports) {

$parcel$export(module.exports, "default", () => $c75904359bba5163$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $99WQy = parcelRequire("99WQy");
var $l6lJr = parcelRequire("l6lJr");

var $kKODE = parcelRequire("kKODE");

var $bIll3 = parcelRequire("bIll3");

var $lz9QA = parcelRequire("lz9QA");

var $8Bm55 = parcelRequire("8Bm55");

var $i8IAc = parcelRequire("i8IAc");
const $c75904359bba5163$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $c75904359bba5163$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $i8IAc.useAISummaryConfig)();
    const cardState = (0, $lz9QA.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $99WQy.extractAri)(data);
    const dataUrl = data && (0, $l6lJr.extractLink)(data) || '';
    const onStart = (0, $gwFzn.useCallback)((id)=>{
        (0, $bIll3.startUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $gwFzn.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $bIll3.succeedUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $gwFzn.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $bIll3.failUfoExperience)($c75904359bba5163$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $8Bm55.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $c75904359bba5163$export$2e2bcd8739ae039 = $c75904359bba5163$var$useAISummaryAction;

});
parcelRegister("8Bm55", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $78ebc629fd62f804$export$becd8f2eba1bbd96);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $cbl6V = parcelRequire("cbl6V");

var $geR8p = parcelRequire("geR8p");
const $78ebc629fd62f804$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $gwFzn.useState)((0, $geR8p.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    const { locale: locale } = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $geR8p.AISummariesStore).get(url)) (0, $geR8p.AISummariesStore).set(url, new (0, $cbl6V.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            locale: locale,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $geR8p.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey,
        locale
    ]);
    const summariseUrl = ()=>{
        return (0, $geR8p.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("cbl6V", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $b962d377d695bb74$export$73e4b807d5bd74b6);

var $9HkI0 = parcelRequire("9HkI0");

var $dDhJe = parcelRequire("dDhJe");

var $5Y0oB = parcelRequire("5Y0oB");

var $iPRQp = parcelRequire("iPRQp");

var $eDy2J = parcelRequire("eDy2J");
class $b962d377d695bb74$export$73e4b807d5bd74b6 {
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new (0, $iPRQp.ChunkProcessingError)(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof (0, $iPRQp.ChunkProcessingError) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.config = void 0;
        this.url = void 0;
        this.ari = void 0;
        this.locale = void 0;
        this.subscribedStateSetters = new Set();
        this.onStart = void 0;
        this.onSuccess = void 0;
        this.onError = void 0;
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dDhJe.getBaseUrl)(envKey);
                return (0, $eDy2J.addPath)(baseUrl, path);
            }
            return (0, $eDy2J.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'smartlink_summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown',
                    locale: this.locale
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $5Y0oB.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $eDy2J.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.locale = props.locale;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
}

});
parcelRegister("5Y0oB", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $ac7ab9469e66450d$export$e45226161c660403);

var $eDy2J = parcelRequire("eDy2J");
async function* $ac7ab9469e66450d$export$e45226161c660403(response) {
    const reader = (0, $eDy2J.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});
parcelRegister("eDy2J", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $80037b55255ba382$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $80037b55255ba382$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $80037b55255ba382$export$ff2962de2b2c930f);
const $80037b55255ba382$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $80037b55255ba382$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $80037b55255ba382$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $80037b55255ba382$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $80037b55255ba382$export$ff2962de2b2c930f = (product)=>{
    if ($80037b55255ba382$var$isJiraProduct(product)) return $80037b55255ba382$var$AiMateJiraXProduct[product];
    return product;
};

});


parcelRegister("iPRQp", function(module, exports) {

$parcel$export(module.exports, "ChunkProcessingError", () => $518e18325393707f$export$fcec967a4b7ebd84);
class $518e18325393707f$export$fcec967a4b7ebd84 extends Error {
    constructor(error){
        super(error);
    }
}
const $518e18325393707f$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});


parcelRegister("geR8p", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $ae7dbc37116e63f9$export$6979339b6d41707e);

var $aoOGA = parcelRequire("aoOGA");
const $ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE = 100;
const $ae7dbc37116e63f9$export$6979339b6d41707e = new (0, $aoOGA.LRUMap)($ae7dbc37116e63f9$var$AI_SUMMARY_CACHE_SIZE);

});


parcelRegister("i8IAc", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $524481383d1e73c2$export$4480af2c00aa7ebe);

var $gwFzn = parcelRequire("gwFzn");

var $eIleF = parcelRequire("eIleF");
const $524481383d1e73c2$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $eIleF.useSmartLinkContext)();
    return (0, $gwFzn.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("f0eEY", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $276cdae1a40ee2d2$export$75a19de44af58722);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $3Mg7y = parcelRequire("3Mg7y");

var $kKODE = parcelRequire("kKODE");

var $afp1H = parcelRequire("afp1H");

var $c8jtw = parcelRequire("c8jtw");

var $6FZ6a = parcelRequire("6FZ6a");

var $8NMxD = parcelRequire("8NMxD");
function $276cdae1a40ee2d2$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const onCompleted = (0, $gwFzn.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $8NMxD.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $gwFzn.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).ai_summary_action
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
            spacing: "spacious",
            color: "currentColor",
            label: "Summarise with AI",
            LEGACY_fallbackIcon: (0, $c8jtw.default)
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).ai_summary_action_description
        }),
        ...props
    });
}

});
parcelRegister("c8jtw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6765627d6c82693a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $d6Fdl = parcelRequire("d6Fdl");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $6765627d6c82693a$var$AiIcon = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $d6Fdl.default), {
        ...props,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
                    fill: "var(--ds-icon, #44546F)"
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
                    fill: "var(--ds-icon, #44546F)"
                })
            ]
        })
    });
var $6765627d6c82693a$export$2e2bcd8739ae039 = $6765627d6c82693a$var$AiIcon;

});

parcelRegister("8NMxD", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $b750d65dda1a4c8d$export$82f46aa4e6535a45);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $kbh18 = parcelRequire("kbh18");

var $4Oiym = parcelRequire("4Oiym");

var $6Px5Z = parcelRequire("6Px5Z");
const $b750d65dda1a4c8d$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $kbh18.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Oiym.default), {
                    reason: error
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...message,
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6Px5Z.default), {
                                href: url,
                                children: chunks
                            })
                    }
                })
            ]
        })
    };
};

});
parcelRegister("kbh18", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $681e47ebaeddecd0$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $681e47ebaeddecd0$export$cd2e891d7f87074d);

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");
const $681e47ebaeddecd0$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $681e47ebaeddecd0$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $afp1H.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $5TXU5.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $afp1H.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $afp1H.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $afp1H.messages).ai_summary_error_generic,
                url: (0, $5TXU5.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("4Oiym", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd168d53d6086c0$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $kKODE = parcelRequire("kKODE");
const $9dd168d53d6086c0$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $9dd168d53d6086c0$export$2e2bcd8739ae039 = $9dd168d53d6086c0$var$AIEventErrorViewed;

});

parcelRegister("6Px5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $287ebec1fdd40e02$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2Nwuj = parcelRequire("2Nwuj");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");
const $287ebec1fdd40e02$var$AILearnMoreAnchor = ({ children: children, ...props })=>(0, $dh538.fg)('platform-linking-fix-a11y-in-smart-card') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
        href: (0, $5TXU5.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
        href: (0, $5TXU5.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props,
        children: children
    });
var $287ebec1fdd40e02$export$2e2bcd8739ae039 = $287ebec1fdd40e02$var$AILearnMoreAnchor;

});



parcelRegister("blblm", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $8b66580330514e65$export$cfa1d3eed9a61059);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $gt9HV = parcelRequire("gt9HV");

var $kKODE = parcelRequire("kKODE");

var $afp1H = parcelRequire("afp1H");

var $6FZ6a = parcelRequire("6FZ6a");
function $8b66580330514e65$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $gwFzn.useState)((0, $afp1H.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $gwFzn.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $afp1H.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $afp1H.messages).copy_summary_action
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt9HV))), {
            color: "currentColor",
            spacing: "spacious",
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...tooltipMessage
        }),
        tooltipOnHide: ()=>setTooltipMessage((0, $afp1H.messages).copy_summary_action_description),
        ...props
    });
}

});



parcelRegister("loGLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $12d115b9ed847307$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $fxBfz = parcelRequire("fxBfz");

var $iXCQx = parcelRequire("iXCQx");

var $kKODE = parcelRequire("kKODE");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $3eMTN = parcelRequire("3eMTN");

var $6FZ6a = parcelRequire("6FZ6a");

var $5kt6m = parcelRequire("5kt6m");

var $dvupD = parcelRequire("dvupD");

const $12d115b9ed847307$var$AutomationModal = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("jUnSU")));
const $12d115b9ed847307$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $5TXU5.ActionName).AutomationAction];
    const automationActionOnClick = (0, $gwFzn.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $dvupD.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...modalTitle
        }) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                        as: "strong",
                        children: chunks
                    }),
                br: /*#__PURE__*/ (0, $7UHDa.jsx)("br", {})
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, $7UHDa.jsx)($12d115b9ed847307$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $afp1H.messages).automation_action_title
    });
    const automationActionTooltip = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
        ...(0, $afp1H.messages).automation_action_tooltip
    });
    const automationActionIconLabel = formatMessage((0, $afp1H.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
            content: automationActionTitle,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, $5kt6m.default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        })
    });
};
var $12d115b9ed847307$export$2e2bcd8739ae039 = $12d115b9ed847307$var$AutomationAction;

});
parcelRegister("3eMTN", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $bBN8z = parcelRequire("bBN8z");
const $a2cc1d898ee1f610$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $a2cc1d898ee1f610$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext($a2cc1d898ee1f610$var$FALLBACK_API);
const $a2cc1d898ee1f610$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $gwFzn.useState)(null);
    const api = (0, $gwFzn.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bBN8z.StopPropagation), {
                        children: modal
                    })
                })),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $gwFzn.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $gwFzn.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
                fallbackRender: fallbackRender,
                onReset: onReset,
                children: element
            })
        ]
    });
};
const $a2cc1d898ee1f610$export$1fd7f5f21a6d6cb8 = ()=>(0, $gwFzn.useContext)($a2cc1d898ee1f610$export$f4c0a0f23ba57f8c);

});
parcelRegister("bBN8z", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $67004d95b34ee986$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
const $67004d95b34ee986$var$styles = null;
const $67004d95b34ee986$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $gwFzn.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        onClick: onClick,
        className: (0, $35pXk.default)([
            "_c71lidpf _p12fidpf _kqswstnw"
        ]),
        children: children
    });
};

});


parcelRegister("5kt6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $de78d57bbfdbed3e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $de78d57bbfdbed3e$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14 5L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M14 5L7 12H17L10 19",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $de78d57bbfdbed3e$export$2e2bcd8739ae039 = $de78d57bbfdbed3e$var$AutomationManualTriggersGlyph;

});

parcelRegister("dvupD", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $916427ca86a2c806$export$93e707b363eaf5c8);

var $afp1H = parcelRequire("afp1H");
const $916427ca86a2c806$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $afp1H.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $afp1H.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("jUnSU", function(module, exports) {

let $e7e5c64bf780cbfb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e7e5c64bf780cbfb$var$load("8tqgK"),
    $e7e5c64bf780cbfb$var$load("c6MKV"),
    $e7e5c64bf780cbfb$var$load("aZinD"),
    $e7e5c64bf780cbfb$var$load("ffEVr"),
    $e7e5c64bf780cbfb$var$load("joJy8"),
    $e7e5c64bf780cbfb$var$load("aHE9G"),
    $e7e5c64bf780cbfb$var$load("cqZpg")
]).then(()=>parcelRequire('iWqmE'));

});


parcelRegister("9Gqdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c15e76cd694fe8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $afp1H = parcelRequire("afp1H");

var $fUfR2 = parcelRequire("fUfR2");

var $3eMTN = parcelRequire("3eMTN");

var $6FZ6a = parcelRequire("6FZ6a");

var $1c7FN = parcelRequire("1c7FN");

const $c0c15e76cd694fe8$var$RelatedLinksModal = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("hCy7w")));
const $c0c15e76cd694fe8$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $3eMTN.useSmartLinkModal)();
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const onClick = (0, $gwFzn.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $7UHDa.jsx)($c0c15e76cd694fe8$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6FZ6a.default), {
        content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...(0, $dh538.fg)('platform-linking-visual-refresh-v2') ? (0, $afp1H.messages).related_links_view_related_links : (0, $afp1H.messages).related_links_view_related_urls
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1c7FN.default), {}),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $c0c15e76cd694fe8$export$2e2bcd8739ae039 = $c0c15e76cd694fe8$var$ViewRelatedLinksAction;

});
parcelRegister("1c7FN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0b0240da4db21c1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $kevJM = parcelRequire("kevJM");

var $e6PFM = parcelRequire("e6PFM");

var $dh538 = parcelRequire("dh538");
const $c0b0240da4db21c1$var$rotateSvg = null; /**
                         * ChildIssuesIcon but 180 degrees rotated
                         */ 
const $c0b0240da4db21c1$var$RelatedLinksActionIcon = ()=>(0, $dh538.fg)('platform-linking-visual-refresh-v2') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
        color: "currentColor",
        spacing: "spacious",
        label: "View related links..."
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        className: (0, $35pXk.default)([
            "_t9ec1sub _1e0c1o8l"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e6PFM))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        })
    });
var $c0b0240da4db21c1$export$2e2bcd8739ae039 = $c0b0240da4db21c1$var$RelatedLinksActionIcon;

});

parcelRegister("hCy7w", function(module, exports) {

let $cd4073e04ba0e1b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cd4073e04ba0e1b5$var$load("j87NQ"),
    $cd4073e04ba0e1b5$var$load("joJy8"),
    $cd4073e04ba0e1b5$var$load("aHE9G"),
    $cd4073e04ba0e1b5$var$load("aoU9B")
]).then(()=>parcelRequire('a6OFr'));

});





parcelRegister("2R1C4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ab21bb04b9ccb77$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $l7DP7 = parcelRequire("l7DP7");
const $1ab21bb04b9ccb77$var$BaseBlockStylesOld = null;
const $1ab21bb04b9ccb77$var$baseBlockStyles = null;
const $1ab21bb04b9ccb77$var$highlightRemoveStyles = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $1ab21bb04b9ccb77$var$gapsStylesOld = {
    xlarge: "_zulp1k92 _1ljq1k92",
    large: "_zulp1j6v _1ljq1j6v",
    medium: "_zulp1kwk _1ljq1kwk",
    small: "_zulp6mu8 _1ljq6mu8"
};
const $1ab21bb04b9ccb77$var$gapStyles = {
    xlarge: "_zulpv47k _1ljqv47k",
    large: "_zulppxbi _1ljqpxbi",
    medium: "_zulpu2gc _1ljqu2gc",
    small: "_zulp1b66 _1ljq1b66"
};
const $1ab21bb04b9ccb77$var$directionStyles = {
    vertical: "_2lx21bp4 _4cvr1y6m",
    horizontal: "_2lx2vrvc _4cvr1h6o"
}; /**
    * A block represents a collection of elements and actions that are arranged
    * in a row. All elements and actions should be contained within a Block.
    * @internal
    * @param {ActionGroupProps} ActionGroupProps
    * @see Action
    */ 
const $1ab21bb04b9ccb77$var$Block = ({ children: children, direction: direction = (0, $5TXU5.SmartLinkDirection).Horizontal, size: size = (0, $5TXU5.SmartLinkSize).Medium, testId: testId = 'smart-block', className: className, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd, style: style, placeholderId: placeholderId })=>{
    (0, $gwFzn.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    const ssrPlacholderProps = (0, $dh538.fg)('cc_shortcut_ssr_placeholder') ? {
        'data-ssr-placeholder': placeholderId,
        'data-ssr-placeholder-replace': placeholderId
    } : {};
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _vwz41j6v _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1ouwidpf _f6ju1ns9 _1uzp1mp2 _ytq1bjq5 _a7e8uxlv",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _1ul9idpf _1bah1y6m _fiawglyw _1uzp1mp2 _a6bxmuej _e4i5bjq5 _1gu21oju _5b7tuxlv _17ae1oju",
            "_12ji1snc _1qu2agmp _12y310yn _12ji1kw7 _syaz1kw7 _18ql1j28 _1ifmglyw _181uglyw _1rkwglyw _te17glyw _uiztglyw",
            $1ab21bb04b9ccb77$var$directionStyles[direction],
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $1ab21bb04b9ccb77$var$gapsStylesOld[size],
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $1ab21bb04b9ccb77$var$gapStyles[size],
            className
        ]),
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef,
        style: style,
        ...ssrPlacholderProps,
        children: (0, $l7DP7.renderChildren)(children, size)
    });
};
var $1ab21bb04b9ccb77$export$2e2bcd8739ae039 = $1ab21bb04b9ccb77$var$Block;

});



parcelRegister("1lLfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e07cec8e3b2cb3b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $2R1C4 = parcelRequire("2R1C4");

var $1RvsP = parcelRequire("1RvsP");

var $l7DP7 = parcelRequire("l7DP7");
const $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES = 2;
const $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES = 1;
const $8e07cec8e3b2cb3b$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $8e07cec8e3b2cb3b$var$sizeStylesOld = {
    xlarge: "_vwz41m1q _102k1k7u",
    large: "_vwz41m1q _102k1k7u",
    medium: "_vwz41k8s _102k1wto",
    small: "_vwz41k8s _102k1wto"
};
const $8e07cec8e3b2cb3b$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $8e07cec8e3b2cb3b$var$getMaxLines = (maxLines)=>{
    if (maxLines > $8e07cec8e3b2cb3b$var$MAXIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES;
    if (maxLines < $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES) return $8e07cec8e3b2cb3b$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $8e07cec8e3b2cb3b$var$ElementItemRenderer = ({ align: align = (0, $5TXU5.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $5TXU5.SmartLinkSize).Medium, maxLines: maxLines = $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES })=>{
    const elements = (0, $l7DP7.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
        align: align,
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $35pXk.default)([
            $8e07cec8e3b2cb3b$var$truncateStyles[maxLines],
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStylesOld[size],
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStyles[size]
        ]),
        children: elements
    });
}; /**
    * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
    * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
    * @public
    * @param {MetadataBlockProps} MetadataBlockProps
    * @see Block
    */ 
const $8e07cec8e3b2cb3b$var$MetadataBlock = ({ maxLines: maxLines = $8e07cec8e3b2cb3b$var$DEFAULT_MAX_LINES, status: status = (0, $5TXU5.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    const cardContext = (0, $dh538.fg)('platform-linking-flexible-card-context') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fUfR2.useFlexibleCardContext)() : undefined;
    if ((0, $dh538.fg)('platform-linking-flexible-card-context')) {
        if (primary.length === 0 && secondary.length === 0 || cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    } else {
        if (primary.length === 0 && secondary.length === 0 || status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    }
    const { size: sizeProp = (0, $5TXU5.SmartLinkSize).Medium } = blockProps;
    const size = (0, $dh538.fg)('platform-linking-flexible-card-context') ? blockProps?.size ?? cardContext?.ui?.size ?? (0, $5TXU5.SmartLinkSize).Medium : sizeProp;
    const maxLinesTotal = $8e07cec8e3b2cb3b$var$getMaxLines(maxLines);
    if ((0, $dh538.fg)('platform-linking-flexible-card-context')) return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
                items: primary,
                size: size,
                maxLines: maxLinesTotal
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)($8e07cec8e3b2cb3b$var$ElementItemRenderer, {
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                items: secondary,
                size: size,
                maxLines: maxLinesTotal
            })
        ]
    });
    const primaryElements = (0, $l7DP7.renderElementItems)(primary);
    const secondaryElements = (0, $l7DP7.renderElementItems)(secondary);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            primaryElements && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                align: (0, $5TXU5.SmartLinkAlignment).Left,
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                width: (0, $5TXU5.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $35pXk.default)([
                    $8e07cec8e3b2cb3b$var$truncateStyles[maxLinesTotal],
                    !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStylesOld[size],
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStyles[size]
                ]),
                children: primaryElements
            }),
            secondaryElements && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                width: (0, $5TXU5.SmartLinkWidth).Flexible,
                size: size,
                className: (0, $35pXk.default)([
                    $8e07cec8e3b2cb3b$var$truncateStyles[maxLinesTotal],
                    !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStylesOld[size],
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') && $8e07cec8e3b2cb3b$var$sizeStyles[size]
                ]),
                children: secondaryElements
            })
        ]
    });
};
var $8e07cec8e3b2cb3b$export$2e2bcd8739ae039 = $8e07cec8e3b2cb3b$var$MetadataBlock;

});

parcelRegister("Y5kOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da662f4fc394f2e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $7ZZE6 = parcelRequire("7ZZE6");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $3da662f4fc394f2e$var$PreviewBlock = ({ status: // eslint-disable-next-line @typescript-eslint/no-unused-vars
status = (0, $5TXU5.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $dh538.fg)('platform-linking-flexible-card-context') ? (0, $fUfR2.useFlexibleUiOptionContext)() : undefined;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7ZZE6.default), {
        ...blockProps,
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? {
            size: blockProps.size ?? ui?.size
        } : undefined,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $3da662f4fc394f2e$export$2e2bcd8739ae039 = $3da662f4fc394f2e$var$PreviewBlock;

});
parcelRegister("7ZZE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe31e0809d9677b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $ikM9T = parcelRequire("ikM9T");

var $2R1C4 = parcelRequire("2R1C4");
const $2fe31e0809d9677b$var$previewBlockStyleCommon = null;
const $2fe31e0809d9677b$var$ignoreContainerPaddingStyle = null; /**
                                           * Represents a resolved PreviewBlock, which typically contains media or other large format content.
                                           * @public
                                           * @param {PreviewBlock} PreviewBlock
                                           * @see Block
                                           */ 
const $2fe31e0809d9677b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $gwFzn.useState)(style ?? {});
    const updateStyles = (0, $gwFzn.useCallback)(()=>{
        if (placement === (0, $5TXU5.MediaPlacement).Left || placement === (0, $5TXU5.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $5TXU5.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $5TXU5.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    (0, $gwFzn.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $gwFzn.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $gwFzn.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        style: dynamicStyles,
        className: (0, $35pXk.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ikM9T.default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        })
    });
};
var $2fe31e0809d9677b$export$2e2bcd8739ae039 = $2fe31e0809d9677b$var$PreviewBlockResolvedView;

});


parcelRegister("8zS2j", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c86a1fbc149797$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $4QzTV = parcelRequire("4QzTV");

var $49WiA = parcelRequire("49WiA");

var $hJgLA = parcelRequire("hJgLA");

var $2R1C4 = parcelRequire("2R1C4");
const $60c86a1fbc149797$var$DEFAULT_MAX_LINES = 3;
const $60c86a1fbc149797$var$MAXIMUM_MAX_LINES = 6;
const $60c86a1fbc149797$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $60c86a1fbc149797$var$SnippetBlock = ({ maxLines: maxLines = $60c86a1fbc149797$var$DEFAULT_MAX_LINES, status: status = (0, $5TXU5.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, ...blockProps })=>{
    const context = (0, $dh538.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $fUfR2.useFlexibleUiContext)() : undefined;
    const renderers = (0, $dh538.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $4QzTV.useSmartLinkRenderers)() : undefined;
    const enableSnippetRenderer = (0, $dh538.fg)('cc-ai-linking-platform-snippet-renderer') ? (0, $fUfR2.useFlexibleUiOptionContext)()?.enableSnippetRenderer : undefined;
    const cardContext = (0, $dh538.fg)('platform-linking-flexible-card-context') ? (0, $fUfR2.useFlexibleCardContext)() : undefined;
    if ((0, $dh538.fg)('platform-linking-flexible-card-context')) {
        if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved && !text) return null;
    } else {
        if (status !== (0, $5TXU5.SmartLinkStatus).Resolved && !text) return null;
    }
    const snippetMaxLines = (0, $hJgLA.getMaxLines)(maxLines, $60c86a1fbc149797$var$DEFAULT_MAX_LINES, $60c86a1fbc149797$var$MAXIMUM_MAX_LINES, $60c86a1fbc149797$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $49WiA.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!(0, $dh538.fg)('cc-ai-linking-platform-snippet-renderer') || !enableSnippetRenderer) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
        ...blockProps,
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? {
            size: blockProps.size ?? cardContext?.ui?.size
        } : undefined,
        testId: `${testId}-${statusTestId}-view`,
        children: snippet
    });
    const SnippetReplacement = renderers?.snippet;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
        ...blockProps,
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? {
            size: blockProps.size ?? cardContext?.ui?.size
        } : undefined,
        testId: `${testId}-${statusTestId}-view`,
        children: SnippetReplacement ? /*#__PURE__*/ (0, $7UHDa.jsx)(SnippetReplacement, {
            fallbackText: (text || context?.snippet) ?? '',
            fallbackComponent: snippet,
            contentId: context?.meta?.objectId ?? '',
            contentType: context?.meta?.resourceType ?? '',
            cloudId: context?.meta?.tenantId ?? '',
            maxLines: snippetMaxLines,
            isHidden: isHidden
        }) : snippet
    });
};
var $60c86a1fbc149797$export$2e2bcd8739ae039 = $60c86a1fbc149797$var$SnippetBlock;

});
parcelRegister("4QzTV", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $69abf735cbcf4e67$export$c3514c024fefef57);

var $gwFzn = parcelRequire("gwFzn");

var $eIleF = parcelRequire("eIleF");
const $69abf735cbcf4e67$export$c3514c024fefef57 = ()=>{
    const context = (0, $eIleF.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $gwFzn.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});


parcelRegister("5znEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $86a4ce57d2ec07f2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $4gM1A = parcelRequire("4gM1A");

var $fUfR2 = parcelRequire("fUfR2");

var $gHW9t = parcelRequire("gHW9t");

var $7d67T = parcelRequire("7d67T");

var $8LmiG = parcelRequire("8LmiG");

var $dxIYY = parcelRequire("dxIYY");

var $3HeI9 = parcelRequire("3HeI9");
const $86a4ce57d2ec07f2$var$actionStyles = null;
const $86a4ce57d2ec07f2$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Pending:
        case (0, $5TXU5.SmartLinkStatus).Resolving:
            return 0, $3HeI9.default;
        case (0, $5TXU5.SmartLinkStatus).Resolved:
            return 0, $dxIYY.default;
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).NotFound:
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return 0, $8LmiG.default;
    }
}; /**
    * Represents a TitleBlock, which is the foundation of Flexible UI.
    * This contains an icon, the link, and any associated metadata and actions in one block.
    * The TitleBlock will also render differently given the state of the smart link.
    * This can be found in the corresponding Resolving, Resolved and Errored views.
    * @public
    * @param {TitleBlockProps} TitleBlockProps
    * @see Block
    * @see TitleBlockResolvingViewNew
    * @see TitleBlockResolvedViewNew
    * @see TitleBlockErroredViewNew
    */ 
const $86a4ce57d2ec07f2$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, status: statusProp = (0, $5TXU5.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, className: className, anchorRef: anchorRef, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...props })=>{
    const cardContext = (0, $dh538.fg)('platform-linking-flexible-card-context') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fUfR2.useFlexibleCardContext)() : undefined;
    const { status: status = (0, $5TXU5.SmartLinkStatus).Fallback, ui: ui } = cardContext || {};
    if (!(0, $dh538.fg)('platform-linking-flexible-card-unresolved-action')) {
        if (hideRetry && props.retry) delete props.retry;
    }
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $gwFzn.useState)(false);
    const onDropdownOpenChange = (0, $gwFzn.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7d67T.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gHW9t.default), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
            onClick: onClick
        },
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: (0, $dh538.fg)('platform-linking-flexible-card-context') ? ui?.theme : theme,
        anchorRef: anchorRef,
        ...overrideText
    });
    const Component = $86a4ce57d2ec07f2$var$getTitleBlockViewComponent((0, $dh538.fg)('platform-linking-flexible-card-context') ? status : statusProp);
    return /*#__PURE__*/ (0, $7UHDa.jsx)(Component, {
        ...props,
        actionGroup: actionGroup,
        className: (0, $35pXk.default)([
            showActionOnHover && !actionDropdownOpen && "_1bfhidpf _wn5xkb7n _h157kb7n",
            className
        ]),
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        ...(0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') ? {
            hideRetry: hideRetry
        } : undefined,
        icon: icon,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        size: (0, $dh538.fg)('platform-linking-flexible-card-context') ? props.size ?? ui?.size : props?.size,
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
            theme: theme
        },
        CompetitorPrompt: CompetitorPrompt,
        url: url
    });
};
var $86a4ce57d2ec07f2$export$2e2bcd8739ae039 = $86a4ce57d2ec07f2$var$TitleBlock;

});
parcelRegister("8LmiG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f525c54e6e1b7b1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $lVA2Y = parcelRequire("lVA2Y");

var $jI5eg = parcelRequire("jI5eg");

var $2R1C4 = parcelRequire("2R1C4");

var $1RvsP = parcelRequire("1RvsP");
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $7f525c54e6e1b7b1$var$TitleBlockErroredView = ({ actionGroup: actionGroup, hideRetry: hideRetry, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const hasAction = onClick !== undefined;
    const context = (0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fUfR2.useFlexibleUiContext)() : {};
    const showRetry = (0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') ? !hideRetry && Boolean(context?.actions?.[(0, $5TXU5.InternalActionName).UnresolvedAction]) : false;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-errored-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jI5eg.default), {
                overrideIcon: icon,
                position: position
            }),
            title,
            showRetry && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lVA2Y.default), {
                    testId: testId
                })
            }),
            !(0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') && descriptor && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    onClick: onClick,
                    testId: `${testId}-errored-view-message`,
                    tabIndex: hasAction ? 0 : -1,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...descriptor,
                        values: values
                    })
                })
            }),
            actionGroup
        ]
    });
};
var $7f525c54e6e1b7b1$export$2e2bcd8739ae039 = $7f525c54e6e1b7b1$var$TitleBlockErroredView;

});

parcelRegister("dxIYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1792527dfb9ef73$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");

var $5TXU5 = parcelRequire("5TXU5");

var $jI5eg = parcelRequire("jI5eg");

var $2R1C4 = parcelRequire("2R1C4");

var $1RvsP = parcelRequire("1RvsP");

var $l7DP7 = parcelRequire("l7DP7");
const $c1792527dfb9ef73$var$style = null;
const $c1792527dfb9ef73$var$styles = {
    titleBox: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
}; /**
    * This renders a fully resolved TitleBlock.
    * This should render when a Smart Link returns a valid response.
    * @see TitleBlock
    */ 
const $c1792527dfb9ef73$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, CompetitorPrompt: CompetitorPrompt, url: url, hideIconLoadingSkeleton: hideIconLoadingSkeleton, ...blockProps })=>{
    const { size: size } = blockProps;
    const metadataElements = (0, $l7DP7.renderElementItems)(metadata);
    const subtitleElements = (0, $l7DP7.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jI5eg.default), {
                overrideIcon: icon,
                position: position,
                size: size,
                hideLoadingSkeleton: hideIconLoadingSkeleton
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1RvsP.default), {
                direction: (0, $5TXU5.SmartLinkDirection).Vertical,
                width: (0, $5TXU5.SmartLinkWidth).Flexible,
                size: blockProps.size,
                className: (0, $35pXk.default)([
                    "_zulp1b66"
                ]),
                children: [
                    CompetitorPrompt && url && (0, $dh538.fg)('prompt_whiteboard_competitor_link_gate') ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                        xcss: $c1792527dfb9ef73$var$styles.titleBox,
                        children: [
                            title,
                            /*#__PURE__*/ (0, $7UHDa.jsx)(CompetitorPrompt, {
                                sourceUrl: url,
                                linkType: 'card'
                            })
                        ]
                    }) : title,
                    subtitleElements && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                        direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                        children: subtitleElements
                    })
                ]
            }),
            metadataElements && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1RvsP.default), {
                direction: (0, $5TXU5.SmartLinkDirection).Horizontal,
                align: (0, $5TXU5.SmartLinkAlignment).Right,
                position: metadataPosition ?? (0, $5TXU5.SmartLinkPosition).Center,
                size: blockProps.size,
                children: metadataElements
            }),
            actionGroup
        ]
    });
};
var $c1792527dfb9ef73$export$2e2bcd8739ae039 = $c1792527dfb9ef73$var$TitleBlockResolvedView;

});

parcelRegister("3HeI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $835b2d1437edfc5d$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $hT8Jj = parcelRequire("hT8Jj");

var $hJgLA = parcelRequire("hJgLA");

var $2R1C4 = parcelRequire("2R1C4");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $835b2d1437edfc5d$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $5TXU5.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $hJgLA.getIconWidth)(size);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`,
        children: [
            !hideIcon && /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                style: {
                    width: iconWidth,
                    height: iconWidth
                },
                "data-testid": `${testId}-icon`,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hT8Jj.LoadingSkeleton), {
                    width: iconWidth,
                    height: iconWidth,
                    testId: `${testId}-icon-loading`
                })
            }),
            title,
            actionGroup
        ]
    });
};
var $835b2d1437edfc5d$export$2e2bcd8739ae039 = $835b2d1437edfc5d$var$TitleBlockResolvingView;

});


parcelRegister("eqpYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d73a30329f2f2d2$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $8JQYF = parcelRequire("8JQYF");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $3d73a30329f2f2d2$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const cardContext = (0, $dh538.fg)('platform-linking-flexible-card-context') ? (0, $fUfR2.useFlexibleCardContext)() : undefined;
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    if ((0, $dh538.fg)('platform-linking-flexible-card-context')) {
        if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    } else {
        if (status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    }
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8JQYF.default), {
        ...props,
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? {
            size: props.size ?? cardContext?.ui?.size
        } : undefined,
        testId: testId,
        url: actionData.url
    });
};
var $3d73a30329f2f2d2$export$2e2bcd8739ae039 = $3d73a30329f2f2d2$var$AISummaryBlock;

});
parcelRegister("8JQYF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6916bf0a97d23595$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $RUXAI = parcelRequire("RUXAI");

var $5TXU5 = parcelRequire("5TXU5");

var $6KV13 = parcelRequire("6KV13");

var $dYOF2 = parcelRequire("dYOF2");

var $6bBFP = parcelRequire("6bBFP");

var $2R1C4 = parcelRequire("2R1C4");

var $6iFTJ = parcelRequire("6iFTJ");
const $6916bf0a97d23595$var$styles = null;
const $6916bf0a97d23595$var$AISummaryBlockResolvedView = (props)=>{
    (0, $RUXAI.di)((0, $6KV13.default), (0, $dYOF2.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $6KV13.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $gwFzn.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...props,
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $35pXk.default)([
            "_1reoewfl _18m9ewfl"
        ]),
        children: [
            status === 'done' && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6iFTJ.default), {
                fromCache: isSummarisedOnMountRef.current
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6bBFP.default), {
                minHeight: minHeight,
                show: showAISummary,
                showTransition: !isSummarisedOnMountRef.current,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dYOF2.default), {
                    testId: `${testId}-ai-summary`,
                    minHeight: minHeight,
                    content: content
                })
            })
        ]
    });
};
var $6916bf0a97d23595$export$2e2bcd8739ae039 = $6916bf0a97d23595$var$AISummaryBlockResolvedView;

});
parcelRegister("dYOF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9338d7fc86a81ff5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gUu2y = parcelRequire("gUu2y");

var $dh538 = parcelRequire("dh538");

var $gtWxL = parcelRequire("gtWxL");
const $9338d7fc86a81ff5$var$AISummaryCSSStyles = null;
const $9338d7fc86a81ff5$var$baseStyle = null; /**
                         * A component to render a response from AI in markdown text.
                         * @internal
                         * @param {AISummaryProps} AISummaryProps
                         */ 
const $9338d7fc86a81ff5$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gUu2y.default), {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c8dcr7 _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_11c81o8v _syaz1gjq _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $gtWxL.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $9338d7fc86a81ff5$export$2e2bcd8739ae039 = $9338d7fc86a81ff5$var$AISummary;

});
parcelRegister("gtWxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7359d17942e8a2$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
parcelRequire("gwFzn");
const $bd7359d17942e8a2$var$listStyles = null;
const $bd7359d17942e8a2$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)("ul", {
        ...props,
        className: (0, $35pXk.default)([
            "_19bvv47k _bozgv47k"
        ]),
        children: children
    });
var $bd7359d17942e8a2$export$2e2bcd8739ae039 = $bd7359d17942e8a2$var$UList;

});


parcelRegister("6bBFP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c30cfb4c0c886f9b$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
const $c30cfb4c0c886f9b$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $gwFzn.useState)(0);
    const ref = (0, $gwFzn.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $gwFzn.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref,
        children: children
    }) : null;
};
var $c30cfb4c0c886f9b$export$2e2bcd8739ae039 = $c30cfb4c0c886f9b$export$6118ed0013927eb2;

});

parcelRegister("6iFTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f9db9fca31c767$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $kKODE = parcelRequire("kKODE");
const $f7f9db9fca31c767$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $f7f9db9fca31c767$export$2e2bcd8739ae039 = $f7f9db9fca31c767$var$AIEventSummaryViewed;

});



parcelRegister("MlN47", function(module, exports) {

$parcel$export(module.exports, "default", () => $38aa18aa215cb0bb$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $8KTUJ = parcelRequire("8KTUJ");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $38aa18aa215cb0bb$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    const cardContext = (0, $dh538.fg)('platform-linking-flexible-card-context') ? (0, $fUfR2.useFlexibleCardContext)() : undefined;
    if ((0, $dh538.fg)('platform-linking-flexible-card-context')) {
        if (cardContext?.status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    } else {
        if (status !== (0, $5TXU5.SmartLinkStatus).Resolved) return null;
    }
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8KTUJ.default), {
        ...props,
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? {
            size: props.size ?? cardContext?.ui?.size
        } : undefined,
        testId: testId
    });
};
var $38aa18aa215cb0bb$export$2e2bcd8739ae039 = $38aa18aa215cb0bb$var$AIFooterBlock;

});
parcelRegister("8KTUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $92f251934aee2626$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $2ZgNz = parcelRequire("2ZgNz");

var $2R1C4 = parcelRequire("2R1C4");

var $hs8S6 = parcelRequire("hs8S6");
const $92f251934aee2626$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $5TXU5.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
        ...props,
        testId: `${testId}-resolved-view`,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2ZgNz.default), {
                ...(0, $dh538.fg)('platform-linking-visual-refresh-v1') ? {
                    appearance: 'subtle'
                } : {},
                testId: `${testId}-provider`
            }),
            actionData ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hs8S6.AIFooterMetadata), {
                ...actionData,
                testId: `${testId}-ai-metadata`
            }) : null
        ]
    });
};
var $92f251934aee2626$export$2e2bcd8739ae039 = $92f251934aee2626$var$AIFooterBlockResolvedView;

});
parcelRegister("hs8S6", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $b7fbd07145f71993$export$175228cc2c92b3b6);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $RUXAI = parcelRequire("RUXAI");

var $3Mg7y = parcelRequire("3Mg7y");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $3gadb = parcelRequire("3gadb");

var $afp1H = parcelRequire("afp1H");

var $6KV13 = parcelRequire("6KV13");

var $c8jtw = parcelRequire("c8jtw");

var $iGhkJ = parcelRequire("iGhkJ");
const $b7fbd07145f71993$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $RUXAI.di)((0, $6KV13.default));
    const { state: { status: status } } = (0, $6KV13.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $afp1H.messages).ai_summarized_info_short
                }),
                position: "bottom",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        ...tooltipProps,
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iGhkJ.InfoIcon), {
                            label: "Information",
                            LEGACY_size: "small",
                            color: "var(--ds-icon-subtle, #626F86)"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                label: "AI",
                LEGACY_size: "small",
                LEGACY_fallbackIcon: (0, $c8jtw.default),
                color: "var(--ds-icon-subtle, #626F86)"
            })
        ]
    });
};

});
parcelRegister("iGhkJ", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $b60461a0f2dc3b3a$export$2957fc44b3d2481);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4vzBZ = parcelRequire("4vzBZ");

var $lC4PM = parcelRequire("lC4PM");
const $b60461a0f2dc3b3a$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4vzBZ))), {
        color: props.color || 'currentColor',
        LEGACY_fallbackIcon: (0, $lC4PM.default),
        ...props
    });

});
parcelRegister("lC4PM", function(module, exports) {

$parcel$export(module.exports, "default", () => $433ad242eadf8517$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $433ad242eadf8517$var$InfoIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
                fill: "currentColor"
            })
        ]
    });
/**
 * __InfoIcon__
 */ const $433ad242eadf8517$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $433ad242eadf8517$var$InfoIconGlyph
    });
var $433ad242eadf8517$export$2e2bcd8739ae039 = $433ad242eadf8517$var$InfoIcon;

});





parcelRegister("f0wtW", function(module, exports) {

$parcel$export(module.exports, "default", () => $018f38f6aa2eb81b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $RUXAI = parcelRequire("RUXAI");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $jlQ9A = parcelRequire("jlQ9A");

var $1q2Dp = parcelRequire("1q2Dp");
const $018f38f6aa2eb81b$var$ignoreContainerPaddingStylesOld = null;
const $018f38f6aa2eb81b$var$ignoreContainerPaddingStyles = null;
const $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $018f38f6aa2eb81b$var$sort = (a, b)=>{
    let idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $018f38f6aa2eb81b$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
}; /**
    * Get container padding based on smart link size
    * To replace container/index.tsx getPadding() with space token for primitives
    */ 
const $018f38f6aa2eb81b$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $018f38f6aa2eb81b$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    (0, $RUXAI.di)((0, $1q2Dp.ActionFooter));
    const context = (0, $fUfR2.useFlexibleUiContext)();
    const ui = (0, $fUfR2.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $gwFzn.useState)();
    const [isLoading, setIsLoading] = (0, $gwFzn.useState)(false);
    const onLoadingChange = (0, $gwFzn.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? $018f38f6aa2eb81b$export$1af10e3728e3a644(ui?.size || (0, $5TXU5.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $gwFzn.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $gwFzn.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $gwFzn.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($018f38f6aa2eb81b$var$sort);
        return arr.map((name)=>{
            const Action = name in $jlQ9A ? $jlQ9A[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $7UHDa.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: (0, $dh538.fg)('platform-linking-flexible-card-context') ? size || ui?.size : size,
                style: padding && {
                    paddingInline: padding
                },
                hideTooltip: isLoading
            }, name) : null;
        });
    }, [
        context?.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui?.size,
        padding,
        isLoading,
        onClick
    ]);
    return actions ? /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        ref: blockRef,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g" : "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb1osq _18u01ivi _2hwxc10g",
            className
        ]),
        children: [
            actions,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1q2Dp.ActionFooter), {
                message: message,
                testId: testId
            })
        ]
    }) : null;
};
var $018f38f6aa2eb81b$export$2e2bcd8739ae039 = $018f38f6aa2eb81b$var$ActionBlock;

});
parcelRegister("1q2Dp", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $dfe1275874cc34dc$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $5L38b = parcelRequire("5L38b");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $6bBFP = parcelRequire("6bBFP");
const $dfe1275874cc34dc$var$containerStyles = null;
const $dfe1275874cc34dc$var$errorStyles = null;
const $dfe1275874cc34dc$var$styles = {
    containerStyles: "_kkk2n7od _2rkoglpi _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8dcr7 _syaz1gjq"
};
const $dfe1275874cc34dc$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5L38b))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                LEGACY_size: "small",
                testId: "action-error-icon",
                LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                size: "small"
            });
        default:
            return null;
    }
};
const $dfe1275874cc34dc$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    if ((0, $dh538.fg)('platform-linking-visual-refresh-v1')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $dfe1275874cc34dc$var$styles.containerStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6bBFP.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $dfe1275874cc34dc$var$styles.errorContentStyles,
                children: [
                    message.icon || $dfe1275874cc34dc$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $dfe1275874cc34dc$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testId": `${testId}-footer`,
        className: (0, $35pXk.default)([
            "_kkk2n7od _2rkoglpi _1yt412x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _vwz4gktf _1bsb1osq _fiawglyw",
            message.appearance === 'error' && "_bfhk1gly"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6bBFP.default), {
            isFadeIn: true,
            show: true,
            showTransition: true,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                alignBlock: "start",
                grow: "fill",
                space: "space.075",
                xcss: $dfe1275874cc34dc$var$styles.errorContentStyles,
                children: [
                    message.icon || $dfe1275874cc34dc$var$getIcon(message.appearance),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $dfe1275874cc34dc$var$styles.titleStyles,
                        children: message.title
                    })
                ]
            })
        })
    });
};

});




parcelRegister("jxaPH", function(module, exports) {

let $e3898096d74a0cb6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $e3898096d74a0cb6$var$load("8tqgK"),
    $e3898096d74a0cb6$var$load("8Sd4b"),
    $e3898096d74a0cb6$var$load("kjZZD"),
    $e3898096d74a0cb6$var$load("7jSfd"),
    $e3898096d74a0cb6$var$load("6ACCg"),
    $e3898096d74a0cb6$var$load("4HZlX"),
    $e3898096d74a0cb6$var$load("fe4be"),
    $e3898096d74a0cb6$var$load("kDqHr"),
    $e3898096d74a0cb6$var$load("ffEVr"),
    $e3898096d74a0cb6$var$load("j87NQ"),
    $e3898096d74a0cb6$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});



parcelRegister("a43ao", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $35a2bf75aa5e3412$export$f7c340395f31e832);

var $gwFzn = parcelRequire("gwFzn");

var $eIleF = parcelRequire("eIleF");

var $9gPkz = parcelRequire("9gPkz");

var $3uVVG = parcelRequire("3uVVG");

var $kKODE = parcelRequire("kKODE");

var $5TXU5 = parcelRequire("5TXU5");

var $bIll3 = parcelRequire("bIll3");

var $226XV = parcelRequire("226XV");

var $9oOnT = parcelRequire("9oOnT");

var $7DSoa = parcelRequire("7DSoa");
const $35a2bf75aa5e3412$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $7DSoa.default)();
    const invokeClientAction = (0, $9oOnT.default)({});
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $gwFzn.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5TXU5.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $gwFzn.useCallback)((metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $gwFzn.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $gwFzn.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $gwFzn.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        if (definitionId) (0, $226XV.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $gwFzn.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $gwFzn.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        const extensionKey = (0, $226XV.getExtensionKey)(details);
        const services = (0, $226XV.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $3uVVG.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $gwFzn.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $gwFzn.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("226XV", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $c8f51fccdd166527$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $c8f51fccdd166527$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $c8f51fccdd166527$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $c8f51fccdd166527$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $c8f51fccdd166527$export$81164c1570bcd038);
$parcel$export(module.exports, "getObjectName", () => $c8f51fccdd166527$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $c8f51fccdd166527$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $c8f51fccdd166527$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $c8f51fccdd166527$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $c8f51fccdd166527$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $c8f51fccdd166527$export$3f9446bb21b945a0);

var $15C2j = parcelRequire("15C2j");
const $c8f51fccdd166527$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $c8f51fccdd166527$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $15C2j.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $c8f51fccdd166527$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $c8f51fccdd166527$export$218d96312e385949 = (details)=>details?.meta?.key;
const $c8f51fccdd166527$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $c8f51fccdd166527$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $c8f51fccdd166527$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $c8f51fccdd166527$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $c8f51fccdd166527$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $c8f51fccdd166527$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $c8f51fccdd166527$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $c8f51fccdd166527$export$ac5d414b1ebfab5a = (details)=>details && $c8f51fccdd166527$export$cd41ae544cfc2a65(details) && $c8f51fccdd166527$export$795910f5f15a9633(details);
const $c8f51fccdd166527$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $c8f51fccdd166527$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $c8f51fccdd166527$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $c8f51fccdd166527$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $c8f51fccdd166527$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $c8f51fccdd166527$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $c8f51fccdd166527$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $c8f51fccdd166527$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("15C2j", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $4a791b5829124355$export$c81497d3681f24f4);
const $4a791b5829124355$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});



parcelRegister("8k046", function(module, exports) {

$parcel$export(module.exports, "default", () => $b18298ec40df52db$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $i8IAc = parcelRequire("i8IAc");

var $7DSoa = parcelRequire("7DSoa");

var $djwkb = parcelRequire("djwkb");

var $bTcnb = parcelRequire("bTcnb");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $b18298ec40df52db$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, origin: origin, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $i8IAc.useAISummaryConfig)();
    const resolve = (0, $7DSoa.default)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $gwFzn.useMemo)(()=>(0, $bTcnb.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        appearance,
        fireEvent,
        details,
        id,
        onAuthorize,
        onClick,
        origin,
        renderers,
        resolve,
        actionOptions,
        status,
        url
    ]);
    const flexibleCardContext = (0, $dh538.fg)('platform-linking-flexible-card-context') ? (0, $gwFzn.useMemo)(()=>({
            data: context,
            status: status,
            ui: ui
        }), [
        context,
        status,
        ui
    ]) : undefined;
    const retry = (0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') ? undefined : (0, $bTcnb.getRetryOptions)(url, status, details, onAuthorize);
    const { linkTitle: linkTitle, title: titleOld } = context || {};
    const title = (0, $dh538.fg)('platform-linking-flexible-card-context') ? linkTitle?.text : titleOld;
    (0, $gwFzn.useEffect)(()=>{
        switch(status){
            case (0, $5TXU5.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $5TXU5.SmartLinkStatus).Errored:
            case (0, $5TXU5.SmartLinkStatus).Fallback:
            case (0, $5TXU5.SmartLinkStatus).Forbidden:
            case (0, $5TXU5.SmartLinkStatus).NotFound:
            case (0, $5TXU5.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    if ((0, $dh538.fg)('platform-linking-flexible-card-context')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fUfR2.FlexibleCardContext).Provider, {
        value: flexibleCardContext,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $djwkb.default), {
            testId: testId,
            ...ui,
            onClick: onClick,
            retry: retry,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            status: status,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fUfR2.FlexibleUiOptionContext).Provider, {
        value: ui,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fUfR2.FlexibleUiContext).Provider, {
            value: context,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $djwkb.default), {
                testId: testId,
                ...ui,
                onClick: onClick,
                retry: retry,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                status: status,
                children: children
            })
        })
    });
};
var $b18298ec40df52db$export$2e2bcd8739ae039 = $b18298ec40df52db$var$FlexibleCard;

});
parcelRegister("djwkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a624e70f21d764cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $gwFzn = parcelRequire("gwFzn");

var $RUXAI = parcelRequire("RUXAI");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $fUfR2 = parcelRequire("fUfR2");

var $179om = parcelRequire("179om");

var $9E8aG = parcelRequire("9E8aG");

var $5znEc = parcelRequire("5znEc");

var $ipYFb = parcelRequire("ipYFb");

var $3eIDF = parcelRequire("3eIDF");
const $a624e70f21d764cf$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $179om.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child)) {
            if ((0, $9E8aG.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $5TXU5.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $5TXU5.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $a624e70f21d764cf$var$filterChildren = (children, removeBlockRestriction)=>{
    if ((0, $dh538.fg)('platform-linking-flexible-card-openness')) {
        if (removeBlockRestriction) return children;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child) && (0, $9E8aG.isFlexibleUiBlock)(child) ? child : undefined);
};
const $a624e70f21d764cf$var$renderChildren = (children, containerSize, containerTheme, status, retry, onClick, removeBlockRestriction)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child) && (0, $9E8aG.isFlexibleUiBlock)(child)) {
            if ((0, $9E8aG.isFlexibleUiTitleBlock)(child)) {
                if ((0, $9E8aG.isStyleCacheProvider)(child)) return $a624e70f21d764cf$var$updateChildrenTitleBlock(child, {
                    onClick: onClick,
                    retry: retry,
                    containerSize: containerSize,
                    status: status,
                    theme: containerTheme
                });
                else {
                    const { size: blockSize } = child.props;
                    const size = blockSize || containerSize;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(child, {
                        onClick: // @ts-expect-error
                        onClick,
                        size: size,
                        status: status,
                        theme: containerTheme,
                        ...(0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') ? undefined : {
                            retry: retry
                        }
                    });
                }
            }
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            if ((0, $9E8aG.isStyleCacheProvider)(child)) return $a624e70f21d764cf$var$updateChildrenBlock(child, size, status);
             // @ts-expect-error
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(child, {
                size: size,
                status: status
            });
        }
        if ((0, $dh538.fg)('platform-linking-flexible-card-openness')) {
            if (removeBlockRestriction) return child;
        }
    });
};
const $a624e70f21d764cf$var$updateChildrenBlock = (node, size, status)=>{
    const updatedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child) && (0, $9E8aG.isFlexibleUiBlock)(child)) // @ts-expect-error
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(child, {
            size: size,
            status: status
        });
        return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(node, {
        children: updatedChildren
    });
};
const $a624e70f21d764cf$var$updateChildrenTitleBlock = (node, { containerSize: containerSize, ...props })=>{
    const updatedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(child) && (0, $9E8aG.isFlexibleUiTitleBlock)(child)) {
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(child, {
                ...props,
                size: size
            });
        } else return child;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).cloneElement(node, {
        children: updatedChildren
    });
}; /**
    * Note: This function is only necessary for CompiledCSS within Jest tests due to the way it handles Styles.
    * CompiledCSS will inject a StyleCacheProvider around the component tree, which
    * causes the children to be wrapped in a StyleCacheProvider as well. This function recursively
    * searches for the first valid TitleBlock within the children of the StyleCacheProvider.
    */ 
const $a624e70f21d764cf$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(node)) return undefined;
    if (node.type === (0, $5znEc.default)) return node;
    if ((0, $9E8aG.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $a624e70f21d764cf$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $a624e70f21d764cf$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Children.toArray(children).map((child)=>$a624e70f21d764cf$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).isValidElement(block)) return block.props;
};
const $a624e70f21d764cf$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { title: title, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $a624e70f21d764cf$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3eIDF.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || title,
        url: url
    });
};
const $a624e70f21d764cf$var$baseStyleCommon = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $a624e70f21d764cf$var$backgroundStyleOld = null;
const $a624e70f21d764cf$var$backgroundStyles = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $a624e70f21d764cf$var$elevationStylesOld = null;
const $a624e70f21d764cf$var$elevationStyles = null;
const $a624e70f21d764cf$var$clickableContainerStyles = null; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $a624e70f21d764cf$var$gapStyleMapOld = {
    xlarge: "_zulp1jvo",
    large: "_zulph3jc",
    medium: "_zulp1qos",
    small: "_zulpfzsm"
};
const $a624e70f21d764cf$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
}; /**
    * Get container padding based on smart link size
    * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
    * at view/FlexibleCard/components/utils.tsx
    */ 
const $a624e70f21d764cf$var$getPadding = (size)=>{
    if ((0, $dh538.fg)('platform-linking-visual-refresh-v1')) switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $5TXU5.SmartLinkSize).Large:
            return '1.25rem';
        case (0, $5TXU5.SmartLinkSize).Medium:
            return '1rem';
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return '.5rem';
    }
};
const $a624e70f21d764cf$var$getGap = (size)=>{
    if ((0, $dh538.fg)('platform-linking-visual-refresh-v1')) switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $5TXU5.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $5TXU5.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
    switch(size){
        case (0, $5TXU5.SmartLinkSize).XLarge:
            return '1.25rem';
        case (0, $5TXU5.SmartLinkSize).Large:
            return '1rem';
        case (0, $5TXU5.SmartLinkSize).Medium:
            return '.5rem';
        case (0, $5TXU5.SmartLinkSize).Small:
        default:
            return '.25rem';
    }
}; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $a624e70f21d764cf$var$previewOnLeftStyleMapOld = {
    xlarge: "_19bv15sf _y5vk1k92",
    large: "_19bvf557 _y5vk1j6v",
    medium: "_19bvqox2 _y5vk1kwk",
    small: "_19bv1ltm _y5vk6mu8"
};
const $a624e70f21d764cf$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
}; // TODO: Remove on fg cleanup: platform-linking-visual-refresh-v1
const $a624e70f21d764cf$var$previewOnRightStyleMapOld = {
    xlarge: "_u5f315sf _1yob1k92",
    large: "_u5f3f557 _1yob1j6v",
    medium: "_u5f3qox2 _1yob1kwk",
    small: "_u5f31ltm _1yob6mu8"
};
const $a624e70f21d764cf$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
}; /**
    * A container is a hidden component that build the Flexible Smart Link.
    * All the Flexible UI components are wrapped inside the container.
    * It inherits the ui props from Card component and applies the custom styling
    * accordingly.
    * @internal
    * @see Block
    */ 
const $a624e70f21d764cf$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $5TXU5.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', theme: theme = (0, $5TXU5.SmartLinkTheme).Link })=>{
    (0, $RUXAI.di)((0, $ipYFb.default));
    const padding = hidePadding ? (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? '0px' : '0rem' : $a624e70f21d764cf$var$getPadding(size);
    const gap = $a624e70f21d764cf$var$getGap(size);
    const context = (0, $dh538.fg)('platform-linking-flexible-card-context') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $fUfR2.useFlexibleUiContext)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gwFzn.useContext)((0, $fUfR2.FlexibleUiContext));
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $a624e70f21d764cf$export$6f4e0540a2f2295a(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved'; // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showHoverPreview && status === 'unauthorized' && retry !== undefined;
    const containerPaddingStyles = null;
    const container = (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $a624e70f21d764cf$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $a624e70f21d764cf$var$previewOnLeftStyleMap[size],
            previewOnRight && $a624e70f21d764cf$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itzgxb _2rkob7nn _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $iAWao.default)(padding),
            "--_73mooq": (0, $iAWao.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $iAWao.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $a624e70f21d764cf$var$getLayeredLink(testId, context, children, onClick) : null,
            (0, $dh538.fg)('platform-linking-flexible-card-context') ? $a624e70f21d764cf$var$filterChildren(children, removeBlockRestriction) : $a624e70f21d764cf$var$renderChildren(children, size, theme, status, retry, onClick, removeBlockRestriction)
        ]
    }) : /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $a624e70f21d764cf$var$gapStyleMapOld[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $a624e70f21d764cf$var$previewOnLeftStyleMapOld[size],
            previewOnRight && $a624e70f21d764cf$var$previewOnRightStyleMapOld[size],
            !hideElevation && "_19itzgxb _2rkopd34 _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $iAWao.default)(padding),
            "--_73mooq": (0, $iAWao.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $iAWao.default)(previewOnRight ? gap : padding)
        },
        children: [
            clickableContainer ? $a624e70f21d764cf$var$getLayeredLink(testId, context, children, onClick) : null,
            (0, $dh538.fg)('platform-linking-flexible-card-context') ? $a624e70f21d764cf$var$filterChildren(children, removeBlockRestriction) : $a624e70f21d764cf$var$renderChildren(children, size, theme, status, retry, onClick, removeBlockRestriction)
        ]
    });
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ipYFb.default), {
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: container
    });
    return container;
};
var $a624e70f21d764cf$export$2e2bcd8739ae039 = $a624e70f21d764cf$var$Container;

});
parcelRegister("179om", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $bb043bc0c2a9f6db$export$783c1bf8fee63f80);
const $bb043bc0c2a9f6db$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("ipYFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7470566bbae8322c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5TXU5 = parcelRequire("5TXU5");

var $90Y9A = parcelRequire("90Y9A");
const $7470566bbae8322c$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $7470566bbae8322c$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $7470566bbae8322c$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $gwFzn.useState)(true);
    const mouseStopTimer = (0, $gwFzn.useRef)();
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $gwFzn.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $gwFzn.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $5TXU5.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $90Y9A.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            onMouseLeave: onMouseLeave,
            onMouseMove: onMouseMove,
            "data-testid": `${testId}-hover-card-wrapper`,
            children: children
        })
    });
};
var $7470566bbae8322c$export$2e2bcd8739ae039 = $7470566bbae8322c$var$HoverCardControl;

});
parcelRegister("90Y9A", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $1ecced62c01f09fc$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $1ecced62c01f09fc$export$f1f63acbe6ed8fb0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $RUXAI = parcelRequire("RUXAI");

var $1DWH0 = parcelRequire("1DWH0");

var $kKODE = parcelRequire("kKODE");

var $5TXU5 = parcelRequire("5TXU5");

var $bIll3 = parcelRequire("bIll3");

var $3eMTN = parcelRequire("3eMTN");

var $5MkWK = parcelRequire("5MkWK");

var $cD2gN = parcelRequire("cD2gN");
const $1ecced62c01f09fc$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $RUXAI.di)((0, $cD2gN.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $5MkWK.useSmartLinkAnalyticsContext)({
        display: (0, $5TXU5.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $cD2gN.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $gwFzn.useCallback)((error, info)=>{
        (0, $bIll3.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $bIll3.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $bIll3.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
        fallback: children,
        onError: onError,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3eMTN.SmartLinkModalProvider), {
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cD2gN.HoverCardComponent), {
                ...props,
                children: children
            })
        })
    });
};
const $1ecced62c01f09fc$var$HoverCardWithoutAnalyticsContext = (0, $1DWH0.default)()($1ecced62c01f09fc$var$HoverCardWithErrorBoundary);
const $1ecced62c01f09fc$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)($1ecced62c01f09fc$var$HoverCardWithoutAnalyticsContext, {
        ...props
    });
};
const $1ecced62c01f09fc$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)($1ecced62c01f09fc$export$57a077cc9fbe653e, {
        ...props
    });

});
parcelRegister("cD2gN", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $4bda3cea16c08f4a$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $4bda3cea16c08f4a$export$e2173dafa6a751bb);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $dh538 = parcelRequire("dh538");

var $lGgRw = parcelRequire("lGgRw");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $a43ao = parcelRequire("a43ao");

var $4QzTV = parcelRequire("4QzTV");

var $lz9QA = parcelRequire("lz9QA");

var $5MkWK = parcelRequire("5MkWK");

var $7MOSf = parcelRequire("7MOSf");

var $2Stw8 = parcelRequire("2Stw8");

var $aSUnJ = parcelRequire("aSUnJ");
const $4bda3cea16c08f4a$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $4bda3cea16c08f4a$var$FADE_IN_DELAY = 500;
const $4bda3cea16c08f4a$var$FADE_OUT_DELAY = 300;
const $4bda3cea16c08f4a$var$RESOLVE_DELAY = 100;
const $4bda3cea16c08f4a$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $aSUnJ.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, label: label, titleId: titleId, showLabel: showLabel = true })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $4bda3cea16c08f4a$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState(false);
    const fadeOutTimeoutId = (0, $gwFzn.useRef)();
    const fadeInTimeoutId = (0, $gwFzn.useRef)();
    const resolveTimeOutId = (0, $gwFzn.useRef)();
    const mousePos = (0, $gwFzn.useRef)();
    const popupOffset = (0, $gwFzn.useRef)();
    const parentSpan = (0, $gwFzn.useRef)(null);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const renderers = (0, $4QzTV.useSmartLinkRenderers)();
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const { loadMetadata: loadMetadata } = (0, $a43ao.useSmartCardActions)(id, url);
    const setMousePosition = (0, $gwFzn.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $aSUnJ.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $aSUnJ.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $gwFzn.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $gwFzn.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $4bda3cea16c08f4a$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $gwFzn.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $4bda3cea16c08f4a$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $gwFzn.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $gwFzn.useCallback)((actionId)=>{
        if (actionId === (0, $5TXU5.ActionName).PreviewAction || actionId === (0, $5TXU5.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $gwFzn.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $gwFzn.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $gwFzn.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $gwFzn.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5MkWK.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview,
            id: id,
            source: $4bda3cea16c08f4a$export$421dbc3834daf261,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Stw8.default), {
                ...hoverCardContentProps
            })
        });
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $gwFzn.useCallback)(({ 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            ref: parentSpan,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                ...triggerProps,
                // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
                onMouseOver: initShowCard,
                onMouseLeave: initHideCard,
                onMouseMove: setMousePosition,
                onClick: onChildClick,
                onContextMenu: onContextMenuClick,
                "data-testid": "hover-card-trigger-wrapper",
                ...!(0, $dh538.fg)('platform_bandicoots-smart-card-disable-aria') ? {
                    'aria-label': showLabel ? formatMessage((0, $afp1H.messages).more_information_about_this_work_item) : undefined
                } : {},
                ...(0, $dh538.fg)('fix_a11y_violation_in_hover_card_trigger') ? {
                    role: 'button'
                } : {},
                children: children
            })
        }), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition,
        formatMessage,
        showLabel
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $7MOSf.default)
    });
};

});
parcelRegister("7MOSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $52ec9dab657c3c9f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $52ec9dab657c3c9f$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ...props,
        ref: ref,
        children: children
    }));
var $52ec9dab657c3c9f$export$2e2bcd8739ae039 = $52ec9dab657c3c9f$var$CustomPopupContainer;

});

parcelRegister("2Stw8", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $44ed84e93427a03a$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $44ed84e93427a03a$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $eIleF = parcelRequire("eIleF");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $5TXU5 = parcelRequire("5TXU5");

var $226XV = parcelRequire("226XV");

var $lz9QA = parcelRequire("lz9QA");

var $ivUmx = parcelRequire("ivUmx");

var $kbh18 = parcelRequire("kbh18");

var $6wQZE = parcelRequire("6wQZE");

var $aSUnJ = parcelRequire("aSUnJ");

var $kwHRh = parcelRequire("kwHRh");

var $1pQH9 = parcelRequire("1pQH9");

var $2FHby = parcelRequire("2FHby");

var $3Yue4 = parcelRequire("3Yue4");

var $84jjJ = parcelRequire("84jjJ");

var $5GuAS = parcelRequire("5GuAS");
const $44ed84e93427a03a$export$34883cbaea18402d = 'smart-links-hover-preview';
const $44ed84e93427a03a$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const extensionKey = (0, $gwFzn.useMemo)(()=>(0, $226XV.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $lz9QA.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $gwFzn.useMemo)(()=>(0, $226XV.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $eIleF.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $kbh18.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $226XV.getServices)(linkState.details);
    const statusRef = (0, $gwFzn.useRef)(linkStatus);
    const fireEventRef = (0, $gwFzn.useRef)(fireEvent);
    const definitionIdRef = (0, $gwFzn.useRef)(definitionId);
    (0, $gwFzn.useEffect)(()=>{
        /**
		 * Must access object value via ref because its not stable
		 * and it can trigger useEffect to re-run below
		 */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const onClick = (0, $gwFzn.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $ivUmx.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $kwHRh.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $5TXU5.SmartLinkSize).Large,
        position: (0, $5TXU5.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const uiOptions = (0, $dh538.fg)('platform-linking-flexible-card-context') ? (0, $aSUnJ.flexibleUiOptions) : (0, $aSUnJ.flexibleUiOptionsOld);
    if ((0, $dh538.fg)('cc-ai-linking-platform-snippet-renderer')) uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $5TXU5.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $gwFzn.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $84jjJ.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5GuAS.default), {
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2FHby.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3Yue4.default), {
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1pQH9.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url,
        children: cardView
    }) : null;
};
var $44ed84e93427a03a$export$2e2bcd8739ae039 = $44ed84e93427a03a$var$HoverCardContent;

});
parcelRegister("aSUnJ", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $695b1b58e53b929b$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptionsOld", () => $695b1b58e53b929b$export$c973be2d9b924c51);
$parcel$export(module.exports, "flexibleUiOptions", () => $695b1b58e53b929b$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $695b1b58e53b929b$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $695b1b58e53b929b$export$e7cae8c75d768024);

var $dTk3A = parcelRequire("dTk3A");

var $5TXU5 = parcelRequire("5TXU5");
const $695b1b58e53b929b$export$8245b0eaabf3440c = (0, $dTk3A.layers).modal();
const $695b1b58e53b929b$export$c973be2d9b924c51 = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    size: (0, $5TXU5.SmartLinkSize).Medium,
    zIndex: $695b1b58e53b929b$export$8245b0eaabf3440c + 1
};
const $695b1b58e53b929b$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $5TXU5.SmartLinkSize).Medium,
    zIndex: $695b1b58e53b929b$export$8245b0eaabf3440c + 1
};
const $695b1b58e53b929b$export$a0a37c997fbcd678 = 24;
const $695b1b58e53b929b$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("kwHRh", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $11f68d60f03aaf1c$export$8548546c0aa631e6);

var $aliCf = parcelRequire("aliCf");

var $5TXU5 = parcelRequire("5TXU5");

var $imb12 = parcelRequire("imb12");
const $11f68d60f03aaf1c$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $aliCf.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $5TXU5.ElementName).AuthorGroup,
            (0, $5TXU5.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn,
                    (0, $5TXU5.ElementName).SubscriberCount,
                    (0, $5TXU5.ElementName).State
                ],
                subtitle: [
                    (0, $5TXU5.ElementName).SourceBranch,
                    (0, $5TXU5.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $5TXU5.ElementName).LatestCommit,
                    (0, $5TXU5.ElementName).CollaboratorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $imb12.extractOwnedBy)(data) ? (0, $5TXU5.ElementName).OwnedByGroup : (0, $5TXU5.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $5TXU5.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $5TXU5.ElementName).ReactCount,
                    (0, $5TXU5.ElementName).CommentCount,
                    (0, $5TXU5.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $5TXU5.ElementName).AssignedToGroup,
                        (0, $5TXU5.ElementName).State,
                        (0, $5TXU5.ElementName).StoryPoints,
                        (0, $5TXU5.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $5TXU5.ElementName).CollaboratorGroup,
                    (0, $5TXU5.ElementName).State,
                    (0, $5TXU5.ElementName).DueOn
                ],
                secondary: [
                    (0, $5TXU5.ElementName).ReactCount,
                    (0, $5TXU5.ElementName).CommentCount,
                    (0, $5TXU5.ElementName).AttachmentCount,
                    (0, $5TXU5.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $5TXU5.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn,
                    (0, $5TXU5.ElementName).State,
                    (0, $5TXU5.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).State,
                    (0, $5TXU5.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).SentOn
                ],
                tertiary: [
                    (0, $5TXU5.ElementName).ReactCount,
                    (0, $5TXU5.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $5TXU5.ElementName).AuthorGroup,
                    (0, $5TXU5.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $11f68d60f03aaf1c$var$AvatarGroupsWithNamePrefix = [
    (0, $5TXU5.ElementName).AssignedToGroup,
    (0, $5TXU5.ElementName).OwnedByGroup,
    (0, $5TXU5.ElementName).AuthorGroup
];
const $11f68d60f03aaf1c$var$toElementItem = (name)=>{
    const showNamePrefix = $11f68d60f03aaf1c$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $11f68d60f03aaf1c$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $5TXU5.ElementName)).map($11f68d60f03aaf1c$var$toElementItem);
};
const $11f68d60f03aaf1c$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $11f68d60f03aaf1c$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $11f68d60f03aaf1c$var$toElementItems(metadata.subtitle),
        primary: $11f68d60f03aaf1c$var$toElementItems(primary),
        secondary: $11f68d60f03aaf1c$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("imb12", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $4af8820ea221ff5f$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $4af8820ea221ff5f$export$4356c594f5c138d6);
$parcel$export(module.exports, "extractDueOn", () => $4af8820ea221ff5f$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $4af8820ea221ff5f$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $4af8820ea221ff5f$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $4af8820ea221ff5f$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $4af8820ea221ff5f$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $4af8820ea221ff5f$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $4af8820ea221ff5f$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $4af8820ea221ff5f$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $4af8820ea221ff5f$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $4af8820ea221ff5f$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractAttachmentCount", () => $4af8820ea221ff5f$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $4af8820ea221ff5f$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $4af8820ea221ff5f$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $4af8820ea221ff5f$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $4af8820ea221ff5f$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractReadTime", () => $4af8820ea221ff5f$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $4af8820ea221ff5f$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $4af8820ea221ff5f$export$bdcea84d1550eb9d);
$parcel$export(module.exports, "extractMetaObjectId", () => $4af8820ea221ff5f$export$bec1443e3e33b166);
$parcel$export(module.exports, "extractMetaResourceType", () => $4af8820ea221ff5f$export$11d1314ebbee594e);
$parcel$export(module.exports, "extractMetaTenantId", () => $4af8820ea221ff5f$export$92037aea7f27bf7f);

var $dLFOH = parcelRequire("dLFOH");
var $9WUug = parcelRequire("9WUug");
var $4P3K9 = parcelRequire("4P3K9");
var $4sK6R = parcelRequire("4sK6R");
const $4af8820ea221ff5f$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $4af8820ea221ff5f$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $4af8820ea221ff5f$export$b68822b76d5d51d5 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'schema:commentCount');
const $4af8820ea221ff5f$export$4356c594f5c138d6 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $4af8820ea221ff5f$export$ac56bd7a37249b48 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'endTime');
const $4af8820ea221ff5f$export$e57334ce4738e29d = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:viewCount');
const $4af8820ea221ff5f$export$44130aa92252501 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:reactCount');
const $4af8820ea221ff5f$export$c8bef3d5e550a3a = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:voteCount');
const $4af8820ea221ff5f$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $4P3K9.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4af8820ea221ff5f$export$5546969a505305 = (data)=>{
    const person = (0, $dLFOH.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $4af8820ea221ff5f$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $dLFOH.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $4af8820ea221ff5f$export$69b10d653f96288b = (data)=>{
    const persons = (0, $9WUug.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4af8820ea221ff5f$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $4sK6R.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $4af8820ea221ff5f$export$43e54589935a1ff = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'schema:programmingLanguage');
const $4af8820ea221ff5f$export$949ac6a8325b3fdb = (data)=>$4af8820ea221ff5f$var$extractLinkName(data['atlassian:mergeSource']);
const $4af8820ea221ff5f$export$8bd03a7beb5badf1 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:subscriberCount');
const $4af8820ea221ff5f$export$65362ff78a97fd8 = (data)=>$4af8820ea221ff5f$var$extractValue(data, 'atlassian:attachmentCount');
const $4af8820ea221ff5f$export$29b0ac5d2f9890cf = (data)=>$4af8820ea221ff5f$var$extractLinkName(data['atlassian:mergeDestination']);
const $4af8820ea221ff5f$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $4af8820ea221ff5f$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $4af8820ea221ff5f$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $4af8820ea221ff5f$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $4af8820ea221ff5f$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $4af8820ea221ff5f$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $4af8820ea221ff5f$export$cc4028b2878d0675 = (data)=>{
    return $4af8820ea221ff5f$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $4af8820ea221ff5f$export$b592ddecae70b61d = (data)=>{
    return $4af8820ea221ff5f$var$extractValue(data, 'dateSent');
};
const $4af8820ea221ff5f$export$bdcea84d1550eb9d = (data)=>{
    return $4af8820ea221ff5f$var$extractValue(data, 'atlassian:storyPoints');
};
const $4af8820ea221ff5f$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $4af8820ea221ff5f$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $4af8820ea221ff5f$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});
parcelRegister("dLFOH", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $338f0872276e6db6$export$38a0979ebf273662);

var $kzSaQ = parcelRequire("kzSaQ");
const $338f0872276e6db6$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $kzSaQ.extractPersonFromJsonLd)(assignedTo);
};

});

parcelRegister("4P3K9", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $4fbbebc17c1a2887$export$19ee667f3f7a6ec3);

var $kzSaQ = parcelRequire("kzSaQ");
const $4fbbebc17c1a2887$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $kzSaQ.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $kzSaQ.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});



parcelRegister("1pQH9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b39273305bd9d567$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $RUXAI = parcelRequire("RUXAI");

var $6KV13 = parcelRequire("6KV13");

var $boZKf = parcelRequire("boZKf");

var $2Stw8 = parcelRequire("2Stw8");
const $b39273305bd9d567$var$NEW_CARD_WIDTH_REM = 25;
const $b39273305bd9d567$var$HoverCardContainerStyle = null;
const $b39273305bd9d567$var$popupContainerStyles = null;
const $b39273305bd9d567$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $RUXAI.di)((0, $6KV13.default), (0, $boZKf.default));
    const { state: { status: status } } = (0, $6KV13.default)(url);
    const [showPrism, setShowPrism] = (0, $gwFzn.useState)(status === 'loading');
    (0, $gwFzn.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $7UHDa.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            "_11q7glyw _189eidpf _vchhusvi _1bsb1f23 _9spsglyw",
            !isAIEnabled && "_2rkopd34 _bfhk1bhr _16qs1cd0",
            (0, $2Stw8.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props,
        children: children
    });
    return isAIEnabled ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $boZKf.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`,
        children: container
    }) : container;
};
const $b39273305bd9d567$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $7UHDa.jsx)($b39273305bd9d567$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props,
        children: children
    });
var $b39273305bd9d567$export$2e2bcd8739ae039 = $b39273305bd9d567$var$ContentContainer;

});
parcelRegister("boZKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $211707d69efe87d9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $cOrQJ = parcelRequire("cOrQJ");

var $e42nY = parcelRequire("e42nY");

var $ciHKQ = parcelRequire("ciHKQ");
const $211707d69efe87d9$var$contentStyles = null;
const $211707d69efe87d9$var$contentStylesPrismVisible = null;
const $211707d69efe87d9$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $211707d69efe87d9$var$popupContainerStyles = null;
const $211707d69efe87d9$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $cOrQJ.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e42nY.default), {
        palette: (0, $ciHKQ.AI_BORDER_PALETTE)[colorMode] ?? (0, $ciHKQ.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $35pXk.default)([
            $211707d69efe87d9$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false']
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            className: (0, $35pXk.default)([
                "_2rkopd34 _bfhk1bhr _16qs1cd0",
                "_v5649spz",
                isVisible && "_16qs1sqb"
            ]),
            children: children
        })
    });
};
var $211707d69efe87d9$export$2e2bcd8739ae039 = $211707d69efe87d9$var$AIPrism;

});
parcelRegister("e42nY", function(module, exports) {

$parcel$export(module.exports, "default", () => $0807ece58a794f3e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $hkhVk = parcelRequire("hkhVk");
const $0807ece58a794f3e$var$borderContainerStyles = null;
const $0807ece58a794f3e$var$borderContentStyles = null; /**
                                   * The bulk of this file is originally from
                                   * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
                                   * with modifications.
                                   */ 
const $0807ece58a794f3e$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hkhVk.default), {
                palette: palette,
                isMoving: isMoving,
                className: className
            }),
            isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hkhVk.default), {
                palette: palette,
                isMoving: isMoving,
                isGlowing: true,
                className: className
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                className: (0, $35pXk.default)([
                    "_2rkoftgi _16jlkb7n _1pbykb7n"
                ]),
                children: [
                    children,
                    " "
                ]
            })
        ]
    });
var $0807ece58a794f3e$export$2e2bcd8739ae039 = $0807ece58a794f3e$var$AIGlowingBorder;

});
parcelRegister("hkhVk", function(module, exports) {

$parcel$export(module.exports, "default", () => $79bc72179a51708e$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
let $79bc72179a51708e$var$namespaceUUID = 0;
const $79bc72179a51708e$var$svgStyles = null;
const $79bc72179a51708e$var$blurredStyles = null;
const $79bc72179a51708e$var$notBlurredStyles = null; /**
                                * The bulk of this file is originally from
                                * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
                                * with modifications.
                                */ 
const $79bc72179a51708e$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $gwFzn.useRef)(null);
    const namespaceId = (0, $gwFzn.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $79bc72179a51708e$var$namespaceUUID;
        $79bc72179a51708e$var$namespaceUUID += 1;
    }
    (0, $gwFzn.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current; // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("svg" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $35pXk.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg1`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0%",
                        y1: "0",
                        x2: "400%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "0%",
                                to: "400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "400%",
                                to: "800%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg2`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "-100%",
                        x2: "0",
                        y2: "300%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "-100%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "300%",
                                to: "700%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg3`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "300%",
                        y1: "0",
                        x2: "700%",
                        y2: "0",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x1",
                                from: "300%",
                                to: "-100%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "x2",
                                from: "700%",
                                to: "300%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: `${namespaceId.current}_lg4`,
                        gradientUnits: "userSpaceOnUse",
                        x1: "0",
                        y1: "0",
                        x2: "0",
                        y2: "400%",
                        spreadMethod: "reflect",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y1",
                                from: "0%",
                                to: "-400%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("animate", {
                                begin: "indefinite",
                                attributeName: "y2",
                                from: "400%",
                                to: "0%",
                                repeatCount: "indefinite",
                                dur: "3s"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0",
                                stopColor: palette.blue
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.25",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.5",
                                stopColor: palette.yellow
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.75",
                                stopColor: palette.teal
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: palette.blue
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                strokeWidth: "8",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg1)`,
                        d: "M0 0h24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg2)`,
                        d: "M24 0v24",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg3)`,
                        d: "M24 24H0",
                        vectorEffect: "non-scaling-stroke"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        stroke: `url(#${namespaceId.current}_lg4)`,
                        d: "M0 24V0",
                        vectorEffect: "non-scaling-stroke"
                    })
                ]
            })
        ]
    });
};
var $79bc72179a51708e$export$2e2bcd8739ae039 = $79bc72179a51708e$var$AnimatedSvgContainer;

});


parcelRegister("ciHKQ", function(module, exports) {

$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $24cc1de367735950$export$23b7b83c7063ccfe);
const $24cc1de367735950$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $24cc1de367735950$export$23b7b83c7063ccfe = {
    dark: {
        blue: $24cc1de367735950$export$3088ed82e2905d1e.blue800,
        teal: $24cc1de367735950$export$3088ed82e2905d1e.teal500,
        yellow: $24cc1de367735950$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $24cc1de367735950$export$3088ed82e2905d1e.blue600,
        teal: $24cc1de367735950$export$3088ed82e2905d1e.teal300,
        yellow: $24cc1de367735950$export$3088ed82e2905d1e.yellow200
    }
};

});



parcelRegister("2FHby", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cef7844f9674345$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $eEA8O = parcelRequire("eEA8O");

var $ccHMk = parcelRequire("ccHMk");

var $79vw2 = parcelRequire("79vw2");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $7kN5H = parcelRequire("7kN5H");

var $hiPTU = parcelRequire("hiPTU");

var $afp1H = parcelRequire("afp1H");

var $8k046 = parcelRequire("8k046");

var $2R1C4 = parcelRequire("2R1C4");
var $Y5kOr = parcelRequire("Y5kOr");
const $7cef7844f9674345$var$titleBlockStylesOld = null;
const $7cef7844f9674345$var$titleBlockStyles = null;
const $7cef7844f9674345$var$mainTextStylesOld = null;
const $7cef7844f9674345$var$mainTextStyles = null;
const $7cef7844f9674345$var$connectButtonStylesOld = null;
const $7cef7844f9674345$var$connectButtonStyles = null;
const $7cef7844f9674345$var$basePreviewStylesOld = null;
const $7cef7844f9674345$var$basePreviewStyles = null;
const $7cef7844f9674345$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $79vw2.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, $7UHDa.jsx)("b", {
        children: (0, $hiPTU.default)(url)
    });
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $7kN5H.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    const ButtonComponent = (0, $dh538.fg)('platform-smart-card-remove-legacy-button') ? (0, $ccHMk.default) : (0, $eEA8O.default);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $8k046.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Y5kOr.default), {
                ignoreContainerPadding: true,
                testId: testId,
                ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $5TXU5.SmartLinkStatus).Forbidden
                },
                className: (0, $35pXk.default)([
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_13lipd34 _qrwqpd34 _otyru2gc" : "_13lipd34 _qrwqpd34 _otyru2gc"
                ])
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
                testId: `${testId}-title`,
                ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $5TXU5.SmartLinkStatus).Forbidden
                },
                className: (0, $35pXk.default)([
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_1bah1h6o _k48p1pd9 _19pku2gc" : "_1bah1h6o _k48p1pd9 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $afp1H.messages)[titleMessageKey],
                    values: {
                        product: product
                    }
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
                testId: `${testId}-content`,
                ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $5TXU5.SmartLinkStatus).Forbidden
                },
                className: (0, $35pXk.default)([
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o" : "_11c8dcr7 _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $afp1H.messages)[descriptiveMessageKey],
                    values: {
                        product: product,
                        hostname: hostname
                    }
                })
            }),
            action && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
                ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $5TXU5.SmartLinkStatus).Forbidden
                },
                className: (0, $35pXk.default)([
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_1bah1h6o _19pku2gc" : "_1bah1h6o _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)(ButtonComponent, {
                    testId: `${testId}-button`,
                    onClick: action?.promise,
                    appearance: "primary",
                    isDisabled: buttonDisabled,
                    children: action?.text
                })
            })
        ]
    });
};
var $7cef7844f9674345$export$2e2bcd8739ae039 = $7cef7844f9674345$var$HoverCardForbiddenView;

});
parcelRegister("7kN5H", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $b560bbfc29780324$export$846c1540a86749e6);

var $afp1H = parcelRequire("afp1H");

var $lgqac = parcelRequire("lgqac");

var $hI9U7 = parcelRequire("hI9U7");

var $hiPTU = parcelRequire("hiPTU");
const $b560bbfc29780324$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $hiPTU.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $hI9U7.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $lgqac.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $afp1H.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $hI9U7.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $lgqac.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $afp1H.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $hI9U7.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $afp1H.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $hI9U7.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $lgqac.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $afp1H.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("hI9U7", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $8a01ffa8e2b5674f$export$59f8830fb5467e35);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $afp1H = parcelRequire("afp1H");
const $8a01ffa8e2b5674f$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $afp1H.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("hiPTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b64bf218ef2796$export$2e2bcd8739ae039);
const $31b64bf218ef2796$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $31b64bf218ef2796$export$2e2bcd8739ae039 = $31b64bf218ef2796$var$extractHostname;

});



parcelRegister("3Yue4", function(module, exports) {

$parcel$export(module.exports, "default", () => $800f2bff5149f1e1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $5TXU5 = parcelRequire("5TXU5");

var $bIll3 = parcelRequire("bIll3");

var $8k046 = parcelRequire("8k046");

var $f0wtW = parcelRequire("f0wtW");
var $MlN47 = parcelRequire("MlN47");
var $eqpYq = parcelRequire("eqpYq");
var $1lLfV = parcelRequire("1lLfV");
var $8zS2j = parcelRequire("8zS2j");
var $5znEc = parcelRequire("5znEc");

var $kwHRh = parcelRequire("kwHRh");

var $hggyn = parcelRequire("hggyn");
const $800f2bff5149f1e1$var$hiddenSnippetStyles = null;
const $800f2bff5149f1e1$var$metadataBlockCssOld = null; /**
                                   * Moved from HoverCardContent.tsx due to CompiledCSS migration.
                                   */ 
const $800f2bff5149f1e1$var$titleBlockStyleOld = null;
const $800f2bff5149f1e1$var$titleBlockStyles = null;
const $800f2bff5149f1e1$var$snippetBlockCss = null;
const $800f2bff5149f1e1$var$actionBlockCss = null;
const $800f2bff5149f1e1$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $bIll3.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $5TXU5.CardDisplay).HoverCardPreview
        }); // UFO will disregard this if authentication experience has not yet been started
        (0, $bIll3.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $5TXU5.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $5TXU5.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $gwFzn.useMemo)(()=>{
        return (0, $kwHRh.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(0);
    const snippetBlockRef = (0, $gwFzn.useRef)(null);
    const onSnippetRender = (0, $gwFzn.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $hggyn.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8zS2j.default), {
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
            status: (0, $5TXU5.SmartLinkStatus).Resolved
        },
        className: (0, $35pXk.default)([
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $8k046.default), {
        ...flexibleCardProps,
        children: [
            imagePreview,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5znEc.default), {
                ...titleBlockProps,
                metadataPosition: (0, $5TXU5.SmartLinkPosition).Top,
                ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $5TXU5.SmartLinkStatus).Resolved
                },
                className: (0, $35pXk.default)([
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9" : "_zulpu2gc _quenui7n _oebj1txw _x7z0u2gc _1ljqu2gc _13mh1pd9"
                ])
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1lLfV.default), {
                primary: primary,
                secondary: secondary,
                maxLines: 1,
                size: (0, $5TXU5.SmartLinkSize).Medium,
                ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $5TXU5.SmartLinkStatus).Resolved
                },
                className: (0, $35pXk.default)([
                    !(0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_zulpidpf _2aco1o8v _fmt31ohn _yklxu2gc _w3muu2gc _ia0l11wp _3tmpu2gc"
                ])
            }),
            isAISummaryEnabled ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eqpYq.default), {
                aiSummaryMinHeight: aiSummaryMinHeight,
                placeholder: snippet,
                ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $5TXU5.SmartLinkStatus).Resolved
                }
            }) : snippet,
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8zS2j.default), {
                testId: "hidden-snippet",
                onRender: onSnippetRender,
                blockRef: snippetBlockRef,
                ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
                    status: (0, $5TXU5.SmartLinkStatus).Resolved
                },
                isHidden: true,
                className: (0, $35pXk.default)([
                    "_3um015vq _kqswstnw"
                ])
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f0wtW.default), {
                onClick: onActionClick,
                spaceInline: "space.100",
                className: (0, $35pXk.default)([
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') && "_n3td1b66"
                ])
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $MlN47.default), {})
        ]
    });
};
var $800f2bff5149f1e1$export$2e2bcd8739ae039 = $800f2bff5149f1e1$var$HoverCardResolvedView;

});
parcelRegister("hggyn", function(module, exports) {

$parcel$export(module.exports, "default", () => $57f598b4bbab12f1$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $5ctc0 = parcelRequire("5ctc0");

var $Y5kOr = parcelRequire("Y5kOr");
const $57f598b4bbab12f1$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $gwFzn.useRef)(false);
    const previewBlockRef = (0, $gwFzn.useRef)(null);
    const [showPreview, setShowPreview] = (0, $gwFzn.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $gwFzn.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $gwFzn.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
                borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
                marginBottom: (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "var(--ds-space-100, 8px)" : '0.5rem',
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $gwFzn.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $gwFzn.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $5ctc0.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $Y5kOr.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $57f598b4bbab12f1$export$2e2bcd8739ae039 = $57f598b4bbab12f1$var$ImagePreview;

});
parcelRegister("5ctc0", function(module, exports) {

$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $0f22550e7379302c$export$a79836076066b8b6);

var $lyclm = parcelRequire("lyclm");
var $iFI9k = parcelRequire("iFI9k");

var $5TXU5 = parcelRequire("5TXU5");
const $0f22550e7379302c$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $iFI9k.extractImage)(data);
    return url ? {
        type: (0, $5TXU5.MediaType).Image,
        url: url
    } : undefined;
};
var $0f22550e7379302c$export$2e2bcd8739ae039 = $0f22550e7379302c$var$extractPreview;
const $0f22550e7379302c$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        if (!url) {
            const provider = (0, $lyclm.extractEntityProvider)(response);
            url = provider?.image;
        }
        return url ? {
            type: (0, $5TXU5.MediaType).Image,
            url: url
        } : undefined;
    }
    return $0f22550e7379302c$var$extractPreview(response.data);
};

});
parcelRegister("iFI9k", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $09d93d7349277f66$export$4c753a1297cb9805);

var $kzBLz = parcelRequire("kzBLz");
const $09d93d7349277f66$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});




parcelRegister("84jjJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9431eb578da6d4e9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2R1C4 = parcelRequire("2R1C4");

var $7d67T = parcelRequire("7d67T");

var $hT8Jj = parcelRequire("hT8Jj");

var $4NlKF = parcelRequire("4NlKF");

var $aSUnJ = parcelRequire("aSUnJ");
const $9431eb578da6d4e9$var$loadingViewContainer = null;
const $9431eb578da6d4e9$var$skeletonContainer = null;
const $9431eb578da6d4e9$var$titleStyle = null;
const $9431eb578da6d4e9$var$titleBlockStyles = null;
const $9431eb578da6d4e9$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $aSUnJ.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7d67T.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        className: (0, $35pXk.default)([
            "_1e0c1txw _2lx21bp4 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
            className: (0, $35pXk.default)([
                "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
                    ...titleBlockProps,
                    testId: `${testId}-title-block`,
                    className: (0, $35pXk.default)([
                        "_zulpu2gc _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4NlKF.default), {
                            render: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hT8Jj.LoadingSkeleton), {}),
                            size: size
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
                            "data-testid": `${testId}-title`,
                            className: (0, $35pXk.default)([
                                "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
                            ]),
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hT8Jj.LoadingSkeleton), {
                                height: `${lineHeightRem}rem`
                            })
                        }),
                        actionGroup
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hT8Jj.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hT8Jj.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem * 3}rem`
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hT8Jj.LoadingSkeleton), {
                            width: `${skeletonWidth}rem`,
                            height: `${lineHeightRem}rem`
                        })
                    ]
                })
            ]
        })
    });
};
var $9431eb578da6d4e9$export$2e2bcd8739ae039 = $9431eb578da6d4e9$var$HoverCardLoadingView;

});

parcelRegister("5GuAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa8b3375130275dc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4jR19 = parcelRequire("4jR19");

var $79vw2 = parcelRequire("79vw2");

var $dh538 = parcelRequire("dh538");

var $kKODE = parcelRequire("kKODE");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");

var $a43ao = parcelRequire("a43ao");

var $226XV = parcelRequire("226XV");

var $86rMt = parcelRequire("86rMt");

var $8k046 = parcelRequire("8k046");

var $2R1C4 = parcelRequire("2R1C4");

var $7d67T = parcelRequire("7d67T");

var $jI5eg = parcelRequire("jI5eg");
const $aa8b3375130275dc$var$connectButtonStylesOld = null;
const $aa8b3375130275dc$var$connectButtonStyles = null;
const $aa8b3375130275dc$var$titleBlockStylesOld = null;
const $aa8b3375130275dc$var$titleBlockStyles = null;
const $aa8b3375130275dc$var$mainTextStylesOld = null;
const $aa8b3375130275dc$var$mainTextStyles = null;
const $aa8b3375130275dc$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $79vw2.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $226XV.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $a43ao.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleAuthorize = (0, $gwFzn.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $5TXU5.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $gwFzn.useMemo)(()=>[
            {
                name: (0, $5TXU5.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...(0, $afp1H.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $8k046.default), {
        ...flexibleCardProps,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2R1C4.default), {
                testId: `${testId}-title`,
                className: (0, $35pXk.default)([
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_zulpu2gc _13mh1pd9" : "_zulp5l1i _bpsp1wq8"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jI5eg.default), {}),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                        ...(0, $afp1H.messages).connect_link_account_card_name,
                        values: {
                            context: providerName
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
                testId: `${testId}-content`,
                className: (0, $35pXk.default)([
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_11c8dcr7 _19pku2gc" : "_11c8dcr7 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $86rMt.default), {
                        providerName: providerName,
                        isProductIntegrationSupported: isProductIntegrationSupported
                    })
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2R1C4.default), {
                testId: `${testId}-button`,
                className: (0, $35pXk.default)([
                    (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? "_1bahesu3 _19pku2gc" : "_1bahesu3 _19pku2gc"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7d67T.default), {
                    items: actions,
                    appearance: "primary"
                })
            })
        ]
    });
};
var $aa8b3375130275dc$export$2e2bcd8739ae039 = $aa8b3375130275dc$var$HoverCardUnauthorisedView;

});
parcelRegister("86rMt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a1690bb7ffa863c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $dh538 = parcelRequire("dh538");

var $auNCB = parcelRequire("auNCB");

var $kKODE = parcelRequire("kKODE");

var $5TXU5 = parcelRequire("5TXU5");

var $afp1H = parcelRequire("afp1H");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $4a1690bb7ffa863c$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $gwFzn.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $afp1H.messages).learn_more_about_connecting_account : (0, $afp1H.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            providerName ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $afp1H.messages).connect_unauthorised_account_description,
                values: {
                    context: providerName
                }
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...(0, $afp1H.messages).connect_unauthorised_account_description_no_provider
            }),
            ' ',
            (0, $dh538.fg)('platform-linking-visual-refresh-v1') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $auNCB.default), {
                href: isProductIntegrationSupported ? (0, $5TXU5.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5TXU5.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                testId: `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...learnMoreMessage
                })
            }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, $7UHDa.jsx)("a", {
                href: isProductIntegrationSupported ? (0, $5TXU5.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $5TXU5.CONTENT_URL_SECURITY_AND_PERMISSIONS),
                target: "_blank",
                "data-testid": `${testId}-learn-more`,
                onClick: handleLearnMoreClick,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: {
                    textDecoration: 'underline'
                },
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...learnMoreMessage
                })
            })
        ]
    });
};
var $4a1690bb7ffa863c$export$2e2bcd8739ae039 = $4a1690bb7ffa863c$var$UnauthorisedViewContent;

});






parcelRegister("3eIDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $079645fb666cbdaa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $4gM1A = parcelRequire("4gM1A");
const $079645fb666cbdaa$var$styles = null; /**
                      * An anchor component to cover the entire container creating a clickable area.
                      * @internal
                      * @see `clickableContainer`
                      */ 
const $079645fb666cbdaa$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $4gM1A.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)("a" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1,
        children: text
    });
};
var $079645fb666cbdaa$export$2e2bcd8739ae039 = $079645fb666cbdaa$var$LayeredLink;

});


parcelRegister("bTcnb", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $bce69080918b9451$export$e68aec76e359e401);
$parcel$export(module.exports, "getRetryOptions", () => $bce69080918b9451$export$f3d3482baaff4bf6);

var $79vw2 = parcelRequire("79vw2");

var $dh538 = parcelRequire("dh538");

var $5TXU5 = parcelRequire("5TXU5");

var $7kN5H = parcelRequire("7kN5H");

var $ftgZs = parcelRequire("ftgZs");

var $6f2GC = parcelRequire("6f2GC");

var $5ctc0 = parcelRequire("5ctc0");

var $575f6 = parcelRequire("575f6");

var $kX2ZH = parcelRequire("kX2ZH");

var $afp1H = parcelRequire("afp1H");

var $ivUmx = parcelRequire("ivUmx");

var $4ibS1 = parcelRequire("4ibS1");
const $bce69080918b9451$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Pending:
        case (0, $5TXU5.SmartLinkStatus).Resolving:
            return (0, $dh538.fg)('platform-linking-flexible-card-context') ? {
                linkTitle: (0, $6f2GC.default)(status, url, response, onClick),
                url: url
            } : {
                title: url,
                url: url
            };
        case (0, $5TXU5.SmartLinkStatus).Resolved:
            return (0, $ftgZs.default)(params);
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).NotFound:
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                title: (0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : url,
                linkIcon: (0, $575f6.extractErrorIcon)(response, status),
                linkTitle: (0, $dh538.fg)('platform-linking-flexible-card-context') ? (0, $6f2GC.default)(status, url, response, onClick) : undefined,
                preview: (0, $5ctc0.extractSmartLinkPreviewImage)(response),
                provider: (0, $kX2ZH.extractSmartLinkProviderIcon)(response),
                actions: (0, $dh538.fg)('platform-linking-flexible-card-unresolved-action') ? {
                    [(0, $5TXU5.InternalActionName).UnresolvedAction]: $bce69080918b9451$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                } : undefined
            };
    }
};
const $bce69080918b9451$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $dh538.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $dh538.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $bce69080918b9451$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $79vw2.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $4ibS1.getForbiddenJsonLd)().meta;
            const access = (0, $7kN5H.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $bce69080918b9451$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $afp1H.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $ivUmx.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $afp1H.messages).connect_link_account_card_name,
                onClick: (0, $ivUmx.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $5TXU5.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $afp1H.messages).cannot_find_link
            };
    }
};

});
parcelRegister("ftgZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc6e2a82dcbb4550$export$2e2bcd8739ae039);

var $9WUug = parcelRequire("9WUug");
var $4P3K9 = parcelRequire("4P3K9");
var $79vw2 = parcelRequire("79vw2");
var $aliCf = parcelRequire("aliCf");

var $dh538 = parcelRequire("dh538");

var $3Qsou = parcelRequire("3Qsou");

var $d5zG4 = parcelRequire("d5zG4");

var $5ftEU = parcelRequire("5ftEU");

var $6f2GC = parcelRequire("6f2GC");

var $5ctc0 = parcelRequire("5ctc0");

var $5kcPY = parcelRequire("5kcPY");

var $1mkpa = parcelRequire("1mkpa");

var $575f6 = parcelRequire("575f6");

var $kX2ZH = parcelRequire("kX2ZH");

var $dUZ8o = parcelRequire("dUZ8o");

var $imb12 = parcelRequire("imb12");
const $cc6e2a82dcbb4550$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, origin: origin, renderers: renderers, resolve: resolve, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $79vw2.extractSmartLinkUrl)(response);
    return {
        actions: (0, $d5zG4.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            url: props.url
        }),
        appliedToComponentsCount: (0, $imb12.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $imb12.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $imb12.extractAttachmentCount)(data),
        authorGroup: (0, $9WUug.extractPersonCreatedBy)(data),
        ownedByGroup: (0, $4P3K9.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $5ftEU.extractPersonsUpdatedBy)(data),
        commentCount: (0, $imb12.extractCommentCount)(data),
        viewCount: (0, $imb12.extractViewCount)(data),
        reactCount: (0, $imb12.extractReactCount)(data),
        voteCount: (0, $imb12.extractVoteCount)(data),
        checklistProgress: (0, $imb12.extractChecklistProgress)(data),
        createdBy: (0, $79vw2.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $imb12.extractOwnedBy)(data),
        assignedTo: (0, $imb12.extractAssignedTo)(data),
        createdOn: (0, $79vw2.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $imb12.extractDueOn)(data),
        latestCommit: (0, $dUZ8o.extractLatestCommit)(data),
        linkIcon: (0, $575f6.extractSmartLinkIcon)(response),
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') && {
            linkTitle: (0, $6f2GC.default)(status, props.url, response, onClick)
        },
        location: (0, $imb12.extractLocation)(data),
        modifiedBy: (0, $79vw2.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $79vw2.extractSmartLinkModifiedOn)(response),
        preview: (0, $5ctc0.extractSmartLinkPreviewImage)(response),
        priority: (0, $5kcPY.default)(data),
        provider: (0, $kX2ZH.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $imb12.extractProgrammingLanguage)(data),
        readTime: (0, $imb12.extractReadTime)(data),
        sentOn: (0, $imb12.extractSentOn)(data),
        snippet: (0, $3Qsou.extractSummary)(data) || undefined,
        sourceBranch: (0, $imb12.extractSourceBranch)(data),
        state: (0, $1mkpa.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve),
        subscriberCount: (0, $imb12.extractSubscriberCount)(data),
        subTasksProgress: (0, $imb12.extractSubTasksProgress)(data),
        storyPoints: (0, $imb12.extractStoryPoints)(data),
        targetBranch: (0, $imb12.extractTargetBranch)(data),
        ...(0, $dh538.fg)('platform-linking-flexible-card-context') ? undefined : {
            title: (0, $79vw2.extractSmartLinkTitle)(response) || url
        },
        url: url,
        ari: (0, $79vw2.extractSmartLinkAri)(response),
        ...(0, $dh538.fg)('platform-linking-visual-refresh-v2') && {
            type: (0, $aliCf.extractType)(data)
        },
        ...(0, $dh538.fg)('cc-ai-linking-platform-snippet-renderer') && {
            meta: {
                objectId: (0, $imb12.extractMetaObjectId)(meta),
                resourceType: (0, $imb12.extractMetaResourceType)(meta),
                tenantId: (0, $imb12.extractMetaTenantId)(meta)
            }
        }
    };
};
var $cc6e2a82dcbb4550$export$2e2bcd8739ae039 = $cc6e2a82dcbb4550$var$extractFlexibleUiContext;

});
parcelRegister("3Qsou", function(module, exports) {

$parcel$export(module.exports, "extractSummary", () => $89d55dabaa02345a$export$db5a8500f6b6286e);
const $89d55dabaa02345a$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});

parcelRegister("d5zG4", function(module, exports) {

$parcel$export(module.exports, "extractFlexibleCardActions", () => $97dbdd6e7a108abb$export$abe8d0ca1daa1755);

var $5TXU5 = parcelRequire("5TXU5");

var $bZe40 = parcelRequire("bZe40");

var $fhiZH = parcelRequire("fhiZH");

var $1uqRs = parcelRequire("1uqRs");

var $aW1vb = parcelRequire("aW1vb");

var $6WoWK = parcelRequire("6WoWK");

var $euIFk = parcelRequire("euIFk");

var $cN6vm = parcelRequire("cN6vm");
const $97dbdd6e7a108abb$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, response: response, url: url })=>{
    const action = {
        [(0, $5TXU5.ActionName).CopyLinkAction]: (0, $1uqRs.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5TXU5.ActionName).DownloadAction]: (0, $aW1vb.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $5TXU5.ActionName).FollowAction]: (0, $6WoWK.default)(response, actionOptions, id),
        [(0, $5TXU5.ActionName).PreviewAction]: (0, $euIFk.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response
        }),
        [(0, $5TXU5.ActionName).AutomationAction]: (0, $fhiZH.extractAutomationAction)(response),
        [(0, $5TXU5.InternalActionName).AISummaryAction]: (0, $bZe40.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $5TXU5.InternalActionName).ViewRelatedLinksAction]: (0, $cN6vm.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("bZe40", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $e8673adc3e68b528$export$e7f7a50a8b8932df);

var $2LWAa = parcelRequire("2LWAa");

var $kbh18 = parcelRequire("kbh18");

var $hcMBV = parcelRequire("hcMBV");
const $e8673adc3e68b528$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).AISummaryAction, actionOptions) || !(0, $kbh18.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("2LWAa", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $c909c594c41baf78$export$2487b058456cca75);
const $c909c594c41baf78$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});


parcelRegister("fhiZH", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $b78ad704e0ae6105$export$f913cc6abf3ec084);

var $5TXU5 = parcelRequire("5TXU5");
const $b78ad704e0ae6105$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $5TXU5.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("1uqRs", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkClientAction", () => $8c2f74fe1be4da73$export$31ddd5c40039ce53);

var $8TLGw = parcelRequire("8TLGw");
const $8c2f74fe1be4da73$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $8TLGw.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("8TLGw", function(module, exports) {

$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $fb7e4596bd230c75$export$5ec86886067a062d);

var $l6lJr = parcelRequire("l6lJr");

var $5TXU5 = parcelRequire("5TXU5");
var $hcMBV = parcelRequire("hcMBV");

var $226XV = parcelRequire("226XV");

var $2LWAa = parcelRequire("2LWAa");
const $fb7e4596bd230c75$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).CopyLinkAction, actionOptions)) return;
    const data = response.data;
    const url = (0, $l6lJr.extractLink)(data);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $5TXU5.ActionName).CopyLinkAction,
        definitionId: (0, $226XV.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $226XV.getExtensionKey)(response),
        id: id,
        resourceType: (0, $226XV.getResourceType)(response)
    };
};

});


parcelRegister("aW1vb", function(module, exports) {

$parcel$export(module.exports, "extractDownloadClientAction", () => $9de9c0ec786639a8$export$f6c386869a352b1f);

var $eB2Ls = parcelRequire("eB2Ls");
const $9de9c0ec786639a8$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $eB2Ls.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("eB2Ls", function(module, exports) {

$parcel$export(module.exports, "extractInvokeDownloadAction", () => $dd9cc1ea5f7a02ad$export$ea97cd34c2ca86de);

var $5TXU5 = parcelRequire("5TXU5");
var $hcMBV = parcelRequire("hcMBV");

var $226XV = parcelRequire("226XV");

var $ivUmx = parcelRequire("ivUmx");

var $2LWAa = parcelRequire("2LWAa");

var $fcTJU = parcelRequire("fcTJU");

var $kwfiJ = parcelRequire("kwfiJ");
const $dd9cc1ea5f7a02ad$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $fcTJU.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $kwfiJ.extractDownloadUrl)(data);
        return {
            actionFn: async ()=>(0, $ivUmx.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $5TXU5.ActionName).DownloadAction,
            definitionId: (0, $226XV.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $226XV.getExtensionKey)(response),
            id: id,
            resourceType: (0, $226XV.getResourceType)(response)
        };
    }
};

});
parcelRegister("fcTJU", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $bcab3e29f50fe6bc$export$8f031784a3a03b23);
const $bcab3e29f50fe6bc$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});

parcelRegister("kwfiJ", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $5bfe619ac7055161$export$9682e3ac9d184e95);
const $5bfe619ac7055161$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});



parcelRegister("6WoWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2c6b1a5cddedae9$export$2e2bcd8739ae039);

var $l6lJr = parcelRequire("l6lJr");
var $aliCf = parcelRequire("aliCf");

var $4X6f2 = parcelRequire("4X6f2");

var $226XV = parcelRequire("226XV");

var $2LWAa = parcelRequire("2LWAa");

var $hcMBV = parcelRequire("hcMBV");

var $4LRV4 = parcelRequire("4LRV4");
const $e2c6b1a5cddedae9$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $226XV.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $4LRV4.default)(data);
    const type = (0, $aliCf.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $4X6f2.SmartLinkActionType).FollowEntityAction || actionName === (0, $4X6f2.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $l6lJr.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $4X6f2.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $e2c6b1a5cddedae9$export$2e2bcd8739ae039 = $e2c6b1a5cddedae9$var$extractFollowAction;

});
parcelRegister("4LRV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e8dd570acdd9ca$export$2e2bcd8739ae039);
const $22e8dd570acdd9ca$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $22e8dd570acdd9ca$export$2e2bcd8739ae039 = $22e8dd570acdd9ca$var$extractServerAction;

});


parcelRegister("euIFk", function(module, exports) {

$parcel$export(module.exports, "extractPreviewClientAction", () => $eeffcaf65b928966$export$9f0d9100b079448);

var $4gOU2 = parcelRequire("4gOU2");
const $eeffcaf65b928966$export$9f0d9100b079448 = (param)=>{
    const invokeAction = (0, $4gOU2.extractInvokePreviewAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("4gOU2", function(module, exports) {

$parcel$export(module.exports, "extractInvokePreviewAction", () => $0216c8d70d641474$export$caf83f49e52ac0bb);

var $l6lJr = parcelRequire("l6lJr");
var $9JHBV = parcelRequire("9JHBV");
var $ccQw1 = parcelRequire("ccQw1");
var $hUifo = parcelRequire("hUifo");

var $5TXU5 = parcelRequire("5TXU5");
var $hcMBV = parcelRequire("hcMBV");

var $226XV = parcelRequire("226XV");

var $2LWAa = parcelRequire("2LWAa");

var $29GtD = parcelRequire("29GtD");

var $fHhRu = parcelRequire("fHhRu");

var $cUjGA = parcelRequire("cUjGA");

var $575f6 = parcelRequire("575f6");

var $eB2Ls = parcelRequire("eB2Ls");

var $dOvUN = parcelRequire("dOvUN");
const $0216c8d70d641474$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response } = param;
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $9JHBV.extractPreview)(data, 'web')?.src;
    if (src) {
        const url = (0, $l6lJr.extractLink)(data);
        const extensionKey = (0, $226XV.getExtensionKey)(response);
        return {
            actionFn: async ()=>(0, $29GtD.openEmbedModal)({
                    fireEvent: fireEvent,
                    extensionKey: extensionKey,
                    id: id,
                    invokeDownloadAction: (0, $eB2Ls.extractInvokeDownloadAction)(param),
                    invokeViewAction: (0, $dOvUN.extractInvokeViewAction)(param, true),
                    isSupportTheming: (0, $fHhRu.extractIsSupportTheming)(meta),
                    isTrusted: (0, $cUjGA.extractIsTrusted)(meta),
                    linkIcon: (0, $575f6.extractLinkIcon)(response),
                    providerName: (0, $ccQw1.extractProvider)(data)?.text,
                    onClose: onClose,
                    origin: origin,
                    src: src,
                    title: (0, $hUifo.extractTitle)(data),
                    url: url
                }),
            actionSubjectId: 'invokePreviewScreen',
            actionType: (0, $5TXU5.ActionName).PreviewAction,
            display: display,
            extensionKey: extensionKey,
            id: id
        };
    }
};

});
parcelRegister("29GtD", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $76698d8a364f0519$export$7859f96cd8cff034);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $4FhhO = parcelRequire("4FhhO");

var $hlhtG = parcelRequire("hlhtG");
const $76698d8a364f0519$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $76698d8a364f0519$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $76698d8a364f0519$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($76698d8a364f0519$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $76698d8a364f0519$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("3xgjO"));
    (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).render(/*#__PURE__*/ (0, $7UHDa.jsx)((0, $hlhtG.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)(Modal.default, {
            ...props,
            iframeName: $76698d8a364f0519$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($4FhhO))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })
    }), popupMountPoint);
}

});
parcelRegister("3xgjO", function(module, exports) {

let $29311cb1984c168f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $29311cb1984c168f$var$load("j87NQ"),
    $29311cb1984c168f$var$load("iiqDR"),
    $29311cb1984c168f$var$load("ffEVr"),
    $29311cb1984c168f$var$load("8tqgK"),
    $29311cb1984c168f$var$load("dUKeO"),
    $29311cb1984c168f$var$load("cXPC0"),
    $29311cb1984c168f$var$load("bFS2f"),
    $29311cb1984c168f$var$load("joJy8"),
    $29311cb1984c168f$var$load("aHE9G"),
    $29311cb1984c168f$var$load("kDLrp")
]).then(()=>parcelRequire('6as51'));

});


parcelRegister("fHhRu", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $0f61633c27d66d37$export$38d755f52cdf4acb);

var $15w8R = parcelRequire("15w8R");
const $0f61633c27d66d37$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $15w8R.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("15w8R", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $c903d02fdad660aa$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $c903d02fdad660aa$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $c903d02fdad660aa$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $c903d02fdad660aa$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $c903d02fdad660aa$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $c903d02fdad660aa$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $c903d02fdad660aa$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $c903d02fdad660aa$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $c903d02fdad660aa$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $c903d02fdad660aa$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $c903d02fdad660aa$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $c903d02fdad660aa$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $c903d02fdad660aa$export$fe44ce30fd8d131b);
const $c903d02fdad660aa$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $c903d02fdad660aa$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $c903d02fdad660aa$export$84a73a0383f58180 = 'JiraTask';
const $c903d02fdad660aa$export$c6c83963a9378a67 = 'JiraSubTask';
const $c903d02fdad660aa$export$58af3c426c111a6d = 'JiraStory';
const $c903d02fdad660aa$export$ac9898a63417219e = 'JiraBug';
const $c903d02fdad660aa$export$54db5e3fb12e39cd = 'JiraEpic';
const $c903d02fdad660aa$export$2f54a5a217202c85 = 'JiraIncident';
const $c903d02fdad660aa$export$d097371052bfc411 = 'JiraServiceRequest';
const $c903d02fdad660aa$export$efd9452ad16c6676 = 'JiraChange';
const $c903d02fdad660aa$export$2e7e70abb5d81f67 = 'JiraProblem';
const $c903d02fdad660aa$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $c903d02fdad660aa$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});


parcelRegister("cUjGA", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $b09d72911e8b5283$export$4f3ffbb500daac5a);
const $b09d72911e8b5283$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("575f6", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $48fd38a3919fb96d$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $48fd38a3919fb96d$export$bdd29be9b0395931);
$parcel$export(module.exports, "extractSmartLinkIcon", () => $48fd38a3919fb96d$export$35040aed9264b11c);

var $lyclm = parcelRequire("lyclm");

var $5TXU5 = parcelRequire("5TXU5");

var $2CpuW = parcelRequire("2CpuW");

var $kn2iQ = parcelRequire("kn2iQ");

var $kX2ZH = parcelRequire("kX2ZH");
const $48fd38a3919fb96d$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $2CpuW.default)(data, renderers);
    return {
        ...(0, $kn2iQ.default)(data),
        render: render
    };
};
const $48fd38a3919fb96d$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $kX2ZH.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $5TXU5.SmartLinkStatus).Forbidden:
        case (0, $5TXU5.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $5TXU5.IconType).Forbidden
            };
        case (0, $5TXU5.SmartLinkStatus).NotFound:
            return {
                icon: (0, $5TXU5.IconType).Error
            };
        case (0, $5TXU5.SmartLinkStatus).Errored:
        case (0, $5TXU5.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $5TXU5.IconType).Default
            };
    }
};
const $48fd38a3919fb96d$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntityIcon)(response);
    return $48fd38a3919fb96d$export$43612bed147eae48(response, renderers);
};

});
parcelRegister("2CpuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecff103eb394f1ce$export$2e2bcd8739ae039);
const $ecff103eb394f1ce$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $ecff103eb394f1ce$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $ecff103eb394f1ce$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $ecff103eb394f1ce$export$2e2bcd8739ae039 = $ecff103eb394f1ce$var$extractIconRenderer;

});

parcelRegister("kn2iQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $db64d56f9a1152ff$export$2e2bcd8739ae039);

var $hUifo = parcelRequire("hUifo");

var $5TXU5 = parcelRequire("5TXU5");

var $7hXqf = parcelRequire("7hXqf");

var $uAXxz = parcelRequire("uAXxz");

var $8sXiv = parcelRequire("8sXiv");

var $15w8R = parcelRequire("15w8R");

var $2OB54 = parcelRequire("2OB54");

var $f6wMd = parcelRequire("f6wMd");

var $8fQ4N = parcelRequire("8fQ4N");

var $kX2ZH = parcelRequire("kX2ZH");

var $dVnIN = parcelRequire("dVnIN");
const $db64d56f9a1152ff$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $8sXiv.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $db64d56f9a1152ff$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $uAXxz.extractorPriorityMap)[b] - (0, $uAXxz.extractorPriorityMap)[a])[0] : type;
};
const $db64d56f9a1152ff$var$isJiraProvider = (provider)=>provider === (0, $15w8R.JIRA_GENERATOR_ID);
function $db64d56f9a1152ff$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $f6wMd.default)(fileFormat);
    const documentTypeIcon = $db64d56f9a1152ff$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $2OB54.default)(type, label, providerId);
    return (0, $7hXqf.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $db64d56f9a1152ff$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $5TXU5.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $5TXU5.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $5TXU5.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $5TXU5.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $5TXU5.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $5TXU5.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $5TXU5.IconType).Task,
                label: taskLabel
            };
            if ($db64d56f9a1152ff$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $db64d56f9a1152ff$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $8fQ4N.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $db64d56f9a1152ff$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $hUifo.extractTitle)(data);
    const type = $db64d56f9a1152ff$var$extractType(data);
    const urlIcon = (0, $dVnIN.default)(data.icon, label);
    const providerIcon = (0, $kX2ZH.default)(data);
    return $db64d56f9a1152ff$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $db64d56f9a1152ff$export$2e2bcd8739ae039 = $db64d56f9a1152ff$var$extractJsonldDataIcon;

});
parcelRegister("7hXqf", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $776748d0c66c7fba$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $776748d0c66c7fba$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("uAXxz", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $2e2993a3a04453b8$export$e0deaeb4a2dfe2b4);
const $2e2993a3a04453b8$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("8sXiv", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $50b1c4035dc2416d$export$ed3fd59180514d27);

var $8hlRK = parcelRequire("8hlRK");
const $50b1c4035dc2416d$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("2OB54", function(module, exports) {

$parcel$export(module.exports, "default", () => $43d4ba8ed352f0e6$export$2e2bcd8739ae039);

var $ccQw1 = parcelRequire("ccQw1");

var $5TXU5 = parcelRequire("5TXU5");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $43d4ba8ed352f0e6$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $5TXU5.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $ccQw1.isConfluenceGenerator)(providerId)) return {
                icon: (0, $5TXU5.IconType).LiveDocument,
                label: label || 'Live Document'
            };
            else return {
                icon: (0, $5TXU5.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $5TXU5.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $5TXU5.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $5TXU5.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $5TXU5.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $5TXU5.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $43d4ba8ed352f0e6$export$2e2bcd8739ae039 = $43d4ba8ed352f0e6$var$extractDocumentTypeIcon;

});

parcelRegister("8fQ4N", function(module, exports) {

$parcel$export(module.exports, "default", () => $3057ac52417f53cb$export$2e2bcd8739ae039);

var $5TXU5 = parcelRequire("5TXU5");
const $3057ac52417f53cb$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $5TXU5.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $5TXU5.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $5TXU5.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $5TXU5.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $5TXU5.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $5TXU5.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $5TXU5.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $5TXU5.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $5TXU5.IconType).Task,
                label: label
            };
    }
};
var $3057ac52417f53cb$export$2e2bcd8739ae039 = $3057ac52417f53cb$var$extractJiraTaskIcon;

});

parcelRegister("kX2ZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $65f5e55fe221e038$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extractSmartLinkProviderIcon", () => $65f5e55fe221e038$export$5def189f04eea025);

var $lyclm = parcelRequire("lyclm");
var $hUifo = parcelRequire("hUifo");

var $5TXU5 = parcelRequire("5TXU5");

var $15w8R = parcelRequire("15w8R");

var $dVnIN = parcelRequire("dVnIN");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $65f5e55fe221e038$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $hUifo.extractTitle)(data);
    if (provider === (0, $15w8R.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $5TXU5.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $15w8R.JIRA_GENERATOR_ID)) return {
        icon: (0, $5TXU5.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $dVnIN.default)(icon, label);
};
var $65f5e55fe221e038$export$2e2bcd8739ae039 = $65f5e55fe221e038$var$extractProviderIcon;
const $65f5e55fe221e038$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const provider = (0, $lyclm.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $15w8R.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $5TXU5.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $15w8R.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $5TXU5.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $lyclm.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $65f5e55fe221e038$var$extractProviderIcon(response.data);
};

});
parcelRegister("dVnIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af37185996e64e9$export$2e2bcd8739ae039);

var $8hlRK = parcelRequire("8hlRK");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $1af37185996e64e9$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $8hlRK.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $1af37185996e64e9$export$2e2bcd8739ae039 = $1af37185996e64e9$var$extractUrlIcon;

});




parcelRegister("dOvUN", function(module, exports) {

$parcel$export(module.exports, "extractInvokeViewAction", () => $7b2d7b35c23c90ae$export$88c5813cfbbe4e4c);

var $l6lJr = parcelRequire("l6lJr");

var $hcMBV = parcelRequire("hcMBV");

var $226XV = parcelRequire("226XV");

var $ivUmx = parcelRequire("ivUmx");

var $2LWAa = parcelRequire("2LWAa");

var $fcTJU = parcelRequire("fcTJU");
const $7b2d7b35c23c90ae$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response }, force)=>{
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $l6lJr.extractLink)(data);
    const viewActionExists = (0, $fcTJU.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>(0, $ivUmx.openUrl)(url),
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $226XV.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $226XV.getExtensionKey)(response),
        id: id,
        resourceType: (0, $226XV.getResourceType)(response)
    };
};

});



parcelRegister("cN6vm", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $2508fbc57d702d88$export$debae7424a0231b9);

var $99WQy = parcelRequire("99WQy");
const $2508fbc57d702d88$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $99WQy.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("5ftEU", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $bb6eac6463daf31f$export$216e4f6aa7c169b8);

var $96Gxc = parcelRequire("96Gxc");
var $kzSaQ = parcelRequire("kzSaQ");
const $bb6eac6463daf31f$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $96Gxc.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $kzSaQ.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("96Gxc", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $335da40493fc9d85$export$6281d080d62a0719);

var $kzSaQ = parcelRequire("kzSaQ");
const $335da40493fc9d85$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $kzSaQ.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $kzSaQ.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("6f2GC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9f3dbb8591ea96a$export$2e2bcd8739ae039);

var $79vw2 = parcelRequire("79vw2");

var $5TXU5 = parcelRequire("5TXU5");
const $d9f3dbb8591ea96a$var$extractLinkTitle = (status, propUrl, response, onClick)=>{
    const responseUrl = (0, $79vw2.extractSmartLinkUrl)(response);
    const url = status === (0, $5TXU5.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $79vw2.extractSmartLinkTitle)(response);
    const text = status === (0, $5TXU5.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        text: text,
        url: url
    };
};
var $d9f3dbb8591ea96a$export$2e2bcd8739ae039 = $d9f3dbb8591ea96a$var$extractLinkTitle;

});

parcelRegister("5kcPY", function(module, exports) {

$parcel$export(module.exports, "default", () => $74fe51f061491681$export$2e2bcd8739ae039);

var $8hlRK = parcelRequire("8hlRK");

var $5TXU5 = parcelRequire("5TXU5");
const $74fe51f061491681$var$priorityMapper = {
    blocker: (0, $5TXU5.IconType).PriorityBlocker,
    critical: (0, $5TXU5.IconType).PriorityCritical,
    high: (0, $5TXU5.IconType).PriorityHigh,
    highest: (0, $5TXU5.IconType).PriorityHighest,
    low: (0, $5TXU5.IconType).PriorityLow,
    lowest: (0, $5TXU5.IconType).PriorityLowest,
    major: (0, $5TXU5.IconType).PriorityMajor,
    medium: (0, $5TXU5.IconType).PriorityMedium,
    minor: (0, $5TXU5.IconType).PriorityMinor,
    trivial: (0, $5TXU5.IconType).PriorityTrivial,
    undefined: (0, $5TXU5.IconType).PriorityUndefined
};
const $74fe51f061491681$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $74fe51f061491681$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $74fe51f061491681$export$2e2bcd8739ae039 = $74fe51f061491681$var$extractPriority;

});

parcelRegister("1mkpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4bf3e45dcc07f8b$export$2e2bcd8739ae039);

var $l6lJr = parcelRequire("l6lJr");

var $226XV = parcelRequire("226XV");

var $2LWAa = parcelRequire("2LWAa");

var $hcMBV = parcelRequire("hcMBV");

var $4gOU2 = parcelRequire("4gOU2");

var $dKrmg = parcelRequire("dKrmg");

var $4LRV4 = parcelRequire("4LRV4");
const $a4bf3e45dcc07f8b$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $a4bf3e45dcc07f8b$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve)=>{
    const extensionKey = (0, $226XV.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $4LRV4.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $a4bf3e45dcc07f8b$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $l6lJr.extractLink)(data);
    const invokePreviewAction = response ? (0, $4gOU2.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve(url, true) : undefined,
        origin: origin,
        response: response
    }) : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $a4bf3e45dcc07f8b$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $a4bf3e45dcc07f8b$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $dKrmg.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $2LWAa.canShowAction)((0, $hcMBV.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $a4bf3e45dcc07f8b$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve);
    return {
        ...lozenge,
        action: action
    };
};
var $a4bf3e45dcc07f8b$export$2e2bcd8739ae039 = $a4bf3e45dcc07f8b$var$extractState;

});
parcelRegister("dKrmg", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $35ed8229f3b3cbd6$export$e5da155556a77bca);

var $aliCf = parcelRequire("aliCf");

var $jJuER = parcelRequire("jJuER");

var $eT7Ev = parcelRequire("eT7Ev");

var $i3QgA = parcelRequire("i3QgA");

var $8sXiv = parcelRequire("8sXiv");
const $35ed8229f3b3cbd6$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $aliCf.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $eT7Ev.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $i3QgA.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $35ed8229f3b3cbd6$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $jJuER.extractState)(jsonLd);
    }
};
const $35ed8229f3b3cbd6$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $8sXiv.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("jJuER", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $2218d42ba61dc0c3$export$5e4074cbce6574c7);

var $9uon3 = parcelRequire("9uon3");
// Maps accent color short names to their corresponding background and text colors
const $2218d42ba61dc0c3$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $2218d42ba61dc0c3$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $9uon3.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $9uon3.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $2218d42ba61dc0c3$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("9uon3", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $62de36893d312d67$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $62de36893d312d67$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $62de36893d312d67$export$772610da74ddbc07);
const $62de36893d312d67$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $62de36893d312d67$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $62de36893d312d67$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $62de36893d312d67$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $62de36893d312d67$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("eT7Ev", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $107358540664e913$export$962a8da34cf78a4f);

var $9uon3 = parcelRequire("9uon3");
const $107358540664e913$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($107358540664e913$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $107358540664e913$var$extractTagItem(tag);
    }
};
const $107358540664e913$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $9uon3.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("i3QgA", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $361da8e075cf72f7$export$7698df1946deda72);
const $361da8e075cf72f7$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("dUZ8o", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $6850aa7564532ebc$export$f222392162cff0d8);
const $6850aa7564532ebc$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});




parcelRegister("kVnOi", function(module, exports) {

$parcel$export(module.exports, "className", () => $3da5dd2acb364266$export$2913c0c0b5623090);
$parcel$export(module.exports, "embedHeaderHeight", () => $3da5dd2acb364266$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "LinkWrapperOldVisualRefresh", () => $3da5dd2acb364266$export$2a480844028e4ec0);
$parcel$export(module.exports, "WrapperOldVisualRefresh", () => $3da5dd2acb364266$export$3261c38179e5e529);
$parcel$export(module.exports, "HeaderOldVisualRefresh", () => $3da5dd2acb364266$export$b23fd71055f45d1c);
$parcel$export(module.exports, "IconWrapperOldVisualRefresh", () => $3da5dd2acb364266$export$abdbe8c4b7f7dbc0);
$parcel$export(module.exports, "TextWrapperOldVisualRefresh", () => $3da5dd2acb364266$export$6c22c892e48a7e6d);
$parcel$export(module.exports, "TooltipWrapperOldVisualRefresh", () => $3da5dd2acb364266$export$63387b6a2966b8a1);
$parcel$export(module.exports, "ContentOldVisualRefresh", () => $3da5dd2acb364266$export$ddc04b8b166e58de);
$parcel$export(module.exports, "Image", () => $3da5dd2acb364266$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");
const $3da5dd2acb364266$export$2913c0c0b5623090 = 'media-card-frame';
const $3da5dd2acb364266$export$8f5a73ba0d077b01 = 32;
const $3da5dd2acb364266$export$2a480844028e4ec0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, frameStyle: frameStyle, minWidth: minWidth, maxWidth: maxWidth, isInteractive: isInteractive, inheritDimensions: inheritDimensions, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10q0298": (0, $iAWao.default)(__cmplp.minWidth, "px"),
            "--_1et2rhb": (0, $iAWao.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34",
            __cmplp.minWidth && "_1ul91pd6",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rzgxb",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf",
            __cmplp.isInteractive && "_1di6fg4m",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf",
            __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz",
            __cmplp.frameStyle === 'show' && "_631ousvi",
            __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw",
            __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43zgxb" : "_eq431kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1hfkhp5a" : "_1hfk1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3u92p9" : "_8x3u1kw7",
            __cmplp.className
        ])
    });
});
const $3da5dd2acb364266$export$3261c38179e5e529 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, frameStyle: frameStyle, minWidth: minWidth, maxWidth: maxWidth, isInteractive: isInteractive, inheritDimensions: inheritDimensions, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10q0298": (0, $iAWao.default)(__cmplp.minWidth, "px"),
            "--_1et2rhb": (0, $iAWao.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _v5641y8x _1e0c116y _2lx21bp4 _vchhusvi _ect41gqc _1bsb1osq _uiztglyw _vwz44jg8 _kqswh2mm _19pk19bv _qc5o94zs _14mjpd34 _aetrb3bt _18postnw _1qdg1rgy",
            __cmplp.isSelected && __cmplp.frameStyle === 'hide' ? "_2rkoiti9" : "_2rkopd34",
            __cmplp.minWidth && "_1ul91pd6",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_1u3rzgxb",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' && "_4tpuhp5a",
            __cmplp.isInteractive && __cmplp.frameStyle !== 'hide' ? "_x148kb7n" : "_x148idpf",
            __cmplp.isInteractive && "_1di6fg4m",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_1ifikb7n" : "_1ifiidpf",
            __cmplp.inheritDimensions ? "_4t3i1osq" : "_4t3ik5xz",
            __cmplp.frameStyle === 'show' && "_631ousvi",
            __cmplp.frameStyle === 'show' ? "_z0ai1osq" : "_z0aie9lw",
            __cmplp.frameStyle !== 'show' ? "_19dox0bf" : __cmplp.isSelected ? "_19doidpf" : "_19do1kw7",
            __cmplp.frameStyle === 'show' || __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_eq43zgxb" : "_eq431kw7",
            __cmplp.frameStyle === 'show' ? "_1hfkhp5a" : "_1hfk1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_6syztlke" : "_6syz1kw7",
            __cmplp.isSelected && __cmplp.frameStyle !== 'hide' ? "_8x3u92p9" : "_8x3u1kw7",
            __cmplp.className
        ])
    });
}); // TODO Delete when cleaning platform-linking-visual-refresh-v1
const $3da5dd2acb364266$export$b23fd71055f45d1c = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { frameStyle: frameStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_v564ojwh _4t3izwfg _kqswstnw _1pbykb7n _1bsb1osq _1e0c1txw _4cvr1h6o _syazwdcn _tzy4idpf",
            __cmplp.frameStyle === 'show' && "_vchhusvi",
            __cmplp.frameStyle === 'show' && "_1yt4h8dc",
            __cmplp.className
        ])
    });
}); // TODO Delete when cleaning platform-linking-visual-refresh-v1
const $3da5dd2acb364266$export$abdbe8c4b7f7dbc0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPlaceholder: isPlaceholder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1sit _1bsb7vkz _4t3i7vkz _2hwx1b66",
            __cmplp.isPlaceholder && "_bfhkn82g",
            __cmplp.className
        ])
    });
}); // TODO Delete when cleaning platform-linking-visual-refresh-v1
const $3da5dd2acb364266$export$6c22c892e48a7e6d = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPlaceholder: isPlaceholder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8dcr7 _1reo15vq _18m915vq _syaz131l _1bto1l2s _o5721q9c",
            __cmplp.isPlaceholder && "_2rko1sit",
            __cmplp.isPlaceholder && "_1bsb176v",
            __cmplp.isPlaceholder && "_4t3i1crf",
            __cmplp.isPlaceholder && "_bfhkn82g",
            __cmplp.className
        ])
    });
}); // TODO Delete when cleaning platform-linking-visual-refresh-v1
const $3da5dd2acb364266$export$63387b6a2966b8a1 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // TODO Delete when cleaning platform-linking-visual-refresh-v1
const $3da5dd2acb364266$export$ddc04b8b166e58de = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { removeOverflow: removeOverflow, allowScrollBar: allowScrollBar, frameStyle: frameStyle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rkoiti9 _19itzgxb _v56414ba _bfhkhp5a _kqswstnw _1pbykb7n _hlq8idpf _rd9b1wug _1g4jidpf _jk3p1wug",
            !__cmplp.removeOverflow && (__cmplp.allowScrollBar ? "_1reo1wug _18m91wug" : "_1reo15vq _18m915vq"),
            __cmplp.frameStyle === 'show' ? "_1bsbwgg2" : "_1bsb1osq",
            __cmplp.frameStyle === 'show' && "_18s81xf9",
            __cmplp.frameStyle === 'hide' ? "_4t3i1osq" : "_4t3i1j2a",
            __cmplp.frameStyle !== 'hide' && "_154ixy5q",
            __cmplp.className
        ])
    });
});
const $3da5dd2acb364266$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
const $3da5dd2acb364266$export$3e431a229df88919 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $iAWao.default)($3da5dd2acb364266$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1sit _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
const $3da5dd2acb364266$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $iAWao.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1sit _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkn82g _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iWvOt", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $f9f9ad585f1b3a08$export$b32b5f1ee4493319);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $f9f9ad585f1b3a08$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, ...props })=>{
    // eslint-disable-next-line jsx-a11y/iframe-has-title,@atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $7UHDa.jsx)("iframe", {
        className: className,
        ...props,
        ref: childRef
    });
};

});


//# sourceMappingURL=modal.570245be.js.map
